import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, toDisplayString, ref, reactive, toRefs, normalizeStyle, createTextVNode, createCommentVNode, createElementVNode, resolveComponent, renderSlot, createVNode, onMounted, onBeforeUnmount, watch, withModifiers, withDirectives, Fragment, renderList, createBlock, withCtx, vShow, pushScopeId, popScopeId, nextTick, vModelSelect, vModelText, resolveDirective, Transition, vModelDynamic, withKeys, createStaticVNode, resolveDynamicComponent, onUnmounted } from "vue";
var EntryStatus = /* @__PURE__ */ ((EntryStatus2) => {
  EntryStatus2["loading"] = "loading";
  EntryStatus2["loaded"] = "loaded";
  EntryStatus2["error"] = "error";
  EntryStatus2["reload"] = "reload";
  EntryStatus2["draft"] = "draft";
  EntryStatus2["editing"] = "editing";
  return EntryStatus2;
})(EntryStatus || {});
var FormInputType = /* @__PURE__ */ ((FormInputType2) => {
  FormInputType2["String"] = "string";
  FormInputType2["Number"] = "number";
  FormInputType2["Object"] = "object";
  FormInputType2["Boolean"] = "boolean";
  FormInputType2["Toggle"] = "toggle";
  FormInputType2["Array"] = "array";
  FormInputType2["Multi-select"] = "multi-select";
  FormInputType2["Select"] = "select";
  FormInputType2["Tag"] = "tag";
  FormInputType2["Link-list"] = "link-list";
  FormInputType2["Link"] = "link";
  FormInputType2["Placeholder"] = "placeholder";
  FormInputType2["Nullable"] = "NULL";
  return FormInputType2;
})(FormInputType || {});
const FormInputTypeKeys = Object.fromEntries(Object.keys(FormInputType).map((t2) => [t2, t2.toLowerCase()]));
var Size = /* @__PURE__ */ ((Size2) => {
  Size2["sm"] = "small";
  Size2["small"] = "small";
  Size2["md"] = "medium";
  Size2["medium"] = "medium";
  Size2["xl"] = "large";
  Size2["large"] = "large";
  return Size2;
})(Size || {});
var Shape = /* @__PURE__ */ ((Shape2) => {
  Shape2["circle"] = "circle";
  Shape2["rectangle"] = "rectangle";
  return Shape2;
})(Shape || {});
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$l = defineComponent({
  name: "Avatar",
  props: {
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    user: {
      type: Object,
      required: true
    },
    imgUrl: {
      type: String
    },
    size: {
      type: String,
      default: Size.sm
    },
    shape: {
      type: String,
      default: Shape.rectangle
    },
    bordered: {
      type: Boolean,
      default: true
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const additionalClasses = computed(() => {
      return {
        [`ozn-avatar--${props.size}`]: props.size !== void 0,
        [`ozn-avatar--${props.shape}`]: props.shape !== void 0,
        ["ozn-avatar--bordered"]: props.bordered
      };
    });
    const name2 = computed(() => {
      var _a, _b, _c;
      if (props.user.fullName) {
        return (_a = props.user) == null ? void 0 : _a.fullName;
      } else {
        return `${((_b = props.user) == null ? void 0 : _b.firstName) || ""} ${((_c = props.user) == null ? void 0 : _c.lastName) || ""}`.trim();
      }
    });
    const abbreviation = computed(() => {
      var _a, _b, _c, _d;
      if ((_a = props.user) == null ? void 0 : _a.fullName) {
        return (_b = props.user) == null ? void 0 : _b.fullName.split(" ").map((n) => n.substr(0, 1)).join("").substr(0, 3);
      } else {
        return ((_c = props.user) == null ? void 0 : _c.firstName) ? (_d = props.user) == null ? void 0 : _d.firstName.substr(0, 1) : "";
      }
    });
    function onClick() {
      emit("click");
    }
    return {
      additionalClasses,
      Size,
      Shape,
      name: name2,
      abbreviation,
      onClick
    };
  }
});
const _hoisted_1$n = ["src"];
const _hoisted_2$l = ["data-tooltip"];
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: "ozn-avatar",
    class: normalizeClass(["ozn-avatar", _ctx.additionalClasses]),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    _ctx.imgUrl ? (openBlock(), createElementBlock("img", {
      key: 0,
      class: "ozn-avatar__avatar",
      src: _ctx.imgUrl,
      alt: "user-avatar"
    }, null, 8, _hoisted_1$n)) : (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass(`ozn-avatar__avatar ${_ctx.name ? "has-tooltip" : ""}`),
      "data-tooltip": _ctx.name
    }, toDisplayString(_ctx.abbreviation), 11, _hoisted_2$l))
  ], 2);
}
var Avatar = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$i]]);
Avatar.install = (Vue) => {
  Vue.component(Avatar.name, Avatar);
};
const _sfc_main$k = {
  name: "Column",
  props: {
    span: {
      type: Number,
      default: 24
    },
    tag: {
      type: String,
      default: "div"
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  },
  computed: {
    gutter() {
      let parent = this.$parent;
      while (parent && parent.$options.componentName !== "Row") {
        parent = parent.$parent;
      }
      return parent ? parent.gutter : 0;
    }
  },
  render(h3) {
    const classList = [];
    const style = {};
    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + "px";
      style.paddingRight = style.paddingLeft;
    }
    ["span", "offset", "pull", "push"].forEach((prop) => {
      if (this[prop] || this[prop] === 0) {
        classList.push(
          prop !== "span" ? `col-${prop}-${this[prop]}` : `col-${this[prop]}`
        );
      }
    });
    ["xs", "sm", "md", "lg", "xl"].forEach((size) => {
      if (typeof this[size] === "number") {
        classList.push(`col-${size}-${this[size]}`);
      } else if (typeof this[size] === "object") {
        const props = this[size];
        Object.keys(props).forEach((prop) => {
          classList.push(
            prop !== "span" ? `col-${size}-${prop}-${props[prop]}` : `col-${size}-${props[prop]}`
          );
        });
      }
    });
    return h3(this.tag, {
      class: ["col", classList],
      style
    }, this.$slots.default);
  }
};
_sfc_main$k.install = (Vue) => {
  Vue.component(_sfc_main$k.name, _sfc_main$k);
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var lodash = { exports: {} };
/**
* @license
* Lodash <https://lodash.com/>
* Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
* Released under MIT license <https://lodash.com/license>
* Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
* Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
*/
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length = values.length, offset = array.length;
      while (++index2 < length) {
        array[offset + index2] = values[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length = array.length;
      while (++index2 < length) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length = array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2(
        "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e2) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed2 = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed2;
              } else if (!computed2) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index2 = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index2 < length) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source2) {
        return object && copyObject(source2, keys(source2), object);
      }
      function baseAssignIn(object, source2) {
        return object && copyObject(source2, keysIn(source2), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index2 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$1 : get(object, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer2(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source2) {
        var props = keys(source2);
        return function(object) {
          return baseConformsTo(object, source2, props);
        };
      }
      function baseConformsTo(object, source2, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source2[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index2 = -1, includes3 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes3 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes3 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed2 = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed2) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes3(values2, computed2, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length = array.length;
        while (++index2 < length) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed2 === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed2))) {
            var computed2 = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger2(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger2(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction2(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length = path.length;
        while (object != null && index2 < length) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes3 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed2) : includes3(result2, computed2, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed2) : includes3(arrays[othIndex], computed2, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed2);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source2, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source2, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source2) {
        var matchData = getMatchData(source2);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source2 || baseIsMatch(object, source2, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source2, srcIndex, customizer, stack) {
        if (object === source2) {
          return;
        }
        baseFor(source2, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source2, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source2, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source2, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source2, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source2, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length = paths.length, result2 = {};
        while (++index2 < length) {
          var path = paths[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values2[index2], computed2 = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed2, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex(index2)) {
              splice.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string, n) {
        var result2 = "";
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n % 2) {
            result2 += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index2 < length) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index2 = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed2 = array[mid];
            if (computed2 !== null && !isSymbol(computed2) && (retHighest ? computed2 <= value : computed2 < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed2 = iteratee2(array[mid]), othIsDefined = computed2 !== undefined$1, othIsNull = computed2 === null, othIsReflexive = computed2 === computed2, othIsSymbol = isSymbol(computed2);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed2 <= value : computed2 < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed2, seen)) {
            var seen = computed2;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes3 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes3 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes3 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed2) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed2);
              }
              result2.push(value);
            } else if (!includes3(seen, computed2, comparator)) {
              if (seen !== result2) {
                seen.push(computed2);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString3(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source2, array) {
        var index2 = -1, length = source2.length;
        array || (array = Array2(length));
        while (++index2 < length) {
          array[index2] = source2[index2];
        }
        return array;
      }
      function copyObject(source2, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length = props.length;
        while (++index2 < length) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source2[key], key, object, source2) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source2[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source2, object) {
        return copyObject(source2, getSymbols(source2), object);
      }
      function copySymbolsIn(source2, object) {
        return copyObject(source2, getSymbolsIn(source2), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index2 < length) {
            var source2 = sources[index2];
            if (source2) {
              assigner(object, source2, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString3(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger2(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString3(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString3(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function(values2) {
        return new Set(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger2(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger2(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source2, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data = array[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map2, key) {
        var data = map2.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length = result2.length;
        while (length--) {
          var key = result2[length], value = object[key];
          result2[length] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e2) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data = transforms[index2], size2 = data.size;
          switch (data.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source2) {
        var match2 = source2.match(reWrapDetails);
        return match2 ? match2[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length = path.length, result2 = false;
        while (++index2 < length) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray2(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source2, details) {
        var length = details.length;
        if (!length) {
          return source2;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source2.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction2 : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data, source2) {
        var bitmask = data[1], srcBitmask = source2[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source2[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source2[7].length <= source2[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source2[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source2[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source2[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source2[4];
        }
        value = source2[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source2[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source2[6];
        }
        value = source2[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source2[8] : nativeMin(data[8], source2[8]);
        }
        if (data[9] == null) {
          data[9] = source2[9];
        }
        data[0] = source2[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform2) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index2 < length) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index2 = indexes[length];
          array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source2 = reference + "";
        return setToString(wrapper, insertWrapDetails(source2, updateWrapDetails(getWrapDetails(source2), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match2, number, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e2) {
          }
          try {
            return func + "";
          } catch (e2) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger2(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
        while (index2 < length) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact(array) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger2(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger2(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex2(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger2(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger2(start);
          end = end === undefined$1 ? length : toInteger2(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger2(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger2(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone2 = wrapperClone(parent2);
          clone2.__index__ = 0;
          clone2.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone2;
          } else {
            result2 = clone2;
          }
          var previous = clone2;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex2);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach3(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes2(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger2(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger2(n);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger2(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger2(n);
        return function() {
          if (--n > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind3 = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind3));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce2(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger2(start);
        return baseRest(func, start);
      }
      function spread3(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger2(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce2(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source2) {
        return source2 == null || baseConformsTo(object, source2, keys(source2));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer2 = nativeIsBuffer || stubFalse;
      var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty2(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger2(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source2) {
        return object === source2 || baseIsMatch(object, source2, getMatchData(source2));
      }
      function isMatchWith(object, source2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source2, getMatchData(source2), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject2(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger2(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger2(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger2(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString3(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign = createAssigner(function(object, source2) {
        if (isPrototype(source2) || isArrayLike(source2)) {
          copyObject(source2, keys(source2), object);
          return;
        }
        for (var key in source2) {
          if (hasOwnProperty.call(source2, key)) {
            assignValue(object, key, source2[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source2) {
        copyObject(source2, keysIn(source2), object);
      });
      var assignInWith = createAssigner(function(object, source2, srcIndex, customizer) {
        copyObject(source2, keysIn(source2), object, customizer);
      });
      var assignWith = createAssigner(function(object, source2, srcIndex, customizer) {
        copyObject(source2, keys(source2), object, customizer);
      });
      var at = flatRest(baseAt);
      function create2(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source2 = sources[index2];
          var props = keysIn(source2);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source2[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep2 = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey2(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge2 = createAssigner(function(object, source2, srcIndex) {
        baseMerge(object, source2, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source2, srcIndex, customizer) {
        baseMerge(object, source2, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index2 < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index2])];
          if (value === undefined$1) {
            index2 = length;
            value = defaultValue;
          }
          object = isFunction2(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer2(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString3(string).toLowerCase());
      }
      function deburr(string) {
        string = toString3(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString3(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger2(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString3(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString3(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString3(string);
        length = toInteger2(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString3(string);
        length = toInteger2(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString3(string);
        length = toInteger2(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString3(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger2(n);
        }
        return baseRepeat(toString3(string), n);
      }
      function replace() {
        var args = arguments, string = toString3(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString3(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString3(string);
        position = position == null ? 0 : baseClamp(toInteger2(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString3(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source2 = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source2 += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source2 += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source2 += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source2 += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match2.length;
          return match2;
        });
        source2 += "';\n";
        var variable = hasOwnProperty.call(options, "variable") && options.variable;
        if (!variable) {
          source2 = "with (obj) {\n" + source2 + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source2 = (isEvaluating ? source2.replace(reEmptyStringLeading, "") : source2).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source2 = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source2 + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source2).apply(undefined$1, importsValues);
        });
        result2.source = source2;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString3(value).toLowerCase();
      }
      function toUpper(value) {
        return toString3(value).toUpperCase();
      }
      function trim2(string, chars, guard) {
        string = toString3(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString3(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString3(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger2(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString3(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match2, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match2 = separator.exec(substring)) {
              var newEnd = match2.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape2(string) {
        string = toString3(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString3(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e2) {
          return isError(e2) ? e2 : new Error2(e2);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind3(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source2) {
        return baseConforms(baseClone(source2, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow2 = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source2) {
        return baseMatches(baseClone(source2, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source2, options) {
        var props = keys(source2), methodNames = baseFunctions(source2, props);
        if (options == null && !(isObject2(source2) && (methodNames.length || !props.length))) {
          options = source2;
          source2 = object;
          object = this;
          methodNames = baseFunctions(source2, keys(source2));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
        arrayEach(methodNames, function(methodName) {
          var func = source2[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n) {
        n = toInteger2(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee2) {
        n = toInteger2(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length, iteratee2);
        while (++index2 < n) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString3(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString3(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind3;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create2;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep2;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow2;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread3;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex2;
      lodash2.findKey = findKey2;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach3;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes2;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty2;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger2;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString3;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach3;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source2 = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
            source2[methodName] = func;
          }
        });
        return source2;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger2(n), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger2(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger2(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule) {
      (freeModule.exports = _2)._ = _2;
      freeExports._ = _2;
    } else {
      root._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var _ = lodash.exports;
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$1(uuid2) {
  return typeof uuid2 === "string" && REGEX.test(uuid2);
}
var byteToHex = [];
for (var i2 = 0; i2 < 256; ++i2) {
  byteToHex.push((i2 + 256).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid2 = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate$1(uuid2)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid2;
}
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1(options, buf, offset) {
  var i2 = buf && offset || 0;
  var b2 = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || rng)();
    if (node == null) {
      node = _nodeId = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options.msecs !== void 0 ? options.msecs : Date.now();
  var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b2[i2++] = tl >>> 24 & 255;
  b2[i2++] = tl >>> 16 & 255;
  b2[i2++] = tl >>> 8 & 255;
  b2[i2++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b2[i2++] = tmh >>> 8 & 255;
  b2[i2++] = tmh & 255;
  b2[i2++] = tmh >>> 24 & 15 | 16;
  b2[i2++] = tmh >>> 16 & 255;
  b2[i2++] = clockseq >>> 8 | 128;
  b2[i2++] = clockseq & 255;
  for (var n = 0; n < 6; ++n) {
    b2[i2 + n] = node[n];
  }
  return buf || stringify(b2);
}
function parse(uuid2) {
  if (!validate$1(uuid2)) {
    throw TypeError("Invalid UUID");
  }
  var v;
  var arr = new Uint8Array(16);
  arr[0] = (v = parseInt(uuid2.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 255;
  arr[2] = v >>> 8 & 255;
  arr[3] = v & 255;
  arr[4] = (v = parseInt(uuid2.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 255;
  arr[6] = (v = parseInt(uuid2.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 255;
  arr[8] = (v = parseInt(uuid2.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 255;
  arr[10] = (v = parseInt(uuid2.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v / 4294967296 & 255;
  arr[12] = v >>> 24 & 255;
  arr[13] = v >>> 16 & 255;
  arr[14] = v >>> 8 & 255;
  arr[15] = v & 255;
  return arr;
}
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  var bytes = [];
  for (var i2 = 0; i2 < str.length; ++i2) {
    bytes.push(str.charCodeAt(i2));
  }
  return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(name2, version2, hashfunc) {
  function generateUUID2(value, namespace, buf, offset) {
    if (typeof value === "string") {
      value = stringToBytes(value);
    }
    if (typeof namespace === "string") {
      namespace = parse(namespace);
    }
    if (namespace.length !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version2;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset = offset || 0;
      for (var i2 = 0; i2 < 16; ++i2) {
        buf[offset + i2] = bytes[i2];
      }
      return buf;
    }
    return stringify(bytes);
  }
  try {
    generateUUID2.name = name2;
  } catch (err) {
  }
  generateUUID2.DNS = DNS;
  generateUUID2.URL = URL;
  return generateUUID2;
}
function md5(bytes) {
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = new Uint8Array(msg.length);
    for (var i2 = 0; i2 < msg.length; ++i2) {
      bytes[i2] = msg.charCodeAt(i2);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = "0123456789abcdef";
  for (var i2 = 0; i2 < length32; i2 += 8) {
    var x2 = input[i2 >> 5] >>> i2 % 32 & 255;
    var hex = parseInt(hexTab.charAt(x2 >>> 4 & 15) + hexTab.charAt(x2 & 15), 16);
    output.push(hex);
  }
  return output;
}
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x2, len) {
  x2[len >> 5] |= 128 << len % 32;
  x2[getOutputLength(len) - 1] = len;
  var a3 = 1732584193;
  var b2 = -271733879;
  var c2 = -1732584194;
  var d3 = 271733878;
  for (var i2 = 0; i2 < x2.length; i2 += 16) {
    var olda = a3;
    var oldb = b2;
    var oldc = c2;
    var oldd = d3;
    a3 = md5ff(a3, b2, c2, d3, x2[i2], 7, -680876936);
    d3 = md5ff(d3, a3, b2, c2, x2[i2 + 1], 12, -389564586);
    c2 = md5ff(c2, d3, a3, b2, x2[i2 + 2], 17, 606105819);
    b2 = md5ff(b2, c2, d3, a3, x2[i2 + 3], 22, -1044525330);
    a3 = md5ff(a3, b2, c2, d3, x2[i2 + 4], 7, -176418897);
    d3 = md5ff(d3, a3, b2, c2, x2[i2 + 5], 12, 1200080426);
    c2 = md5ff(c2, d3, a3, b2, x2[i2 + 6], 17, -1473231341);
    b2 = md5ff(b2, c2, d3, a3, x2[i2 + 7], 22, -45705983);
    a3 = md5ff(a3, b2, c2, d3, x2[i2 + 8], 7, 1770035416);
    d3 = md5ff(d3, a3, b2, c2, x2[i2 + 9], 12, -1958414417);
    c2 = md5ff(c2, d3, a3, b2, x2[i2 + 10], 17, -42063);
    b2 = md5ff(b2, c2, d3, a3, x2[i2 + 11], 22, -1990404162);
    a3 = md5ff(a3, b2, c2, d3, x2[i2 + 12], 7, 1804603682);
    d3 = md5ff(d3, a3, b2, c2, x2[i2 + 13], 12, -40341101);
    c2 = md5ff(c2, d3, a3, b2, x2[i2 + 14], 17, -1502002290);
    b2 = md5ff(b2, c2, d3, a3, x2[i2 + 15], 22, 1236535329);
    a3 = md5gg(a3, b2, c2, d3, x2[i2 + 1], 5, -165796510);
    d3 = md5gg(d3, a3, b2, c2, x2[i2 + 6], 9, -1069501632);
    c2 = md5gg(c2, d3, a3, b2, x2[i2 + 11], 14, 643717713);
    b2 = md5gg(b2, c2, d3, a3, x2[i2], 20, -373897302);
    a3 = md5gg(a3, b2, c2, d3, x2[i2 + 5], 5, -701558691);
    d3 = md5gg(d3, a3, b2, c2, x2[i2 + 10], 9, 38016083);
    c2 = md5gg(c2, d3, a3, b2, x2[i2 + 15], 14, -660478335);
    b2 = md5gg(b2, c2, d3, a3, x2[i2 + 4], 20, -405537848);
    a3 = md5gg(a3, b2, c2, d3, x2[i2 + 9], 5, 568446438);
    d3 = md5gg(d3, a3, b2, c2, x2[i2 + 14], 9, -1019803690);
    c2 = md5gg(c2, d3, a3, b2, x2[i2 + 3], 14, -187363961);
    b2 = md5gg(b2, c2, d3, a3, x2[i2 + 8], 20, 1163531501);
    a3 = md5gg(a3, b2, c2, d3, x2[i2 + 13], 5, -1444681467);
    d3 = md5gg(d3, a3, b2, c2, x2[i2 + 2], 9, -51403784);
    c2 = md5gg(c2, d3, a3, b2, x2[i2 + 7], 14, 1735328473);
    b2 = md5gg(b2, c2, d3, a3, x2[i2 + 12], 20, -1926607734);
    a3 = md5hh(a3, b2, c2, d3, x2[i2 + 5], 4, -378558);
    d3 = md5hh(d3, a3, b2, c2, x2[i2 + 8], 11, -2022574463);
    c2 = md5hh(c2, d3, a3, b2, x2[i2 + 11], 16, 1839030562);
    b2 = md5hh(b2, c2, d3, a3, x2[i2 + 14], 23, -35309556);
    a3 = md5hh(a3, b2, c2, d3, x2[i2 + 1], 4, -1530992060);
    d3 = md5hh(d3, a3, b2, c2, x2[i2 + 4], 11, 1272893353);
    c2 = md5hh(c2, d3, a3, b2, x2[i2 + 7], 16, -155497632);
    b2 = md5hh(b2, c2, d3, a3, x2[i2 + 10], 23, -1094730640);
    a3 = md5hh(a3, b2, c2, d3, x2[i2 + 13], 4, 681279174);
    d3 = md5hh(d3, a3, b2, c2, x2[i2], 11, -358537222);
    c2 = md5hh(c2, d3, a3, b2, x2[i2 + 3], 16, -722521979);
    b2 = md5hh(b2, c2, d3, a3, x2[i2 + 6], 23, 76029189);
    a3 = md5hh(a3, b2, c2, d3, x2[i2 + 9], 4, -640364487);
    d3 = md5hh(d3, a3, b2, c2, x2[i2 + 12], 11, -421815835);
    c2 = md5hh(c2, d3, a3, b2, x2[i2 + 15], 16, 530742520);
    b2 = md5hh(b2, c2, d3, a3, x2[i2 + 2], 23, -995338651);
    a3 = md5ii(a3, b2, c2, d3, x2[i2], 6, -198630844);
    d3 = md5ii(d3, a3, b2, c2, x2[i2 + 7], 10, 1126891415);
    c2 = md5ii(c2, d3, a3, b2, x2[i2 + 14], 15, -1416354905);
    b2 = md5ii(b2, c2, d3, a3, x2[i2 + 5], 21, -57434055);
    a3 = md5ii(a3, b2, c2, d3, x2[i2 + 12], 6, 1700485571);
    d3 = md5ii(d3, a3, b2, c2, x2[i2 + 3], 10, -1894986606);
    c2 = md5ii(c2, d3, a3, b2, x2[i2 + 10], 15, -1051523);
    b2 = md5ii(b2, c2, d3, a3, x2[i2 + 1], 21, -2054922799);
    a3 = md5ii(a3, b2, c2, d3, x2[i2 + 8], 6, 1873313359);
    d3 = md5ii(d3, a3, b2, c2, x2[i2 + 15], 10, -30611744);
    c2 = md5ii(c2, d3, a3, b2, x2[i2 + 6], 15, -1560198380);
    b2 = md5ii(b2, c2, d3, a3, x2[i2 + 13], 21, 1309151649);
    a3 = md5ii(a3, b2, c2, d3, x2[i2 + 4], 6, -145523070);
    d3 = md5ii(d3, a3, b2, c2, x2[i2 + 11], 10, -1120210379);
    c2 = md5ii(c2, d3, a3, b2, x2[i2 + 2], 15, 718787259);
    b2 = md5ii(b2, c2, d3, a3, x2[i2 + 9], 21, -343485551);
    a3 = safeAdd(a3, olda);
    b2 = safeAdd(b2, oldb);
    c2 = safeAdd(c2, oldc);
    d3 = safeAdd(d3, oldd);
  }
  return [a3, b2, c2, d3];
}
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i2 = 0; i2 < length8; i2 += 8) {
    output[i2 >> 5] |= (input[i2 / 8] & 255) << i2 % 32;
  }
  return output;
}
function safeAdd(x2, y3) {
  var lsw = (x2 & 65535) + (y3 & 65535);
  var msw = (x2 >> 16) + (y3 >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
function md5cmn(q2, a3, b2, x2, s3, t2) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a3, q2), safeAdd(x2, t2)), s3), b2);
}
function md5ff(a3, b2, c2, d3, x2, s3, t2) {
  return md5cmn(b2 & c2 | ~b2 & d3, a3, b2, x2, s3, t2);
}
function md5gg(a3, b2, c2, d3, x2, s3, t2) {
  return md5cmn(b2 & d3 | c2 & ~d3, a3, b2, x2, s3, t2);
}
function md5hh(a3, b2, c2, d3, x2, s3, t2) {
  return md5cmn(b2 ^ c2 ^ d3, a3, b2, x2, s3, t2);
}
function md5ii(a3, b2, c2, d3, x2, s3, t2) {
  return md5cmn(c2 ^ (b2 | ~d3), a3, b2, x2, s3, t2);
}
var v3 = v35("v3", 48, md5);
var v3$1 = v3;
function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return stringify(rnds);
}
function f(s3, x2, y3, z2) {
  switch (s3) {
    case 0:
      return x2 & y3 ^ ~x2 & z2;
    case 1:
      return x2 ^ y3 ^ z2;
    case 2:
      return x2 & y3 ^ x2 & z2 ^ y3 & z2;
    case 3:
      return x2 ^ y3 ^ z2;
  }
}
function ROTL(x2, n) {
  return x2 << n | x2 >>> 32 - n;
}
function sha1(bytes) {
  var K2 = [1518500249, 1859775393, 2400959708, 3395469782];
  var H3 = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = [];
    for (var i2 = 0; i2 < msg.length; ++i2) {
      bytes.push(msg.charCodeAt(i2));
    }
  } else if (!Array.isArray(bytes)) {
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(128);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M3 = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M3[_i] = arr;
  }
  M3[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M3[N - 1][14] = Math.floor(M3[N - 1][14]);
  M3[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t2 = 0; t2 < 16; ++t2) {
      W[t2] = M3[_i2][t2];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a3 = H3[0];
    var b2 = H3[1];
    var c2 = H3[2];
    var d3 = H3[3];
    var e2 = H3[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s3 = Math.floor(_t2 / 20);
      var T2 = ROTL(a3, 5) + f(s3, b2, c2, d3) + e2 + K2[s3] + W[_t2] >>> 0;
      e2 = d3;
      d3 = c2;
      c2 = ROTL(b2, 30) >>> 0;
      b2 = a3;
      a3 = T2;
    }
    H3[0] = H3[0] + a3 >>> 0;
    H3[1] = H3[1] + b2 >>> 0;
    H3[2] = H3[2] + c2 >>> 0;
    H3[3] = H3[3] + d3 >>> 0;
    H3[4] = H3[4] + e2 >>> 0;
  }
  return [H3[0] >> 24 & 255, H3[0] >> 16 & 255, H3[0] >> 8 & 255, H3[0] & 255, H3[1] >> 24 & 255, H3[1] >> 16 & 255, H3[1] >> 8 & 255, H3[1] & 255, H3[2] >> 24 & 255, H3[2] >> 16 & 255, H3[2] >> 8 & 255, H3[2] & 255, H3[3] >> 24 & 255, H3[3] >> 16 & 255, H3[3] >> 8 & 255, H3[3] & 255, H3[4] >> 24 & 255, H3[4] >> 16 & 255, H3[4] >> 8 & 255, H3[4] & 255];
}
var v5 = v35("v5", 80, sha1);
var v5$1 = v5;
const uuid = { v1, v3: v3$1, v4, v5: v5$1 };
function generateUUID(v = "v4") {
  return uuid[v]();
}
function isUUID(uuid2) {
  const rx = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
  return rx.test(uuid2);
}
function UUIDValidator(i2) {
  return _.castArray(i2).every(isUUID);
}
const S4 = () => ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
function guid() {
  return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
}
const debounce = (callback, wait) => {
  const next = () => {
    timeout = clearTimeout(timeout);
    callback(...lastArgs);
  };
  let timeout;
  let lastArgs;
  return (...args) => {
    lastArgs = args;
    if (timeout === void 0) {
      timeout = setTimeout(next, wait);
    }
  };
};
const DEFAULT_BREAKPOINTS = { smallMedium: 380, mediumLarge: 960, smallLarge: 1440 };
function calcSizeBreakpoints(value, breakPoints = DEFAULT_BREAKPOINTS, size) {
  const points = breakPoints || DEFAULT_BREAKPOINTS;
  if (Object.keys(points).length && size) {
    const { smallMedium, mediumLarge, smallLarge } = points;
    switch (size) {
      case Size.sm:
      case Size.small:
        return Size.small;
      case Size.md:
      case Size.medium:
        if (smallMedium) {
          return value <= smallMedium ? Size.small : Size.medium;
        }
        break;
      case Size.xl:
      case Size.large:
        if (smallLarge) {
          return value <= smallLarge ? Size.small : Size.large;
        } else {
          if (smallMedium && mediumLarge) {
            if (value <= smallMedium) {
              return Size.small;
            } else if (value > smallMedium && value <= mediumLarge) {
              return Size.medium;
            } else {
              return Size.large;
            }
          }
        }
        break;
    }
  } else {
    console.group("No value, breakpoints and/or size have been provided");
    console.warn("value: Number ", value);
    console.warn("breakPoint: BreakPoints ", breakPoints);
    console.warn("size: Size ", size);
    console.groupEnd();
  }
}
function defaultsDeep(...sources) {
  const output = {};
  _.toArray(sources).reverse().forEach((item) => {
    _.mergeWith(output, item, (objectValue, sourceValue) => {
      return _.isArray(sourceValue) ? sourceValue : void 0;
    });
  });
  return output;
}
const BASE_TYPES = {
  uuid: generateUUID(),
  string: "",
  number: 0,
  float: 0,
  array: [],
  object: {},
  boolean: false,
  link: "",
  "link-list": [],
  select: [],
  tag: [],
  NULL: null
};
function DEFAULT_LINK_CONFIG(type) {
  return {
    actions: {
      edit: true,
      add: true,
      remove: true,
      search: false
    },
    replace: true,
    draft: false,
    fields: {
      sys: "sys",
      data: "",
      title: ""
    },
    labels: {
      add: "Add new",
      search: "Add Existing",
      remove: "Remove"
    },
    debug: {
      sys: false,
      verbose: false
    },
    placeholder: `No ${titleCase(type || "")}s`
  };
}
const DEFAULT_ENTRY_STATE = {
  entry: {},
  model: {},
  diff: {
    state: false,
    payload: {}
  },
  validation: {
    state: true,
    fields: []
  }
};
const DEFAULT_TYPE_INPUT = (model, key, e2) => {
  const spec = model[key];
  const t2 = typeof spec === "object" ? spec.type : spec;
  return BASE_TYPES[t2];
};
function assertType(entry, key) {
  return isReference(entry[key]) ? Array.isArray(entry[key]) ? "link-list" : "link" : entry[key] ? typeof entry[key] : "NULL";
}
function isReference(field) {
  return typeof field === "string" && isUUID(field) || Array.isArray(field) && field.every((f2) => typeof f2 === "object" && !Array.isArray(f2) && f2.sys && isUUID(f2.sys.id)) || Array.isArray(field) && field.every((f2) => typeof f2 === "string" && isUUID(f2)) || !!field && typeof field === "object" && !!field.sys && isUUID(field.sys.id);
}
function validateEntry(entry) {
  return typeof entry === "string" && isUUID(entry) || isEntry(entry);
}
function isEntry(e2) {
  return e2.sys !== void 0;
}
function applyModelDefaults(entry, model) {
  if (typeof entry === "string")
    return entry;
  const src = entry;
  Object.keys(src).forEach((k2) => {
    var _a, _b;
    src[k2] = src[k2] ? src[k2] : ref(((_a = model[k2]) == null ? void 0 : _a.default) || BASE_TYPES[(_b = model[k2]) == null ? void 0 : _b.type]);
  });
  return src;
}
function assertContentType(e2) {
  if (Array.isArray(e2)) {
    if (!e2.length || !e2.filter((f2) => !!f2).length)
      return "";
    const uniform = e2.map((n) => n && typeof n === "object" && n.sys ? n.sys.type : null).every((f2) => !!f2 && e2[0].sys && e2[0].sys.type === f2);
    return uniform ? e2[0].sys.type : "mixed";
  } else {
    return e2 && typeof e2 === "object" && e2.sys ? e2.sys.type : "";
  }
}
function assertField(k2, e2) {
  return {
    field: k2,
    label: k2,
    type: assertType(e2, k2),
    options: [],
    contentType: assertContentType(e2[k2]),
    default: BASE_TYPES[assertType(e2, k2)],
    config: DEFAULT_LINK_CONFIG(assertContentType(e2[k2])),
    validator: () => true,
    required: false
  };
}
function assertModel(m3, e2) {
  if (!m3) {
    if (typeof e2 === "string" && isUUID(e2))
      return {};
    return Object.fromEntries(Object.keys(e2).map((k2) => [
      k2,
      assertField(k2, e2)
    ]));
  }
  const uniqKeys = Object.keys(m3).concat(Object.keys(e2)).filter((f2, i2, a3) => a3.indexOf(f2) === i2);
  return Object.fromEntries(uniqKeys.map((k2) => [
    k2,
    !m3[k2] ? assertField(k2, e2) : {
      field: typeof m3[k2] === "object" ? m3[k2].field || k2 : k2,
      label: typeof m3[k2] === "object" ? m3[k2].label || m3[k2].field || k2 : k2,
      type: typeof m3[k2] === "object" ? m3[k2].type || assertType(e2, k2) : typeof m3[k2] === "object" ? assertType(e2, k2) : m3[k2],
      contentType: typeof m3[k2] === "object" ? m3[k2].contentType : assertContentType(e2[k2]),
      model: typeof m3[k2] === "object" ? m3[k2].model : void 0,
      default: typeof m3[k2] === "object" ? m3[k2].default || DEFAULT_TYPE_INPUT(m3, k2) : DEFAULT_TYPE_INPUT(m3, k2),
      config: typeof m3[k2] === "object" ? m3[k2].config || DEFAULT_LINK_CONFIG(typeof m3[k2] === "object" ? m3[k2].contentType : assertContentType(e2[k2])) : DEFAULT_LINK_CONFIG(typeof m3[k2] === "object" ? m3[k2].contentType : assertContentType(e2[k2])),
      options: typeof m3[k2] === "object" ? m3[k2].options : [],
      validator: () => true,
      readonly: typeof m3[k2] === "object" ? m3[k2].readonly : false,
      required: typeof m3[k2] === "object" ? m3[k2].required : false
    }
  ]));
}
function $get(obj, path, defaultValue = void 0) {
  const travel = (regexp) => String.prototype.split.call(path, regexp).filter(Boolean).reduce((res, key) => res !== null && res !== void 0 ? res[key] : res, obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === void 0 || result === obj ? defaultValue : result;
}
function $castArray(payload) {
  return Array.isArray(payload) ? payload : [payload];
}
function $setTo(payload, addition, path = "", prepend) {
  const items = $castArray(addition).filter((f2) => !!f2);
  items.forEach((item) => {
    const i2 = payload.findIndex((n) => item && $get(n, path) === $get(item, path));
    let parsedItem = item;
    if (i2 >= 0) {
      parsedItem = Object.fromEntries(Object.keys(item).map((key) => {
        if (Array.isArray(payload[i2][key]) && payload[i2][key].every(isEntry) && (Array.isArray(item[key]) && item[key].every(isUUID)) || payload[i2][key] && (isEntry(payload[i2][key]) && isUUID(item[key]))) {
          return [key, payload[i2][key]];
        }
        return [key, item[key]];
      }));
    }
    i2 >= 0 ? payload.splice(i2, 1, parsedItem) : prepend ? payload.unshift(item) : payload.push(item);
  });
  return payload;
}
function Error$1(ctx) {
  return computed({
    get() {
      return ctx._error;
    },
    set(e2) {
      if (typeof e2 === "string") {
        ctx._error = {
          state: true,
          type: "error",
          message: e2,
          raw: e2
        };
        return;
      }
      if (typeof e2 === "boolean") {
        ctx._error = {
          state: e2,
          type: "",
          message: "",
          raw: {}
        };
        return;
      }
      if (typeof e2 === "object" && !Array.isArray(e2)) {
        const { type, message, raw } = e2;
        ctx._error = { state: true, type, message, raw };
      }
    }
  });
}
function grep(obj, regexp, depth, ownOnly, parseValues) {
  if (arguments.length < 2) {
    throw new Error("Grep | Need both an object and a search string/regexp!");
  }
  const rx = typeof regexp === "string" ? regexp = new RegExp(_.escapeRegExp(regexp), "i") : regexp;
  const dp = depth || 0;
  const hits = {};
  const next = [];
  let found = false;
  let keys;
  let name2;
  let what;
  const getFieldValueasString = (field) => typeof field === "object" && !Array.isArray(field) ? "" : (field || "").toString();
  try {
    keys = Object.getOwnPropertyNames(obj);
    if (!ownOnly) {
      for (name2 in obj) {
        if (keys.indexOf(name2) === -1) {
          keys.push(name2);
        }
      }
    }
  } catch (e2) {
    return void 0;
  }
  while ((name2 = keys.shift()) !== void 0) {
    if (rx.test(name2) || parseValues && rx.test(getFieldValueasString(obj[name2]))) {
      hits[name2] = obj[name2];
      found = true;
    } else if (dp && typeof obj[name2] === "object") {
      next.push(name2);
    }
  }
  while ((name2 = next.shift()) !== void 0) {
    if ((what = grep(obj[name2], rx, dp - 1, ownOnly)) !== void 0) {
      hits[name2] = what;
      found = true;
    }
  }
  return found ? hits : void 0;
}
grep.own = function(obj, rx, depth = 1) {
  return grep(obj, rx, depth, true);
};
grep.contents = function(obj, rx, depth = 1) {
  return grep(obj, rx, depth, true, true);
};
var axios$2 = { exports: {} };
var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray(val) {
  return toString.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$1(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      fn.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l = arguments.length; i2 < l; i2++) {
    forEach(arguments[i2], assignValue);
  }
  return result;
}
function extend(a3, b2, thisArg) {
  forEach(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a3[key] = bind$1(val, thisArg);
    } else {
      a3[key] = val;
    }
  });
  return a3;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$d = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$c = utils$d;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$c.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$c.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$c.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$c.forEach(val, function parseValue(v) {
        if (utils$c.isDate(v)) {
          v = v.toISOString();
        } else if (utils$c.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$b = utils$d;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$b.forEach(this.handlers, function forEachHandler(h3) {
    if (h3 !== null) {
      fn(h3);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$a = utils$d;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$a.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError$2 = function enhanceError(error, config2, code, request2, response) {
  error.config = config2;
  if (code) {
    error.code = code;
  }
  error.request = request2;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  };
  return error;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config2, code, request2, response) {
  var error = new Error(message);
  return enhanceError$1(error, config2, code, request2, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1(
      "Request failed with status code " + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};
var utils$9 = utils$d;
var cookies$1 = utils$9.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name2, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$9.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$9.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$9.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name2) {
      var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$8 = utils$d;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$8.forEach(headers.split("\n"), function parser(line) {
    i2 = line.indexOf(":");
    key = utils$8.trim(line.substr(0, i2)).toLowerCase();
    val = utils$8.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$7 = utils$d;
var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
var utils$6 = utils$d;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var xhr = function xhrAdapter(config2) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config2.data;
    var requestHeaders = config2.headers;
    var responseType = config2.responseType;
    if (utils$6.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request2 = new XMLHttpRequest();
    if (config2.auth) {
      var username = config2.auth.username || "";
      var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config2.baseURL, config2.url);
    request2.open(config2.method.toUpperCase(), buildURL$1(fullPath, config2.params, config2.paramsSerializer), true);
    request2.timeout = config2.timeout;
    function onloadend() {
      if (!request2) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config: config2,
        request: request2
      };
      settle2(resolve, reject, response);
      request2 = null;
    }
    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }
        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }
      reject(createError2("Request aborted", config2, "ECONNABORTED", request2));
      request2 = null;
    };
    request2.onerror = function handleError() {
      reject(createError2("Network Error", config2, null, request2));
      request2 = null;
    };
    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = "timeout of " + config2.timeout + "ms exceeded";
      if (config2.timeoutErrorMessage) {
        timeoutErrorMessage = config2.timeoutErrorMessage;
      }
      reject(createError2(
        timeoutErrorMessage,
        config2,
        config2.transitional && config2.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
        request2
      ));
      request2 = null;
    };
    if (utils$6.isStandardBrowserEnv()) {
      var xsrfValue = (config2.withCredentials || isURLSameOrigin(fullPath)) && config2.xsrfCookieName ? cookies.read(config2.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config2.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request2) {
      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$6.isUndefined(config2.withCredentials)) {
      request2.withCredentials = !!config2.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request2.responseType = config2.responseType;
    }
    if (typeof config2.onDownloadProgress === "function") {
      request2.addEventListener("progress", config2.onDownloadProgress);
    }
    if (typeof config2.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config2.onUploadProgress);
    }
    if (config2.cancelToken) {
      config2.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request2) {
          return;
        }
        request2.abort();
        reject(cancel);
        request2 = null;
      });
    }
    if (!requestData) {
      requestData = null;
    }
    request2.send(requestData);
  });
};
var utils$5 = utils$d;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data.toString();
    }
    if (utils$5.isObject(data) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional2 = this.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError2(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults$3.headers = {
  common: {
    "Accept": "application/json, text/plain, */*"
  }
};
utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$4 = utils$d;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$3 = utils$d;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
}
var dispatchRequest$1 = function dispatchRequest(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = config2.headers || {};
  config2.data = transformData2.call(
    config2,
    config2.data,
    config2.headers,
    config2.transformRequest
  );
  config2.headers = utils$3.merge(
    config2.headers.common || {},
    config2.headers[config2.method] || {},
    config2.headers
  );
  utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config2.headers[method];
    }
  );
  var adapter = config2.adapter || defaults$1.adapter;
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData2.call(
      config2,
      response.data,
      response.headers,
      config2.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(
          config2,
          reason.response.data,
          reason.response.headers,
          config2.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$2 = utils$d;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config3 = {};
  var valueFromConfig2Keys = ["url", "method", "data"];
  var mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"];
  var defaultToConfig2Keys = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ];
  var directMergeKeys = ["validateStatus"];
  function getMergedValue(target, source2) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source2)) {
      return utils$2.merge(target, source2);
    } else if (utils$2.isPlainObject(source2)) {
      return utils$2.merge({}, source2);
    } else if (utils$2.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config3[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config3[prop] = getMergedValue(void 0, config1[prop]);
    }
  }
  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config3[prop] = getMergedValue(void 0, config2[prop]);
    }
  });
  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config3[prop] = getMergedValue(void 0, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config3[prop] = getMergedValue(void 0, config1[prop]);
    }
  });
  utils$2.forEach(directMergeKeys, function merge2(prop) {
    if (prop in config2) {
      config3[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config3[prop] = getMergedValue(void 0, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils$2.forEach(otherKeys, mergeDeepProperties);
  return config3;
};
const name = "axios";
const version = "0.21.4";
const description = "Promise based HTTP client for the browser and node.js";
const main = "index.js";
const scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
};
const repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
};
const keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
];
const author = "Matt Zabriskie";
const license = "MIT";
const bugs = {
  url: "https://github.com/axios/axios/issues"
};
const homepage = "https://axios-http.com";
const devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
};
const browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
const jsdelivr = "dist/axios.min.js";
const unpkg = "dist/axios.min.js";
const typings = "./index.d.ts";
const dependencies = {
  "follow-redirects": "^1.14.0"
};
const bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
];
var require$$0 = {
  name,
  version,
  description,
  main,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split(".");
function isOlderVersion(version2, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
  var destVer = version2.split(".");
  for (var i2 = 0; i2 < 3; i2++) {
    if (pkgVersionArr[i2] > destVer[i2]) {
      return true;
    } else if (pkgVersionArr[i2] < destVer[i2]) {
      return false;
    }
  }
  return false;
}
validators$1.transitional = function transitional(validator2, version2, message) {
  var isDeprecated = version2 && isOlderVersion(version2);
  function formatMessage(opt, desc) {
    return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed in " + version2));
    }
    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i2 = keys.length;
  while (i2-- > 0) {
    var opt = keys[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  isOlderVersion,
  assertOptions,
  validators: validators$1
};
var utils$1 = utils$d;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(config2) {
  if (typeof config2 === "string") {
    config2 = arguments[1] || {};
    config2.url = arguments[0];
  } else {
    config2 = config2 || {};
  }
  config2 = mergeConfig$1(this.defaults, config2);
  if (config2.method) {
    config2.method = config2.method.toLowerCase();
  } else if (this.defaults.method) {
    config2.method = this.defaults.method.toLowerCase();
  } else {
    config2.method = "get";
  }
  var transitional2 = config2.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
      forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
      clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config2);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config2;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config2) {
  config2 = mergeConfig$1(this.defaults, config2);
  return buildURL2(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url,
      data: (config2 || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url,
      data
    }));
  };
});
var Axios_1 = Axios$1;
function Cancel$1(message) {
  this.message = message;
}
Cancel$1.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$1.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c2) {
    cancel = c2;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError = function isAxiosError2(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils = utils$d;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig2(axios$1.defaults, instanceConfig));
};
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
class RequestHandler {
  constructor(config2 = {}, props) {
    this.debug = config2.debug || false;
    this.requestConfig = config2.requestConfig || {};
    this.service = config2.service;
    this._validators = {
      default: (...args) => true,
      ...config2.validators || {}
    };
    this.axiosInstance = axios.create(this.requestConfig);
    axios.defaults.headers.common = this.requestConfig.headers;
    if (props == null ? void 0 : props.interceptors) {
      this.axiosInstance.interceptors = props.interceptors;
    }
    this.getInstance = this.getInstance.bind(this);
    this.setAuthHeader = this.setAuthHeader.bind(this);
    this.validate = this.validate.bind(this);
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.patch = this.patch.bind(this);
    this.delete = this.delete.bind(this);
    this.resolve = this.resolve.bind(this);
    this.model = this.model.bind(this);
    this.handlers = (props == null ? void 0 : props.handlers) || { Error: (e2) => Promise.reject(e2), Warn: (e2) => Promise.reject(e2), Fatal: (e2) => Promise.reject(e2), Unauthorized: (e2) => Promise.reject(e2) };
  }
  trace(args, method) {
    console.log((this.service || {}).name, method, args);
  }
  getInstance() {
    return this.axiosInstance;
  }
  setAuthHeader(token) {
    this.axiosInstance.defaults.headers.common.Authorization = token;
  }
  get validators() {
    return this._validators;
  }
  set validators({ id, value }) {
    if (!["string", "boolean", "function"].includes(typeof value)) {
      throw new Error("validator must be a function");
    }
    this._validators[id] = value;
  }
  async validate(contentType, data, validator2) {
    try {
      if (validator2) {
        const v = typeof validator2 === "string" ? this.validators[validator2] : typeof validator2 === "boolean" ? this.validators[contentType] : validator2;
        if (v && !v(data)) {
          return Promise.reject(new Error("Data Validation failed"));
        }
        return true;
      }
      return true;
    } catch (e2) {
      return false;
    }
  }
  parseServiceRequestConfig(config2, method) {
    const methodDefaults = JSON.parse(_.get(axios.defaults, `headers.${method}.x-service-config`, "{}"));
    const defaults2 = _.merge(JSON.parse(_.get(axios.defaults, `headers.common.${method}.x-service-config`, "{}")), methodDefaults);
    return _.merge(defaults2, config2);
  }
  handleError(e2, opts) {
    return this.handlers.Error(e2.response || e2);
  }
  async get(contentType, query, serviceConfig, validator2, config2) {
    try {
      await this.validate(contentType, query, validator2);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "get");
      const result = await this.axiosInstance({
        url: this.service ? `service/${this.service.id}/${contentType}` : contentType,
        method: "get",
        params: query,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "get");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handleError(e2);
    }
  }
  async post(contentType, query, data, serviceConfig, validator2, config2) {
    try {
      await this.validate(contentType, query, validator2);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "post");
      const d3 = isUUID(contentType) || arguments.length === 2 ? query : data;
      const p = isUUID(contentType) || arguments.length === 2 ? void 0 : query;
      const result = await this.axiosInstance({
        url: this.service ? `service/${this.service.id}/${contentType}` : contentType,
        method: "post",
        data: d3,
        params: p,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "post");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handleError(e2);
    }
  }
  async put(contentType, query, data, serviceConfig, validator2, config2) {
    try {
      await this.validate(contentType, data, validator2);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "put");
      const d3 = isUUID(contentType) || arguments.length === 2 ? query : data;
      const p = isUUID(contentType) || arguments.length === 2 ? void 0 : query;
      const result = await this.axiosInstance({
        url: this.service ? `service/${this.service.id}/${contentType}` : contentType,
        method: "put",
        data: d3,
        params: p,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "put");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handleError(e2);
    }
  }
  async patch(contentType, query, data, serviceConfig, validator2, config2) {
    try {
      await this.validate(contentType, data, validator2);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "patch");
      const d3 = isUUID(contentType) || arguments.length === 2 ? query : data;
      const p = isUUID(contentType) ? void 0 : query;
      const result = await this.axiosInstance({
        url: this.service ? `service/${this.service.id}/${contentType}` : contentType,
        method: "patch",
        data: d3,
        params: p,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "patch");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handleError(e2);
    }
  }
  async delete(contentType, query, serviceConfig, validator2, config2) {
    try {
      await this.validate(contentType, query, validator2);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "delete");
      const result = await this.axiosInstance({
        url: this.service ? `service/${this.service.id}/${contentType}` : contentType,
        method: "delete",
        params: query,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "delete");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handleError(e2);
    }
  }
  async resolve(id, contentType, serviceConfig, validator2, config2) {
    try {
      if (!this.service.id) {
        return Promise.reject(new Error("Service needs to be defined on the instance to resolve entries by id"));
      }
      await this.validate(contentType || "uuid", id, UUIDValidator);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "get");
      const params = (serviceConfig == null ? void 0 : serviceConfig.select) ? [{ select: Array.isArray(serviceConfig.select) ? serviceConfig.select : [serviceConfig.select] }, { field: "sys.id", match: id }] : id;
      const result = await this.axiosInstance({
        url: `service/${this.service.id}/${contentType || "id"}`,
        method: "get",
        params,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "resolve");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handleError(e2);
    }
  }
  async model(contentType, query, serviceConfig, validator2, config2) {
    try {
      if (!this.service.id) {
        return Promise.reject(new Error("Service needs to be defined on the instance to retrieve content type models"));
      }
      await this.validate(contentType, query, validator2);
      const c2 = config2 || { headers: {} };
      const sc = this.parseServiceRequestConfig(serviceConfig || {}, "get");
      const result = await this.axiosInstance({
        url: `service/${this.service.id}/models.${contentType}`,
        method: "get",
        params: query,
        ...c2,
        headers: {
          ...c2.headers,
          "x-service-config": JSON.stringify(sc)
        }
      }).then((res) => res.data);
      if (this.debug)
        this.trace(result, "model");
      return Promise.resolve(result);
    } catch (e2) {
      return this.handlers.Error(e2);
    }
  }
}
var he$1 = { exports: {} };
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
(function(module, exports) {
  (function(root) {
    var freeExports = exports;
    var freeModule = module && module.exports == freeExports && module;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
      root = freeGlobal;
    }
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = { "\xAD": "shy", "\u200C": "zwnj", "\u200D": "zwj", "\u200E": "lrm", "\u2063": "ic", "\u2062": "it", "\u2061": "af", "\u200F": "rlm", "\u200B": "ZeroWidthSpace", "\u2060": "NoBreak", "\u0311": "DownBreve", "\u20DB": "tdot", "\u20DC": "DotDot", "	": "Tab", "\n": "NewLine", "\u2008": "puncsp", "\u205F": "MediumSpace", "\u2009": "thinsp", "\u200A": "hairsp", "\u2004": "emsp13", "\u2002": "ensp", "\u2005": "emsp14", "\u2003": "emsp", "\u2007": "numsp", "\xA0": "nbsp", "\u205F\u200A": "ThickSpace", "\u203E": "oline", "_": "lowbar", "\u2010": "dash", "\u2013": "ndash", "\u2014": "mdash", "\u2015": "horbar", ",": "comma", ";": "semi", "\u204F": "bsemi", ":": "colon", "\u2A74": "Colone", "!": "excl", "\xA1": "iexcl", "?": "quest", "\xBF": "iquest", ".": "period", "\u2025": "nldr", "\u2026": "mldr", "\xB7": "middot", "'": "apos", "\u2018": "lsquo", "\u2019": "rsquo", "\u201A": "sbquo", "\u2039": "lsaquo", "\u203A": "rsaquo", '"': "quot", "\u201C": "ldquo", "\u201D": "rdquo", "\u201E": "bdquo", "\xAB": "laquo", "\xBB": "raquo", "(": "lpar", ")": "rpar", "[": "lsqb", "]": "rsqb", "{": "lcub", "}": "rcub", "\u2308": "lceil", "\u2309": "rceil", "\u230A": "lfloor", "\u230B": "rfloor", "\u2985": "lopar", "\u2986": "ropar", "\u298B": "lbrke", "\u298C": "rbrke", "\u298D": "lbrkslu", "\u298E": "rbrksld", "\u298F": "lbrksld", "\u2990": "rbrkslu", "\u2991": "langd", "\u2992": "rangd", "\u2993": "lparlt", "\u2994": "rpargt", "\u2995": "gtlPar", "\u2996": "ltrPar", "\u27E6": "lobrk", "\u27E7": "robrk", "\u27E8": "lang", "\u27E9": "rang", "\u27EA": "Lang", "\u27EB": "Rang", "\u27EC": "loang", "\u27ED": "roang", "\u2772": "lbbrk", "\u2773": "rbbrk", "\u2016": "Vert", "\xA7": "sect", "\xB6": "para", "@": "commat", "*": "ast", "/": "sol", "undefined": null, "&": "amp", "#": "num", "%": "percnt", "\u2030": "permil", "\u2031": "pertenk", "\u2020": "dagger", "\u2021": "Dagger", "\u2022": "bull", "\u2043": "hybull", "\u2032": "prime", "\u2033": "Prime", "\u2034": "tprime", "\u2057": "qprime", "\u2035": "bprime", "\u2041": "caret", "`": "grave", "\xB4": "acute", "\u02DC": "tilde", "^": "Hat", "\xAF": "macr", "\u02D8": "breve", "\u02D9": "dot", "\xA8": "die", "\u02DA": "ring", "\u02DD": "dblac", "\xB8": "cedil", "\u02DB": "ogon", "\u02C6": "circ", "\u02C7": "caron", "\xB0": "deg", "\xA9": "copy", "\xAE": "reg", "\u2117": "copysr", "\u2118": "wp", "\u211E": "rx", "\u2127": "mho", "\u2129": "iiota", "\u2190": "larr", "\u219A": "nlarr", "\u2192": "rarr", "\u219B": "nrarr", "\u2191": "uarr", "\u2193": "darr", "\u2194": "harr", "\u21AE": "nharr", "\u2195": "varr", "\u2196": "nwarr", "\u2197": "nearr", "\u2198": "searr", "\u2199": "swarr", "\u219D": "rarrw", "\u219D\u0338": "nrarrw", "\u219E": "Larr", "\u219F": "Uarr", "\u21A0": "Rarr", "\u21A1": "Darr", "\u21A2": "larrtl", "\u21A3": "rarrtl", "\u21A4": "mapstoleft", "\u21A5": "mapstoup", "\u21A6": "map", "\u21A7": "mapstodown", "\u21A9": "larrhk", "\u21AA": "rarrhk", "\u21AB": "larrlp", "\u21AC": "rarrlp", "\u21AD": "harrw", "\u21B0": "lsh", "\u21B1": "rsh", "\u21B2": "ldsh", "\u21B3": "rdsh", "\u21B5": "crarr", "\u21B6": "cularr", "\u21B7": "curarr", "\u21BA": "olarr", "\u21BB": "orarr", "\u21BC": "lharu", "\u21BD": "lhard", "\u21BE": "uharr", "\u21BF": "uharl", "\u21C0": "rharu", "\u21C1": "rhard", "\u21C2": "dharr", "\u21C3": "dharl", "\u21C4": "rlarr", "\u21C5": "udarr", "\u21C6": "lrarr", "\u21C7": "llarr", "\u21C8": "uuarr", "\u21C9": "rrarr", "\u21CA": "ddarr", "\u21CB": "lrhar", "\u21CC": "rlhar", "\u21D0": "lArr", "\u21CD": "nlArr", "\u21D1": "uArr", "\u21D2": "rArr", "\u21CF": "nrArr", "\u21D3": "dArr", "\u21D4": "iff", "\u21CE": "nhArr", "\u21D5": "vArr", "\u21D6": "nwArr", "\u21D7": "neArr", "\u21D8": "seArr", "\u21D9": "swArr", "\u21DA": "lAarr", "\u21DB": "rAarr", "\u21DD": "zigrarr", "\u21E4": "larrb", "\u21E5": "rarrb", "\u21F5": "duarr", "\u21FD": "loarr", "\u21FE": "roarr", "\u21FF": "hoarr", "\u2200": "forall", "\u2201": "comp", "\u2202": "part", "\u2202\u0338": "npart", "\u2203": "exist", "\u2204": "nexist", "\u2205": "empty", "\u2207": "Del", "\u2208": "in", "\u2209": "notin", "\u220B": "ni", "\u220C": "notni", "\u03F6": "bepsi", "\u220F": "prod", "\u2210": "coprod", "\u2211": "sum", "+": "plus", "\xB1": "pm", "\xF7": "div", "\xD7": "times", "<": "lt", "\u226E": "nlt", "<\u20D2": "nvlt", "=": "equals", "\u2260": "ne", "=\u20E5": "bne", "\u2A75": "Equal", ">": "gt", "\u226F": "ngt", ">\u20D2": "nvgt", "\xAC": "not", "|": "vert", "\xA6": "brvbar", "\u2212": "minus", "\u2213": "mp", "\u2214": "plusdo", "\u2044": "frasl", "\u2216": "setmn", "\u2217": "lowast", "\u2218": "compfn", "\u221A": "Sqrt", "\u221D": "prop", "\u221E": "infin", "\u221F": "angrt", "\u2220": "ang", "\u2220\u20D2": "nang", "\u2221": "angmsd", "\u2222": "angsph", "\u2223": "mid", "\u2224": "nmid", "\u2225": "par", "\u2226": "npar", "\u2227": "and", "\u2228": "or", "\u2229": "cap", "\u2229\uFE00": "caps", "\u222A": "cup", "\u222A\uFE00": "cups", "\u222B": "int", "\u222C": "Int", "\u222D": "tint", "\u2A0C": "qint", "\u222E": "oint", "\u222F": "Conint", "\u2230": "Cconint", "\u2231": "cwint", "\u2232": "cwconint", "\u2233": "awconint", "\u2234": "there4", "\u2235": "becaus", "\u2236": "ratio", "\u2237": "Colon", "\u2238": "minusd", "\u223A": "mDDot", "\u223B": "homtht", "\u223C": "sim", "\u2241": "nsim", "\u223C\u20D2": "nvsim", "\u223D": "bsim", "\u223D\u0331": "race", "\u223E": "ac", "\u223E\u0333": "acE", "\u223F": "acd", "\u2240": "wr", "\u2242": "esim", "\u2242\u0338": "nesim", "\u2243": "sime", "\u2244": "nsime", "\u2245": "cong", "\u2247": "ncong", "\u2246": "simne", "\u2248": "ap", "\u2249": "nap", "\u224A": "ape", "\u224B": "apid", "\u224B\u0338": "napid", "\u224C": "bcong", "\u224D": "CupCap", "\u226D": "NotCupCap", "\u224D\u20D2": "nvap", "\u224E": "bump", "\u224E\u0338": "nbump", "\u224F": "bumpe", "\u224F\u0338": "nbumpe", "\u2250": "doteq", "\u2250\u0338": "nedot", "\u2251": "eDot", "\u2252": "efDot", "\u2253": "erDot", "\u2254": "colone", "\u2255": "ecolon", "\u2256": "ecir", "\u2257": "cire", "\u2259": "wedgeq", "\u225A": "veeeq", "\u225C": "trie", "\u225F": "equest", "\u2261": "equiv", "\u2262": "nequiv", "\u2261\u20E5": "bnequiv", "\u2264": "le", "\u2270": "nle", "\u2264\u20D2": "nvle", "\u2265": "ge", "\u2271": "nge", "\u2265\u20D2": "nvge", "\u2266": "lE", "\u2266\u0338": "nlE", "\u2267": "gE", "\u2267\u0338": "ngE", "\u2268\uFE00": "lvnE", "\u2268": "lnE", "\u2269": "gnE", "\u2269\uFE00": "gvnE", "\u226A": "ll", "\u226A\u0338": "nLtv", "\u226A\u20D2": "nLt", "\u226B": "gg", "\u226B\u0338": "nGtv", "\u226B\u20D2": "nGt", "\u226C": "twixt", "\u2272": "lsim", "\u2274": "nlsim", "\u2273": "gsim", "\u2275": "ngsim", "\u2276": "lg", "\u2278": "ntlg", "\u2277": "gl", "\u2279": "ntgl", "\u227A": "pr", "\u2280": "npr", "\u227B": "sc", "\u2281": "nsc", "\u227C": "prcue", "\u22E0": "nprcue", "\u227D": "sccue", "\u22E1": "nsccue", "\u227E": "prsim", "\u227F": "scsim", "\u227F\u0338": "NotSucceedsTilde", "\u2282": "sub", "\u2284": "nsub", "\u2282\u20D2": "vnsub", "\u2283": "sup", "\u2285": "nsup", "\u2283\u20D2": "vnsup", "\u2286": "sube", "\u2288": "nsube", "\u2287": "supe", "\u2289": "nsupe", "\u228A\uFE00": "vsubne", "\u228A": "subne", "\u228B\uFE00": "vsupne", "\u228B": "supne", "\u228D": "cupdot", "\u228E": "uplus", "\u228F": "sqsub", "\u228F\u0338": "NotSquareSubset", "\u2290": "sqsup", "\u2290\u0338": "NotSquareSuperset", "\u2291": "sqsube", "\u22E2": "nsqsube", "\u2292": "sqsupe", "\u22E3": "nsqsupe", "\u2293": "sqcap", "\u2293\uFE00": "sqcaps", "\u2294": "sqcup", "\u2294\uFE00": "sqcups", "\u2295": "oplus", "\u2296": "ominus", "\u2297": "otimes", "\u2298": "osol", "\u2299": "odot", "\u229A": "ocir", "\u229B": "oast", "\u229D": "odash", "\u229E": "plusb", "\u229F": "minusb", "\u22A0": "timesb", "\u22A1": "sdotb", "\u22A2": "vdash", "\u22AC": "nvdash", "\u22A3": "dashv", "\u22A4": "top", "\u22A5": "bot", "\u22A7": "models", "\u22A8": "vDash", "\u22AD": "nvDash", "\u22A9": "Vdash", "\u22AE": "nVdash", "\u22AA": "Vvdash", "\u22AB": "VDash", "\u22AF": "nVDash", "\u22B0": "prurel", "\u22B2": "vltri", "\u22EA": "nltri", "\u22B3": "vrtri", "\u22EB": "nrtri", "\u22B4": "ltrie", "\u22EC": "nltrie", "\u22B4\u20D2": "nvltrie", "\u22B5": "rtrie", "\u22ED": "nrtrie", "\u22B5\u20D2": "nvrtrie", "\u22B6": "origof", "\u22B7": "imof", "\u22B8": "mumap", "\u22B9": "hercon", "\u22BA": "intcal", "\u22BB": "veebar", "\u22BD": "barvee", "\u22BE": "angrtvb", "\u22BF": "lrtri", "\u22C0": "Wedge", "\u22C1": "Vee", "\u22C2": "xcap", "\u22C3": "xcup", "\u22C4": "diam", "\u22C5": "sdot", "\u22C6": "Star", "\u22C7": "divonx", "\u22C8": "bowtie", "\u22C9": "ltimes", "\u22CA": "rtimes", "\u22CB": "lthree", "\u22CC": "rthree", "\u22CD": "bsime", "\u22CE": "cuvee", "\u22CF": "cuwed", "\u22D0": "Sub", "\u22D1": "Sup", "\u22D2": "Cap", "\u22D3": "Cup", "\u22D4": "fork", "\u22D5": "epar", "\u22D6": "ltdot", "\u22D7": "gtdot", "\u22D8": "Ll", "\u22D8\u0338": "nLl", "\u22D9": "Gg", "\u22D9\u0338": "nGg", "\u22DA\uFE00": "lesg", "\u22DA": "leg", "\u22DB": "gel", "\u22DB\uFE00": "gesl", "\u22DE": "cuepr", "\u22DF": "cuesc", "\u22E6": "lnsim", "\u22E7": "gnsim", "\u22E8": "prnsim", "\u22E9": "scnsim", "\u22EE": "vellip", "\u22EF": "ctdot", "\u22F0": "utdot", "\u22F1": "dtdot", "\u22F2": "disin", "\u22F3": "isinsv", "\u22F4": "isins", "\u22F5": "isindot", "\u22F5\u0338": "notindot", "\u22F6": "notinvc", "\u22F7": "notinvb", "\u22F9": "isinE", "\u22F9\u0338": "notinE", "\u22FA": "nisd", "\u22FB": "xnis", "\u22FC": "nis", "\u22FD": "notnivc", "\u22FE": "notnivb", "\u2305": "barwed", "\u2306": "Barwed", "\u230C": "drcrop", "\u230D": "dlcrop", "\u230E": "urcrop", "\u230F": "ulcrop", "\u2310": "bnot", "\u2312": "profline", "\u2313": "profsurf", "\u2315": "telrec", "\u2316": "target", "\u231C": "ulcorn", "\u231D": "urcorn", "\u231E": "dlcorn", "\u231F": "drcorn", "\u2322": "frown", "\u2323": "smile", "\u232D": "cylcty", "\u232E": "profalar", "\u2336": "topbot", "\u233D": "ovbar", "\u233F": "solbar", "\u237C": "angzarr", "\u23B0": "lmoust", "\u23B1": "rmoust", "\u23B4": "tbrk", "\u23B5": "bbrk", "\u23B6": "bbrktbrk", "\u23DC": "OverParenthesis", "\u23DD": "UnderParenthesis", "\u23DE": "OverBrace", "\u23DF": "UnderBrace", "\u23E2": "trpezium", "\u23E7": "elinters", "\u2423": "blank", "\u2500": "boxh", "\u2502": "boxv", "\u250C": "boxdr", "\u2510": "boxdl", "\u2514": "boxur", "\u2518": "boxul", "\u251C": "boxvr", "\u2524": "boxvl", "\u252C": "boxhd", "\u2534": "boxhu", "\u253C": "boxvh", "\u2550": "boxH", "\u2551": "boxV", "\u2552": "boxdR", "\u2553": "boxDr", "\u2554": "boxDR", "\u2555": "boxdL", "\u2556": "boxDl", "\u2557": "boxDL", "\u2558": "boxuR", "\u2559": "boxUr", "\u255A": "boxUR", "\u255B": "boxuL", "\u255C": "boxUl", "\u255D": "boxUL", "\u255E": "boxvR", "\u255F": "boxVr", "\u2560": "boxVR", "\u2561": "boxvL", "\u2562": "boxVl", "\u2563": "boxVL", "\u2564": "boxHd", "\u2565": "boxhD", "\u2566": "boxHD", "\u2567": "boxHu", "\u2568": "boxhU", "\u2569": "boxHU", "\u256A": "boxvH", "\u256B": "boxVh", "\u256C": "boxVH", "\u2580": "uhblk", "\u2584": "lhblk", "\u2588": "block", "\u2591": "blk14", "\u2592": "blk12", "\u2593": "blk34", "\u25A1": "squ", "\u25AA": "squf", "\u25AB": "EmptyVerySmallSquare", "\u25AD": "rect", "\u25AE": "marker", "\u25B1": "fltns", "\u25B3": "xutri", "\u25B4": "utrif", "\u25B5": "utri", "\u25B8": "rtrif", "\u25B9": "rtri", "\u25BD": "xdtri", "\u25BE": "dtrif", "\u25BF": "dtri", "\u25C2": "ltrif", "\u25C3": "ltri", "\u25CA": "loz", "\u25CB": "cir", "\u25EC": "tridot", "\u25EF": "xcirc", "\u25F8": "ultri", "\u25F9": "urtri", "\u25FA": "lltri", "\u25FB": "EmptySmallSquare", "\u25FC": "FilledSmallSquare", "\u2605": "starf", "\u2606": "star", "\u260E": "phone", "\u2640": "female", "\u2642": "male", "\u2660": "spades", "\u2663": "clubs", "\u2665": "hearts", "\u2666": "diams", "\u266A": "sung", "\u2713": "check", "\u2717": "cross", "\u2720": "malt", "\u2736": "sext", "\u2758": "VerticalSeparator", "\u27C8": "bsolhsub", "\u27C9": "suphsol", "\u27F5": "xlarr", "\u27F6": "xrarr", "\u27F7": "xharr", "\u27F8": "xlArr", "\u27F9": "xrArr", "\u27FA": "xhArr", "\u27FC": "xmap", "\u27FF": "dzigrarr", "\u2902": "nvlArr", "\u2903": "nvrArr", "\u2904": "nvHarr", "\u2905": "Map", "\u290C": "lbarr", "\u290D": "rbarr", "\u290E": "lBarr", "\u290F": "rBarr", "\u2910": "RBarr", "\u2911": "DDotrahd", "\u2912": "UpArrowBar", "\u2913": "DownArrowBar", "\u2916": "Rarrtl", "\u2919": "latail", "\u291A": "ratail", "\u291B": "lAtail", "\u291C": "rAtail", "\u291D": "larrfs", "\u291E": "rarrfs", "\u291F": "larrbfs", "\u2920": "rarrbfs", "\u2923": "nwarhk", "\u2924": "nearhk", "\u2925": "searhk", "\u2926": "swarhk", "\u2927": "nwnear", "\u2928": "toea", "\u2929": "tosa", "\u292A": "swnwar", "\u2933": "rarrc", "\u2933\u0338": "nrarrc", "\u2935": "cudarrr", "\u2936": "ldca", "\u2937": "rdca", "\u2938": "cudarrl", "\u2939": "larrpl", "\u293C": "curarrm", "\u293D": "cularrp", "\u2945": "rarrpl", "\u2948": "harrcir", "\u2949": "Uarrocir", "\u294A": "lurdshar", "\u294B": "ldrushar", "\u294E": "LeftRightVector", "\u294F": "RightUpDownVector", "\u2950": "DownLeftRightVector", "\u2951": "LeftUpDownVector", "\u2952": "LeftVectorBar", "\u2953": "RightVectorBar", "\u2954": "RightUpVectorBar", "\u2955": "RightDownVectorBar", "\u2956": "DownLeftVectorBar", "\u2957": "DownRightVectorBar", "\u2958": "LeftUpVectorBar", "\u2959": "LeftDownVectorBar", "\u295A": "LeftTeeVector", "\u295B": "RightTeeVector", "\u295C": "RightUpTeeVector", "\u295D": "RightDownTeeVector", "\u295E": "DownLeftTeeVector", "\u295F": "DownRightTeeVector", "\u2960": "LeftUpTeeVector", "\u2961": "LeftDownTeeVector", "\u2962": "lHar", "\u2963": "uHar", "\u2964": "rHar", "\u2965": "dHar", "\u2966": "luruhar", "\u2967": "ldrdhar", "\u2968": "ruluhar", "\u2969": "rdldhar", "\u296A": "lharul", "\u296B": "llhard", "\u296C": "rharul", "\u296D": "lrhard", "\u296E": "udhar", "\u296F": "duhar", "\u2970": "RoundImplies", "\u2971": "erarr", "\u2972": "simrarr", "\u2973": "larrsim", "\u2974": "rarrsim", "\u2975": "rarrap", "\u2976": "ltlarr", "\u2978": "gtrarr", "\u2979": "subrarr", "\u297B": "suplarr", "\u297C": "lfisht", "\u297D": "rfisht", "\u297E": "ufisht", "\u297F": "dfisht", "\u299A": "vzigzag", "\u299C": "vangrt", "\u299D": "angrtvbd", "\u29A4": "ange", "\u29A5": "range", "\u29A6": "dwangle", "\u29A7": "uwangle", "\u29A8": "angmsdaa", "\u29A9": "angmsdab", "\u29AA": "angmsdac", "\u29AB": "angmsdad", "\u29AC": "angmsdae", "\u29AD": "angmsdaf", "\u29AE": "angmsdag", "\u29AF": "angmsdah", "\u29B0": "bemptyv", "\u29B1": "demptyv", "\u29B2": "cemptyv", "\u29B3": "raemptyv", "\u29B4": "laemptyv", "\u29B5": "ohbar", "\u29B6": "omid", "\u29B7": "opar", "\u29B9": "operp", "\u29BB": "olcross", "\u29BC": "odsold", "\u29BE": "olcir", "\u29BF": "ofcir", "\u29C0": "olt", "\u29C1": "ogt", "\u29C2": "cirscir", "\u29C3": "cirE", "\u29C4": "solb", "\u29C5": "bsolb", "\u29C9": "boxbox", "\u29CD": "trisb", "\u29CE": "rtriltri", "\u29CF": "LeftTriangleBar", "\u29CF\u0338": "NotLeftTriangleBar", "\u29D0": "RightTriangleBar", "\u29D0\u0338": "NotRightTriangleBar", "\u29DC": "iinfin", "\u29DD": "infintie", "\u29DE": "nvinfin", "\u29E3": "eparsl", "\u29E4": "smeparsl", "\u29E5": "eqvparsl", "\u29EB": "lozf", "\u29F4": "RuleDelayed", "\u29F6": "dsol", "\u2A00": "xodot", "\u2A01": "xoplus", "\u2A02": "xotime", "\u2A04": "xuplus", "\u2A06": "xsqcup", "\u2A0D": "fpartint", "\u2A10": "cirfnint", "\u2A11": "awint", "\u2A12": "rppolint", "\u2A13": "scpolint", "\u2A14": "npolint", "\u2A15": "pointint", "\u2A16": "quatint", "\u2A17": "intlarhk", "\u2A22": "pluscir", "\u2A23": "plusacir", "\u2A24": "simplus", "\u2A25": "plusdu", "\u2A26": "plussim", "\u2A27": "plustwo", "\u2A29": "mcomma", "\u2A2A": "minusdu", "\u2A2D": "loplus", "\u2A2E": "roplus", "\u2A2F": "Cross", "\u2A30": "timesd", "\u2A31": "timesbar", "\u2A33": "smashp", "\u2A34": "lotimes", "\u2A35": "rotimes", "\u2A36": "otimesas", "\u2A37": "Otimes", "\u2A38": "odiv", "\u2A39": "triplus", "\u2A3A": "triminus", "\u2A3B": "tritime", "\u2A3C": "iprod", "\u2A3F": "amalg", "\u2A40": "capdot", "\u2A42": "ncup", "\u2A43": "ncap", "\u2A44": "capand", "\u2A45": "cupor", "\u2A46": "cupcap", "\u2A47": "capcup", "\u2A48": "cupbrcap", "\u2A49": "capbrcup", "\u2A4A": "cupcup", "\u2A4B": "capcap", "\u2A4C": "ccups", "\u2A4D": "ccaps", "\u2A50": "ccupssm", "\u2A53": "And", "\u2A54": "Or", "\u2A55": "andand", "\u2A56": "oror", "\u2A57": "orslope", "\u2A58": "andslope", "\u2A5A": "andv", "\u2A5B": "orv", "\u2A5C": "andd", "\u2A5D": "ord", "\u2A5F": "wedbar", "\u2A66": "sdote", "\u2A6A": "simdot", "\u2A6D": "congdot", "\u2A6D\u0338": "ncongdot", "\u2A6E": "easter", "\u2A6F": "apacir", "\u2A70": "apE", "\u2A70\u0338": "napE", "\u2A71": "eplus", "\u2A72": "pluse", "\u2A73": "Esim", "\u2A77": "eDDot", "\u2A78": "equivDD", "\u2A79": "ltcir", "\u2A7A": "gtcir", "\u2A7B": "ltquest", "\u2A7C": "gtquest", "\u2A7D": "les", "\u2A7D\u0338": "nles", "\u2A7E": "ges", "\u2A7E\u0338": "nges", "\u2A7F": "lesdot", "\u2A80": "gesdot", "\u2A81": "lesdoto", "\u2A82": "gesdoto", "\u2A83": "lesdotor", "\u2A84": "gesdotol", "\u2A85": "lap", "\u2A86": "gap", "\u2A87": "lne", "\u2A88": "gne", "\u2A89": "lnap", "\u2A8A": "gnap", "\u2A8B": "lEg", "\u2A8C": "gEl", "\u2A8D": "lsime", "\u2A8E": "gsime", "\u2A8F": "lsimg", "\u2A90": "gsiml", "\u2A91": "lgE", "\u2A92": "glE", "\u2A93": "lesges", "\u2A94": "gesles", "\u2A95": "els", "\u2A96": "egs", "\u2A97": "elsdot", "\u2A98": "egsdot", "\u2A99": "el", "\u2A9A": "eg", "\u2A9D": "siml", "\u2A9E": "simg", "\u2A9F": "simlE", "\u2AA0": "simgE", "\u2AA1": "LessLess", "\u2AA1\u0338": "NotNestedLessLess", "\u2AA2": "GreaterGreater", "\u2AA2\u0338": "NotNestedGreaterGreater", "\u2AA4": "glj", "\u2AA5": "gla", "\u2AA6": "ltcc", "\u2AA7": "gtcc", "\u2AA8": "lescc", "\u2AA9": "gescc", "\u2AAA": "smt", "\u2AAB": "lat", "\u2AAC": "smte", "\u2AAC\uFE00": "smtes", "\u2AAD": "late", "\u2AAD\uFE00": "lates", "\u2AAE": "bumpE", "\u2AAF": "pre", "\u2AAF\u0338": "npre", "\u2AB0": "sce", "\u2AB0\u0338": "nsce", "\u2AB3": "prE", "\u2AB4": "scE", "\u2AB5": "prnE", "\u2AB6": "scnE", "\u2AB7": "prap", "\u2AB8": "scap", "\u2AB9": "prnap", "\u2ABA": "scnap", "\u2ABB": "Pr", "\u2ABC": "Sc", "\u2ABD": "subdot", "\u2ABE": "supdot", "\u2ABF": "subplus", "\u2AC0": "supplus", "\u2AC1": "submult", "\u2AC2": "supmult", "\u2AC3": "subedot", "\u2AC4": "supedot", "\u2AC5": "subE", "\u2AC5\u0338": "nsubE", "\u2AC6": "supE", "\u2AC6\u0338": "nsupE", "\u2AC7": "subsim", "\u2AC8": "supsim", "\u2ACB\uFE00": "vsubnE", "\u2ACB": "subnE", "\u2ACC\uFE00": "vsupnE", "\u2ACC": "supnE", "\u2ACF": "csub", "\u2AD0": "csup", "\u2AD1": "csube", "\u2AD2": "csupe", "\u2AD3": "subsup", "\u2AD4": "supsub", "\u2AD5": "subsub", "\u2AD6": "supsup", "\u2AD7": "suphsub", "\u2AD8": "supdsub", "\u2AD9": "forkv", "\u2ADA": "topfork", "\u2ADB": "mlcp", "\u2AE4": "Dashv", "\u2AE6": "Vdashl", "\u2AE7": "Barv", "\u2AE8": "vBar", "\u2AE9": "vBarv", "\u2AEB": "Vbar", "\u2AEC": "Not", "\u2AED": "bNot", "\u2AEE": "rnmid", "\u2AEF": "cirmid", "\u2AF0": "midcir", "\u2AF1": "topcir", "\u2AF2": "nhpar", "\u2AF3": "parsim", "\u2AFD": "parsl", "\u2AFD\u20E5": "nparsl", "\u266D": "flat", "\u266E": "natur", "\u266F": "sharp", "\xA4": "curren", "\xA2": "cent", "$": "dollar", "\xA3": "pound", "\xA5": "yen", "\u20AC": "euro", "\xB9": "sup1", "\xBD": "half", "\u2153": "frac13", "\xBC": "frac14", "\u2155": "frac15", "\u2159": "frac16", "\u215B": "frac18", "\xB2": "sup2", "\u2154": "frac23", "\u2156": "frac25", "\xB3": "sup3", "\xBE": "frac34", "\u2157": "frac35", "\u215C": "frac38", "\u2158": "frac45", "\u215A": "frac56", "\u215D": "frac58", "\u215E": "frac78", "\u{1D4B6}": "ascr", "\u{1D552}": "aopf", "\u{1D51E}": "afr", "\u{1D538}": "Aopf", "\u{1D504}": "Afr", "\u{1D49C}": "Ascr", "\xAA": "ordf", "\xE1": "aacute", "\xC1": "Aacute", "\xE0": "agrave", "\xC0": "Agrave", "\u0103": "abreve", "\u0102": "Abreve", "\xE2": "acirc", "\xC2": "Acirc", "\xE5": "aring", "\xC5": "angst", "\xE4": "auml", "\xC4": "Auml", "\xE3": "atilde", "\xC3": "Atilde", "\u0105": "aogon", "\u0104": "Aogon", "\u0101": "amacr", "\u0100": "Amacr", "\xE6": "aelig", "\xC6": "AElig", "\u{1D4B7}": "bscr", "\u{1D553}": "bopf", "\u{1D51F}": "bfr", "\u{1D539}": "Bopf", "\u212C": "Bscr", "\u{1D505}": "Bfr", "\u{1D520}": "cfr", "\u{1D4B8}": "cscr", "\u{1D554}": "copf", "\u212D": "Cfr", "\u{1D49E}": "Cscr", "\u2102": "Copf", "\u0107": "cacute", "\u0106": "Cacute", "\u0109": "ccirc", "\u0108": "Ccirc", "\u010D": "ccaron", "\u010C": "Ccaron", "\u010B": "cdot", "\u010A": "Cdot", "\xE7": "ccedil", "\xC7": "Ccedil", "\u2105": "incare", "\u{1D521}": "dfr", "\u2146": "dd", "\u{1D555}": "dopf", "\u{1D4B9}": "dscr", "\u{1D49F}": "Dscr", "\u{1D507}": "Dfr", "\u2145": "DD", "\u{1D53B}": "Dopf", "\u010F": "dcaron", "\u010E": "Dcaron", "\u0111": "dstrok", "\u0110": "Dstrok", "\xF0": "eth", "\xD0": "ETH", "\u2147": "ee", "\u212F": "escr", "\u{1D522}": "efr", "\u{1D556}": "eopf", "\u2130": "Escr", "\u{1D508}": "Efr", "\u{1D53C}": "Eopf", "\xE9": "eacute", "\xC9": "Eacute", "\xE8": "egrave", "\xC8": "Egrave", "\xEA": "ecirc", "\xCA": "Ecirc", "\u011B": "ecaron", "\u011A": "Ecaron", "\xEB": "euml", "\xCB": "Euml", "\u0117": "edot", "\u0116": "Edot", "\u0119": "eogon", "\u0118": "Eogon", "\u0113": "emacr", "\u0112": "Emacr", "\u{1D523}": "ffr", "\u{1D557}": "fopf", "\u{1D4BB}": "fscr", "\u{1D509}": "Ffr", "\u{1D53D}": "Fopf", "\u2131": "Fscr", "\uFB00": "fflig", "\uFB03": "ffilig", "\uFB04": "ffllig", "\uFB01": "filig", "fj": "fjlig", "\uFB02": "fllig", "\u0192": "fnof", "\u210A": "gscr", "\u{1D558}": "gopf", "\u{1D524}": "gfr", "\u{1D4A2}": "Gscr", "\u{1D53E}": "Gopf", "\u{1D50A}": "Gfr", "\u01F5": "gacute", "\u011F": "gbreve", "\u011E": "Gbreve", "\u011D": "gcirc", "\u011C": "Gcirc", "\u0121": "gdot", "\u0120": "Gdot", "\u0122": "Gcedil", "\u{1D525}": "hfr", "\u210E": "planckh", "\u{1D4BD}": "hscr", "\u{1D559}": "hopf", "\u210B": "Hscr", "\u210C": "Hfr", "\u210D": "Hopf", "\u0125": "hcirc", "\u0124": "Hcirc", "\u210F": "hbar", "\u0127": "hstrok", "\u0126": "Hstrok", "\u{1D55A}": "iopf", "\u{1D526}": "ifr", "\u{1D4BE}": "iscr", "\u2148": "ii", "\u{1D540}": "Iopf", "\u2110": "Iscr", "\u2111": "Im", "\xED": "iacute", "\xCD": "Iacute", "\xEC": "igrave", "\xCC": "Igrave", "\xEE": "icirc", "\xCE": "Icirc", "\xEF": "iuml", "\xCF": "Iuml", "\u0129": "itilde", "\u0128": "Itilde", "\u0130": "Idot", "\u012F": "iogon", "\u012E": "Iogon", "\u012B": "imacr", "\u012A": "Imacr", "\u0133": "ijlig", "\u0132": "IJlig", "\u0131": "imath", "\u{1D4BF}": "jscr", "\u{1D55B}": "jopf", "\u{1D527}": "jfr", "\u{1D4A5}": "Jscr", "\u{1D50D}": "Jfr", "\u{1D541}": "Jopf", "\u0135": "jcirc", "\u0134": "Jcirc", "\u0237": "jmath", "\u{1D55C}": "kopf", "\u{1D4C0}": "kscr", "\u{1D528}": "kfr", "\u{1D4A6}": "Kscr", "\u{1D542}": "Kopf", "\u{1D50E}": "Kfr", "\u0137": "kcedil", "\u0136": "Kcedil", "\u{1D529}": "lfr", "\u{1D4C1}": "lscr", "\u2113": "ell", "\u{1D55D}": "lopf", "\u2112": "Lscr", "\u{1D50F}": "Lfr", "\u{1D543}": "Lopf", "\u013A": "lacute", "\u0139": "Lacute", "\u013E": "lcaron", "\u013D": "Lcaron", "\u013C": "lcedil", "\u013B": "Lcedil", "\u0142": "lstrok", "\u0141": "Lstrok", "\u0140": "lmidot", "\u013F": "Lmidot", "\u{1D52A}": "mfr", "\u{1D55E}": "mopf", "\u{1D4C2}": "mscr", "\u{1D510}": "Mfr", "\u{1D544}": "Mopf", "\u2133": "Mscr", "\u{1D52B}": "nfr", "\u{1D55F}": "nopf", "\u{1D4C3}": "nscr", "\u2115": "Nopf", "\u{1D4A9}": "Nscr", "\u{1D511}": "Nfr", "\u0144": "nacute", "\u0143": "Nacute", "\u0148": "ncaron", "\u0147": "Ncaron", "\xF1": "ntilde", "\xD1": "Ntilde", "\u0146": "ncedil", "\u0145": "Ncedil", "\u2116": "numero", "\u014B": "eng", "\u014A": "ENG", "\u{1D560}": "oopf", "\u{1D52C}": "ofr", "\u2134": "oscr", "\u{1D4AA}": "Oscr", "\u{1D512}": "Ofr", "\u{1D546}": "Oopf", "\xBA": "ordm", "\xF3": "oacute", "\xD3": "Oacute", "\xF2": "ograve", "\xD2": "Ograve", "\xF4": "ocirc", "\xD4": "Ocirc", "\xF6": "ouml", "\xD6": "Ouml", "\u0151": "odblac", "\u0150": "Odblac", "\xF5": "otilde", "\xD5": "Otilde", "\xF8": "oslash", "\xD8": "Oslash", "\u014D": "omacr", "\u014C": "Omacr", "\u0153": "oelig", "\u0152": "OElig", "\u{1D52D}": "pfr", "\u{1D4C5}": "pscr", "\u{1D561}": "popf", "\u2119": "Popf", "\u{1D513}": "Pfr", "\u{1D4AB}": "Pscr", "\u{1D562}": "qopf", "\u{1D52E}": "qfr", "\u{1D4C6}": "qscr", "\u{1D4AC}": "Qscr", "\u{1D514}": "Qfr", "\u211A": "Qopf", "\u0138": "kgreen", "\u{1D52F}": "rfr", "\u{1D563}": "ropf", "\u{1D4C7}": "rscr", "\u211B": "Rscr", "\u211C": "Re", "\u211D": "Ropf", "\u0155": "racute", "\u0154": "Racute", "\u0159": "rcaron", "\u0158": "Rcaron", "\u0157": "rcedil", "\u0156": "Rcedil", "\u{1D564}": "sopf", "\u{1D4C8}": "sscr", "\u{1D530}": "sfr", "\u{1D54A}": "Sopf", "\u{1D516}": "Sfr", "\u{1D4AE}": "Sscr", "\u24C8": "oS", "\u015B": "sacute", "\u015A": "Sacute", "\u015D": "scirc", "\u015C": "Scirc", "\u0161": "scaron", "\u0160": "Scaron", "\u015F": "scedil", "\u015E": "Scedil", "\xDF": "szlig", "\u{1D531}": "tfr", "\u{1D4C9}": "tscr", "\u{1D565}": "topf", "\u{1D4AF}": "Tscr", "\u{1D517}": "Tfr", "\u{1D54B}": "Topf", "\u0165": "tcaron", "\u0164": "Tcaron", "\u0163": "tcedil", "\u0162": "Tcedil", "\u2122": "trade", "\u0167": "tstrok", "\u0166": "Tstrok", "\u{1D4CA}": "uscr", "\u{1D566}": "uopf", "\u{1D532}": "ufr", "\u{1D54C}": "Uopf", "\u{1D518}": "Ufr", "\u{1D4B0}": "Uscr", "\xFA": "uacute", "\xDA": "Uacute", "\xF9": "ugrave", "\xD9": "Ugrave", "\u016D": "ubreve", "\u016C": "Ubreve", "\xFB": "ucirc", "\xDB": "Ucirc", "\u016F": "uring", "\u016E": "Uring", "\xFC": "uuml", "\xDC": "Uuml", "\u0171": "udblac", "\u0170": "Udblac", "\u0169": "utilde", "\u0168": "Utilde", "\u0173": "uogon", "\u0172": "Uogon", "\u016B": "umacr", "\u016A": "Umacr", "\u{1D533}": "vfr", "\u{1D567}": "vopf", "\u{1D4CB}": "vscr", "\u{1D519}": "Vfr", "\u{1D54D}": "Vopf", "\u{1D4B1}": "Vscr", "\u{1D568}": "wopf", "\u{1D4CC}": "wscr", "\u{1D534}": "wfr", "\u{1D4B2}": "Wscr", "\u{1D54E}": "Wopf", "\u{1D51A}": "Wfr", "\u0175": "wcirc", "\u0174": "Wcirc", "\u{1D535}": "xfr", "\u{1D4CD}": "xscr", "\u{1D569}": "xopf", "\u{1D54F}": "Xopf", "\u{1D51B}": "Xfr", "\u{1D4B3}": "Xscr", "\u{1D536}": "yfr", "\u{1D4CE}": "yscr", "\u{1D56A}": "yopf", "\u{1D4B4}": "Yscr", "\u{1D51C}": "Yfr", "\u{1D550}": "Yopf", "\xFD": "yacute", "\xDD": "Yacute", "\u0177": "ycirc", "\u0176": "Ycirc", "\xFF": "yuml", "\u0178": "Yuml", "\u{1D4CF}": "zscr", "\u{1D537}": "zfr", "\u{1D56B}": "zopf", "\u2128": "Zfr", "\u2124": "Zopf", "\u{1D4B5}": "Zscr", "\u017A": "zacute", "\u0179": "Zacute", "\u017E": "zcaron", "\u017D": "Zcaron", "\u017C": "zdot", "\u017B": "Zdot", "\u01B5": "imped", "\xFE": "thorn", "\xDE": "THORN", "\u0149": "napos", "\u03B1": "alpha", "\u0391": "Alpha", "\u03B2": "beta", "\u0392": "Beta", "\u03B3": "gamma", "\u0393": "Gamma", "\u03B4": "delta", "\u0394": "Delta", "\u03B5": "epsi", "\u03F5": "epsiv", "\u0395": "Epsilon", "\u03DD": "gammad", "\u03DC": "Gammad", "\u03B6": "zeta", "\u0396": "Zeta", "\u03B7": "eta", "\u0397": "Eta", "\u03B8": "theta", "\u03D1": "thetav", "\u0398": "Theta", "\u03B9": "iota", "\u0399": "Iota", "\u03BA": "kappa", "\u03F0": "kappav", "\u039A": "Kappa", "\u03BB": "lambda", "\u039B": "Lambda", "\u03BC": "mu", "\xB5": "micro", "\u039C": "Mu", "\u03BD": "nu", "\u039D": "Nu", "\u03BE": "xi", "\u039E": "Xi", "\u03BF": "omicron", "\u039F": "Omicron", "\u03C0": "pi", "\u03D6": "piv", "\u03A0": "Pi", "\u03C1": "rho", "\u03F1": "rhov", "\u03A1": "Rho", "\u03C3": "sigma", "\u03A3": "Sigma", "\u03C2": "sigmaf", "\u03C4": "tau", "\u03A4": "Tau", "\u03C5": "upsi", "\u03A5": "Upsilon", "\u03D2": "Upsi", "\u03C6": "phi", "\u03D5": "phiv", "\u03A6": "Phi", "\u03C7": "chi", "\u03A7": "Chi", "\u03C8": "psi", "\u03A8": "Psi", "\u03C9": "omega", "\u03A9": "ohm", "\u0430": "acy", "\u0410": "Acy", "\u0431": "bcy", "\u0411": "Bcy", "\u0432": "vcy", "\u0412": "Vcy", "\u0433": "gcy", "\u0413": "Gcy", "\u0453": "gjcy", "\u0403": "GJcy", "\u0434": "dcy", "\u0414": "Dcy", "\u0452": "djcy", "\u0402": "DJcy", "\u0435": "iecy", "\u0415": "IEcy", "\u0451": "iocy", "\u0401": "IOcy", "\u0454": "jukcy", "\u0404": "Jukcy", "\u0436": "zhcy", "\u0416": "ZHcy", "\u0437": "zcy", "\u0417": "Zcy", "\u0455": "dscy", "\u0405": "DScy", "\u0438": "icy", "\u0418": "Icy", "\u0456": "iukcy", "\u0406": "Iukcy", "\u0457": "yicy", "\u0407": "YIcy", "\u0439": "jcy", "\u0419": "Jcy", "\u0458": "jsercy", "\u0408": "Jsercy", "\u043A": "kcy", "\u041A": "Kcy", "\u045C": "kjcy", "\u040C": "KJcy", "\u043B": "lcy", "\u041B": "Lcy", "\u0459": "ljcy", "\u0409": "LJcy", "\u043C": "mcy", "\u041C": "Mcy", "\u043D": "ncy", "\u041D": "Ncy", "\u045A": "njcy", "\u040A": "NJcy", "\u043E": "ocy", "\u041E": "Ocy", "\u043F": "pcy", "\u041F": "Pcy", "\u0440": "rcy", "\u0420": "Rcy", "\u0441": "scy", "\u0421": "Scy", "\u0442": "tcy", "\u0422": "Tcy", "\u045B": "tshcy", "\u040B": "TSHcy", "\u0443": "ucy", "\u0423": "Ucy", "\u045E": "ubrcy", "\u040E": "Ubrcy", "\u0444": "fcy", "\u0424": "Fcy", "\u0445": "khcy", "\u0425": "KHcy", "\u0446": "tscy", "\u0426": "TScy", "\u0447": "chcy", "\u0427": "CHcy", "\u045F": "dzcy", "\u040F": "DZcy", "\u0448": "shcy", "\u0428": "SHcy", "\u0449": "shchcy", "\u0429": "SHCHcy", "\u044A": "hardcy", "\u042A": "HARDcy", "\u044B": "ycy", "\u042B": "Ycy", "\u044C": "softcy", "\u042C": "SOFTcy", "\u044D": "ecy", "\u042D": "Ecy", "\u044E": "yucy", "\u042E": "YUcy", "\u044F": "yacy", "\u042F": "YAcy", "\u2135": "aleph", "\u2136": "beth", "\u2137": "gimel", "\u2138": "daleth" };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
      '"': "&quot;",
      "&": "&amp;",
      "'": "&#x27;",
      "<": "&lt;",
      ">": "&gt;",
      "`": "&#x60;"
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = { "aacute": "\xE1", "Aacute": "\xC1", "abreve": "\u0103", "Abreve": "\u0102", "ac": "\u223E", "acd": "\u223F", "acE": "\u223E\u0333", "acirc": "\xE2", "Acirc": "\xC2", "acute": "\xB4", "acy": "\u0430", "Acy": "\u0410", "aelig": "\xE6", "AElig": "\xC6", "af": "\u2061", "afr": "\u{1D51E}", "Afr": "\u{1D504}", "agrave": "\xE0", "Agrave": "\xC0", "alefsym": "\u2135", "aleph": "\u2135", "alpha": "\u03B1", "Alpha": "\u0391", "amacr": "\u0101", "Amacr": "\u0100", "amalg": "\u2A3F", "amp": "&", "AMP": "&", "and": "\u2227", "And": "\u2A53", "andand": "\u2A55", "andd": "\u2A5C", "andslope": "\u2A58", "andv": "\u2A5A", "ang": "\u2220", "ange": "\u29A4", "angle": "\u2220", "angmsd": "\u2221", "angmsdaa": "\u29A8", "angmsdab": "\u29A9", "angmsdac": "\u29AA", "angmsdad": "\u29AB", "angmsdae": "\u29AC", "angmsdaf": "\u29AD", "angmsdag": "\u29AE", "angmsdah": "\u29AF", "angrt": "\u221F", "angrtvb": "\u22BE", "angrtvbd": "\u299D", "angsph": "\u2222", "angst": "\xC5", "angzarr": "\u237C", "aogon": "\u0105", "Aogon": "\u0104", "aopf": "\u{1D552}", "Aopf": "\u{1D538}", "ap": "\u2248", "apacir": "\u2A6F", "ape": "\u224A", "apE": "\u2A70", "apid": "\u224B", "apos": "'", "ApplyFunction": "\u2061", "approx": "\u2248", "approxeq": "\u224A", "aring": "\xE5", "Aring": "\xC5", "ascr": "\u{1D4B6}", "Ascr": "\u{1D49C}", "Assign": "\u2254", "ast": "*", "asymp": "\u2248", "asympeq": "\u224D", "atilde": "\xE3", "Atilde": "\xC3", "auml": "\xE4", "Auml": "\xC4", "awconint": "\u2233", "awint": "\u2A11", "backcong": "\u224C", "backepsilon": "\u03F6", "backprime": "\u2035", "backsim": "\u223D", "backsimeq": "\u22CD", "Backslash": "\u2216", "Barv": "\u2AE7", "barvee": "\u22BD", "barwed": "\u2305", "Barwed": "\u2306", "barwedge": "\u2305", "bbrk": "\u23B5", "bbrktbrk": "\u23B6", "bcong": "\u224C", "bcy": "\u0431", "Bcy": "\u0411", "bdquo": "\u201E", "becaus": "\u2235", "because": "\u2235", "Because": "\u2235", "bemptyv": "\u29B0", "bepsi": "\u03F6", "bernou": "\u212C", "Bernoullis": "\u212C", "beta": "\u03B2", "Beta": "\u0392", "beth": "\u2136", "between": "\u226C", "bfr": "\u{1D51F}", "Bfr": "\u{1D505}", "bigcap": "\u22C2", "bigcirc": "\u25EF", "bigcup": "\u22C3", "bigodot": "\u2A00", "bigoplus": "\u2A01", "bigotimes": "\u2A02", "bigsqcup": "\u2A06", "bigstar": "\u2605", "bigtriangledown": "\u25BD", "bigtriangleup": "\u25B3", "biguplus": "\u2A04", "bigvee": "\u22C1", "bigwedge": "\u22C0", "bkarow": "\u290D", "blacklozenge": "\u29EB", "blacksquare": "\u25AA", "blacktriangle": "\u25B4", "blacktriangledown": "\u25BE", "blacktriangleleft": "\u25C2", "blacktriangleright": "\u25B8", "blank": "\u2423", "blk12": "\u2592", "blk14": "\u2591", "blk34": "\u2593", "block": "\u2588", "bne": "=\u20E5", "bnequiv": "\u2261\u20E5", "bnot": "\u2310", "bNot": "\u2AED", "bopf": "\u{1D553}", "Bopf": "\u{1D539}", "bot": "\u22A5", "bottom": "\u22A5", "bowtie": "\u22C8", "boxbox": "\u29C9", "boxdl": "\u2510", "boxdL": "\u2555", "boxDl": "\u2556", "boxDL": "\u2557", "boxdr": "\u250C", "boxdR": "\u2552", "boxDr": "\u2553", "boxDR": "\u2554", "boxh": "\u2500", "boxH": "\u2550", "boxhd": "\u252C", "boxhD": "\u2565", "boxHd": "\u2564", "boxHD": "\u2566", "boxhu": "\u2534", "boxhU": "\u2568", "boxHu": "\u2567", "boxHU": "\u2569", "boxminus": "\u229F", "boxplus": "\u229E", "boxtimes": "\u22A0", "boxul": "\u2518", "boxuL": "\u255B", "boxUl": "\u255C", "boxUL": "\u255D", "boxur": "\u2514", "boxuR": "\u2558", "boxUr": "\u2559", "boxUR": "\u255A", "boxv": "\u2502", "boxV": "\u2551", "boxvh": "\u253C", "boxvH": "\u256A", "boxVh": "\u256B", "boxVH": "\u256C", "boxvl": "\u2524", "boxvL": "\u2561", "boxVl": "\u2562", "boxVL": "\u2563", "boxvr": "\u251C", "boxvR": "\u255E", "boxVr": "\u255F", "boxVR": "\u2560", "bprime": "\u2035", "breve": "\u02D8", "Breve": "\u02D8", "brvbar": "\xA6", "bscr": "\u{1D4B7}", "Bscr": "\u212C", "bsemi": "\u204F", "bsim": "\u223D", "bsime": "\u22CD", "bsol": "\\", "bsolb": "\u29C5", "bsolhsub": "\u27C8", "bull": "\u2022", "bullet": "\u2022", "bump": "\u224E", "bumpe": "\u224F", "bumpE": "\u2AAE", "bumpeq": "\u224F", "Bumpeq": "\u224E", "cacute": "\u0107", "Cacute": "\u0106", "cap": "\u2229", "Cap": "\u22D2", "capand": "\u2A44", "capbrcup": "\u2A49", "capcap": "\u2A4B", "capcup": "\u2A47", "capdot": "\u2A40", "CapitalDifferentialD": "\u2145", "caps": "\u2229\uFE00", "caret": "\u2041", "caron": "\u02C7", "Cayleys": "\u212D", "ccaps": "\u2A4D", "ccaron": "\u010D", "Ccaron": "\u010C", "ccedil": "\xE7", "Ccedil": "\xC7", "ccirc": "\u0109", "Ccirc": "\u0108", "Cconint": "\u2230", "ccups": "\u2A4C", "ccupssm": "\u2A50", "cdot": "\u010B", "Cdot": "\u010A", "cedil": "\xB8", "Cedilla": "\xB8", "cemptyv": "\u29B2", "cent": "\xA2", "centerdot": "\xB7", "CenterDot": "\xB7", "cfr": "\u{1D520}", "Cfr": "\u212D", "chcy": "\u0447", "CHcy": "\u0427", "check": "\u2713", "checkmark": "\u2713", "chi": "\u03C7", "Chi": "\u03A7", "cir": "\u25CB", "circ": "\u02C6", "circeq": "\u2257", "circlearrowleft": "\u21BA", "circlearrowright": "\u21BB", "circledast": "\u229B", "circledcirc": "\u229A", "circleddash": "\u229D", "CircleDot": "\u2299", "circledR": "\xAE", "circledS": "\u24C8", "CircleMinus": "\u2296", "CirclePlus": "\u2295", "CircleTimes": "\u2297", "cire": "\u2257", "cirE": "\u29C3", "cirfnint": "\u2A10", "cirmid": "\u2AEF", "cirscir": "\u29C2", "ClockwiseContourIntegral": "\u2232", "CloseCurlyDoubleQuote": "\u201D", "CloseCurlyQuote": "\u2019", "clubs": "\u2663", "clubsuit": "\u2663", "colon": ":", "Colon": "\u2237", "colone": "\u2254", "Colone": "\u2A74", "coloneq": "\u2254", "comma": ",", "commat": "@", "comp": "\u2201", "compfn": "\u2218", "complement": "\u2201", "complexes": "\u2102", "cong": "\u2245", "congdot": "\u2A6D", "Congruent": "\u2261", "conint": "\u222E", "Conint": "\u222F", "ContourIntegral": "\u222E", "copf": "\u{1D554}", "Copf": "\u2102", "coprod": "\u2210", "Coproduct": "\u2210", "copy": "\xA9", "COPY": "\xA9", "copysr": "\u2117", "CounterClockwiseContourIntegral": "\u2233", "crarr": "\u21B5", "cross": "\u2717", "Cross": "\u2A2F", "cscr": "\u{1D4B8}", "Cscr": "\u{1D49E}", "csub": "\u2ACF", "csube": "\u2AD1", "csup": "\u2AD0", "csupe": "\u2AD2", "ctdot": "\u22EF", "cudarrl": "\u2938", "cudarrr": "\u2935", "cuepr": "\u22DE", "cuesc": "\u22DF", "cularr": "\u21B6", "cularrp": "\u293D", "cup": "\u222A", "Cup": "\u22D3", "cupbrcap": "\u2A48", "cupcap": "\u2A46", "CupCap": "\u224D", "cupcup": "\u2A4A", "cupdot": "\u228D", "cupor": "\u2A45", "cups": "\u222A\uFE00", "curarr": "\u21B7", "curarrm": "\u293C", "curlyeqprec": "\u22DE", "curlyeqsucc": "\u22DF", "curlyvee": "\u22CE", "curlywedge": "\u22CF", "curren": "\xA4", "curvearrowleft": "\u21B6", "curvearrowright": "\u21B7", "cuvee": "\u22CE", "cuwed": "\u22CF", "cwconint": "\u2232", "cwint": "\u2231", "cylcty": "\u232D", "dagger": "\u2020", "Dagger": "\u2021", "daleth": "\u2138", "darr": "\u2193", "dArr": "\u21D3", "Darr": "\u21A1", "dash": "\u2010", "dashv": "\u22A3", "Dashv": "\u2AE4", "dbkarow": "\u290F", "dblac": "\u02DD", "dcaron": "\u010F", "Dcaron": "\u010E", "dcy": "\u0434", "Dcy": "\u0414", "dd": "\u2146", "DD": "\u2145", "ddagger": "\u2021", "ddarr": "\u21CA", "DDotrahd": "\u2911", "ddotseq": "\u2A77", "deg": "\xB0", "Del": "\u2207", "delta": "\u03B4", "Delta": "\u0394", "demptyv": "\u29B1", "dfisht": "\u297F", "dfr": "\u{1D521}", "Dfr": "\u{1D507}", "dHar": "\u2965", "dharl": "\u21C3", "dharr": "\u21C2", "DiacriticalAcute": "\xB4", "DiacriticalDot": "\u02D9", "DiacriticalDoubleAcute": "\u02DD", "DiacriticalGrave": "`", "DiacriticalTilde": "\u02DC", "diam": "\u22C4", "diamond": "\u22C4", "Diamond": "\u22C4", "diamondsuit": "\u2666", "diams": "\u2666", "die": "\xA8", "DifferentialD": "\u2146", "digamma": "\u03DD", "disin": "\u22F2", "div": "\xF7", "divide": "\xF7", "divideontimes": "\u22C7", "divonx": "\u22C7", "djcy": "\u0452", "DJcy": "\u0402", "dlcorn": "\u231E", "dlcrop": "\u230D", "dollar": "$", "dopf": "\u{1D555}", "Dopf": "\u{1D53B}", "dot": "\u02D9", "Dot": "\xA8", "DotDot": "\u20DC", "doteq": "\u2250", "doteqdot": "\u2251", "DotEqual": "\u2250", "dotminus": "\u2238", "dotplus": "\u2214", "dotsquare": "\u22A1", "doublebarwedge": "\u2306", "DoubleContourIntegral": "\u222F", "DoubleDot": "\xA8", "DoubleDownArrow": "\u21D3", "DoubleLeftArrow": "\u21D0", "DoubleLeftRightArrow": "\u21D4", "DoubleLeftTee": "\u2AE4", "DoubleLongLeftArrow": "\u27F8", "DoubleLongLeftRightArrow": "\u27FA", "DoubleLongRightArrow": "\u27F9", "DoubleRightArrow": "\u21D2", "DoubleRightTee": "\u22A8", "DoubleUpArrow": "\u21D1", "DoubleUpDownArrow": "\u21D5", "DoubleVerticalBar": "\u2225", "downarrow": "\u2193", "Downarrow": "\u21D3", "DownArrow": "\u2193", "DownArrowBar": "\u2913", "DownArrowUpArrow": "\u21F5", "DownBreve": "\u0311", "downdownarrows": "\u21CA", "downharpoonleft": "\u21C3", "downharpoonright": "\u21C2", "DownLeftRightVector": "\u2950", "DownLeftTeeVector": "\u295E", "DownLeftVector": "\u21BD", "DownLeftVectorBar": "\u2956", "DownRightTeeVector": "\u295F", "DownRightVector": "\u21C1", "DownRightVectorBar": "\u2957", "DownTee": "\u22A4", "DownTeeArrow": "\u21A7", "drbkarow": "\u2910", "drcorn": "\u231F", "drcrop": "\u230C", "dscr": "\u{1D4B9}", "Dscr": "\u{1D49F}", "dscy": "\u0455", "DScy": "\u0405", "dsol": "\u29F6", "dstrok": "\u0111", "Dstrok": "\u0110", "dtdot": "\u22F1", "dtri": "\u25BF", "dtrif": "\u25BE", "duarr": "\u21F5", "duhar": "\u296F", "dwangle": "\u29A6", "dzcy": "\u045F", "DZcy": "\u040F", "dzigrarr": "\u27FF", "eacute": "\xE9", "Eacute": "\xC9", "easter": "\u2A6E", "ecaron": "\u011B", "Ecaron": "\u011A", "ecir": "\u2256", "ecirc": "\xEA", "Ecirc": "\xCA", "ecolon": "\u2255", "ecy": "\u044D", "Ecy": "\u042D", "eDDot": "\u2A77", "edot": "\u0117", "eDot": "\u2251", "Edot": "\u0116", "ee": "\u2147", "efDot": "\u2252", "efr": "\u{1D522}", "Efr": "\u{1D508}", "eg": "\u2A9A", "egrave": "\xE8", "Egrave": "\xC8", "egs": "\u2A96", "egsdot": "\u2A98", "el": "\u2A99", "Element": "\u2208", "elinters": "\u23E7", "ell": "\u2113", "els": "\u2A95", "elsdot": "\u2A97", "emacr": "\u0113", "Emacr": "\u0112", "empty": "\u2205", "emptyset": "\u2205", "EmptySmallSquare": "\u25FB", "emptyv": "\u2205", "EmptyVerySmallSquare": "\u25AB", "emsp": "\u2003", "emsp13": "\u2004", "emsp14": "\u2005", "eng": "\u014B", "ENG": "\u014A", "ensp": "\u2002", "eogon": "\u0119", "Eogon": "\u0118", "eopf": "\u{1D556}", "Eopf": "\u{1D53C}", "epar": "\u22D5", "eparsl": "\u29E3", "eplus": "\u2A71", "epsi": "\u03B5", "epsilon": "\u03B5", "Epsilon": "\u0395", "epsiv": "\u03F5", "eqcirc": "\u2256", "eqcolon": "\u2255", "eqsim": "\u2242", "eqslantgtr": "\u2A96", "eqslantless": "\u2A95", "Equal": "\u2A75", "equals": "=", "EqualTilde": "\u2242", "equest": "\u225F", "Equilibrium": "\u21CC", "equiv": "\u2261", "equivDD": "\u2A78", "eqvparsl": "\u29E5", "erarr": "\u2971", "erDot": "\u2253", "escr": "\u212F", "Escr": "\u2130", "esdot": "\u2250", "esim": "\u2242", "Esim": "\u2A73", "eta": "\u03B7", "Eta": "\u0397", "eth": "\xF0", "ETH": "\xD0", "euml": "\xEB", "Euml": "\xCB", "euro": "\u20AC", "excl": "!", "exist": "\u2203", "Exists": "\u2203", "expectation": "\u2130", "exponentiale": "\u2147", "ExponentialE": "\u2147", "fallingdotseq": "\u2252", "fcy": "\u0444", "Fcy": "\u0424", "female": "\u2640", "ffilig": "\uFB03", "fflig": "\uFB00", "ffllig": "\uFB04", "ffr": "\u{1D523}", "Ffr": "\u{1D509}", "filig": "\uFB01", "FilledSmallSquare": "\u25FC", "FilledVerySmallSquare": "\u25AA", "fjlig": "fj", "flat": "\u266D", "fllig": "\uFB02", "fltns": "\u25B1", "fnof": "\u0192", "fopf": "\u{1D557}", "Fopf": "\u{1D53D}", "forall": "\u2200", "ForAll": "\u2200", "fork": "\u22D4", "forkv": "\u2AD9", "Fouriertrf": "\u2131", "fpartint": "\u2A0D", "frac12": "\xBD", "frac13": "\u2153", "frac14": "\xBC", "frac15": "\u2155", "frac16": "\u2159", "frac18": "\u215B", "frac23": "\u2154", "frac25": "\u2156", "frac34": "\xBE", "frac35": "\u2157", "frac38": "\u215C", "frac45": "\u2158", "frac56": "\u215A", "frac58": "\u215D", "frac78": "\u215E", "frasl": "\u2044", "frown": "\u2322", "fscr": "\u{1D4BB}", "Fscr": "\u2131", "gacute": "\u01F5", "gamma": "\u03B3", "Gamma": "\u0393", "gammad": "\u03DD", "Gammad": "\u03DC", "gap": "\u2A86", "gbreve": "\u011F", "Gbreve": "\u011E", "Gcedil": "\u0122", "gcirc": "\u011D", "Gcirc": "\u011C", "gcy": "\u0433", "Gcy": "\u0413", "gdot": "\u0121", "Gdot": "\u0120", "ge": "\u2265", "gE": "\u2267", "gel": "\u22DB", "gEl": "\u2A8C", "geq": "\u2265", "geqq": "\u2267", "geqslant": "\u2A7E", "ges": "\u2A7E", "gescc": "\u2AA9", "gesdot": "\u2A80", "gesdoto": "\u2A82", "gesdotol": "\u2A84", "gesl": "\u22DB\uFE00", "gesles": "\u2A94", "gfr": "\u{1D524}", "Gfr": "\u{1D50A}", "gg": "\u226B", "Gg": "\u22D9", "ggg": "\u22D9", "gimel": "\u2137", "gjcy": "\u0453", "GJcy": "\u0403", "gl": "\u2277", "gla": "\u2AA5", "glE": "\u2A92", "glj": "\u2AA4", "gnap": "\u2A8A", "gnapprox": "\u2A8A", "gne": "\u2A88", "gnE": "\u2269", "gneq": "\u2A88", "gneqq": "\u2269", "gnsim": "\u22E7", "gopf": "\u{1D558}", "Gopf": "\u{1D53E}", "grave": "`", "GreaterEqual": "\u2265", "GreaterEqualLess": "\u22DB", "GreaterFullEqual": "\u2267", "GreaterGreater": "\u2AA2", "GreaterLess": "\u2277", "GreaterSlantEqual": "\u2A7E", "GreaterTilde": "\u2273", "gscr": "\u210A", "Gscr": "\u{1D4A2}", "gsim": "\u2273", "gsime": "\u2A8E", "gsiml": "\u2A90", "gt": ">", "Gt": "\u226B", "GT": ">", "gtcc": "\u2AA7", "gtcir": "\u2A7A", "gtdot": "\u22D7", "gtlPar": "\u2995", "gtquest": "\u2A7C", "gtrapprox": "\u2A86", "gtrarr": "\u2978", "gtrdot": "\u22D7", "gtreqless": "\u22DB", "gtreqqless": "\u2A8C", "gtrless": "\u2277", "gtrsim": "\u2273", "gvertneqq": "\u2269\uFE00", "gvnE": "\u2269\uFE00", "Hacek": "\u02C7", "hairsp": "\u200A", "half": "\xBD", "hamilt": "\u210B", "hardcy": "\u044A", "HARDcy": "\u042A", "harr": "\u2194", "hArr": "\u21D4", "harrcir": "\u2948", "harrw": "\u21AD", "Hat": "^", "hbar": "\u210F", "hcirc": "\u0125", "Hcirc": "\u0124", "hearts": "\u2665", "heartsuit": "\u2665", "hellip": "\u2026", "hercon": "\u22B9", "hfr": "\u{1D525}", "Hfr": "\u210C", "HilbertSpace": "\u210B", "hksearow": "\u2925", "hkswarow": "\u2926", "hoarr": "\u21FF", "homtht": "\u223B", "hookleftarrow": "\u21A9", "hookrightarrow": "\u21AA", "hopf": "\u{1D559}", "Hopf": "\u210D", "horbar": "\u2015", "HorizontalLine": "\u2500", "hscr": "\u{1D4BD}", "Hscr": "\u210B", "hslash": "\u210F", "hstrok": "\u0127", "Hstrok": "\u0126", "HumpDownHump": "\u224E", "HumpEqual": "\u224F", "hybull": "\u2043", "hyphen": "\u2010", "iacute": "\xED", "Iacute": "\xCD", "ic": "\u2063", "icirc": "\xEE", "Icirc": "\xCE", "icy": "\u0438", "Icy": "\u0418", "Idot": "\u0130", "iecy": "\u0435", "IEcy": "\u0415", "iexcl": "\xA1", "iff": "\u21D4", "ifr": "\u{1D526}", "Ifr": "\u2111", "igrave": "\xEC", "Igrave": "\xCC", "ii": "\u2148", "iiiint": "\u2A0C", "iiint": "\u222D", "iinfin": "\u29DC", "iiota": "\u2129", "ijlig": "\u0133", "IJlig": "\u0132", "Im": "\u2111", "imacr": "\u012B", "Imacr": "\u012A", "image": "\u2111", "ImaginaryI": "\u2148", "imagline": "\u2110", "imagpart": "\u2111", "imath": "\u0131", "imof": "\u22B7", "imped": "\u01B5", "Implies": "\u21D2", "in": "\u2208", "incare": "\u2105", "infin": "\u221E", "infintie": "\u29DD", "inodot": "\u0131", "int": "\u222B", "Int": "\u222C", "intcal": "\u22BA", "integers": "\u2124", "Integral": "\u222B", "intercal": "\u22BA", "Intersection": "\u22C2", "intlarhk": "\u2A17", "intprod": "\u2A3C", "InvisibleComma": "\u2063", "InvisibleTimes": "\u2062", "iocy": "\u0451", "IOcy": "\u0401", "iogon": "\u012F", "Iogon": "\u012E", "iopf": "\u{1D55A}", "Iopf": "\u{1D540}", "iota": "\u03B9", "Iota": "\u0399", "iprod": "\u2A3C", "iquest": "\xBF", "iscr": "\u{1D4BE}", "Iscr": "\u2110", "isin": "\u2208", "isindot": "\u22F5", "isinE": "\u22F9", "isins": "\u22F4", "isinsv": "\u22F3", "isinv": "\u2208", "it": "\u2062", "itilde": "\u0129", "Itilde": "\u0128", "iukcy": "\u0456", "Iukcy": "\u0406", "iuml": "\xEF", "Iuml": "\xCF", "jcirc": "\u0135", "Jcirc": "\u0134", "jcy": "\u0439", "Jcy": "\u0419", "jfr": "\u{1D527}", "Jfr": "\u{1D50D}", "jmath": "\u0237", "jopf": "\u{1D55B}", "Jopf": "\u{1D541}", "jscr": "\u{1D4BF}", "Jscr": "\u{1D4A5}", "jsercy": "\u0458", "Jsercy": "\u0408", "jukcy": "\u0454", "Jukcy": "\u0404", "kappa": "\u03BA", "Kappa": "\u039A", "kappav": "\u03F0", "kcedil": "\u0137", "Kcedil": "\u0136", "kcy": "\u043A", "Kcy": "\u041A", "kfr": "\u{1D528}", "Kfr": "\u{1D50E}", "kgreen": "\u0138", "khcy": "\u0445", "KHcy": "\u0425", "kjcy": "\u045C", "KJcy": "\u040C", "kopf": "\u{1D55C}", "Kopf": "\u{1D542}", "kscr": "\u{1D4C0}", "Kscr": "\u{1D4A6}", "lAarr": "\u21DA", "lacute": "\u013A", "Lacute": "\u0139", "laemptyv": "\u29B4", "lagran": "\u2112", "lambda": "\u03BB", "Lambda": "\u039B", "lang": "\u27E8", "Lang": "\u27EA", "langd": "\u2991", "langle": "\u27E8", "lap": "\u2A85", "Laplacetrf": "\u2112", "laquo": "\xAB", "larr": "\u2190", "lArr": "\u21D0", "Larr": "\u219E", "larrb": "\u21E4", "larrbfs": "\u291F", "larrfs": "\u291D", "larrhk": "\u21A9", "larrlp": "\u21AB", "larrpl": "\u2939", "larrsim": "\u2973", "larrtl": "\u21A2", "lat": "\u2AAB", "latail": "\u2919", "lAtail": "\u291B", "late": "\u2AAD", "lates": "\u2AAD\uFE00", "lbarr": "\u290C", "lBarr": "\u290E", "lbbrk": "\u2772", "lbrace": "{", "lbrack": "[", "lbrke": "\u298B", "lbrksld": "\u298F", "lbrkslu": "\u298D", "lcaron": "\u013E", "Lcaron": "\u013D", "lcedil": "\u013C", "Lcedil": "\u013B", "lceil": "\u2308", "lcub": "{", "lcy": "\u043B", "Lcy": "\u041B", "ldca": "\u2936", "ldquo": "\u201C", "ldquor": "\u201E", "ldrdhar": "\u2967", "ldrushar": "\u294B", "ldsh": "\u21B2", "le": "\u2264", "lE": "\u2266", "LeftAngleBracket": "\u27E8", "leftarrow": "\u2190", "Leftarrow": "\u21D0", "LeftArrow": "\u2190", "LeftArrowBar": "\u21E4", "LeftArrowRightArrow": "\u21C6", "leftarrowtail": "\u21A2", "LeftCeiling": "\u2308", "LeftDoubleBracket": "\u27E6", "LeftDownTeeVector": "\u2961", "LeftDownVector": "\u21C3", "LeftDownVectorBar": "\u2959", "LeftFloor": "\u230A", "leftharpoondown": "\u21BD", "leftharpoonup": "\u21BC", "leftleftarrows": "\u21C7", "leftrightarrow": "\u2194", "Leftrightarrow": "\u21D4", "LeftRightArrow": "\u2194", "leftrightarrows": "\u21C6", "leftrightharpoons": "\u21CB", "leftrightsquigarrow": "\u21AD", "LeftRightVector": "\u294E", "LeftTee": "\u22A3", "LeftTeeArrow": "\u21A4", "LeftTeeVector": "\u295A", "leftthreetimes": "\u22CB", "LeftTriangle": "\u22B2", "LeftTriangleBar": "\u29CF", "LeftTriangleEqual": "\u22B4", "LeftUpDownVector": "\u2951", "LeftUpTeeVector": "\u2960", "LeftUpVector": "\u21BF", "LeftUpVectorBar": "\u2958", "LeftVector": "\u21BC", "LeftVectorBar": "\u2952", "leg": "\u22DA", "lEg": "\u2A8B", "leq": "\u2264", "leqq": "\u2266", "leqslant": "\u2A7D", "les": "\u2A7D", "lescc": "\u2AA8", "lesdot": "\u2A7F", "lesdoto": "\u2A81", "lesdotor": "\u2A83", "lesg": "\u22DA\uFE00", "lesges": "\u2A93", "lessapprox": "\u2A85", "lessdot": "\u22D6", "lesseqgtr": "\u22DA", "lesseqqgtr": "\u2A8B", "LessEqualGreater": "\u22DA", "LessFullEqual": "\u2266", "LessGreater": "\u2276", "lessgtr": "\u2276", "LessLess": "\u2AA1", "lesssim": "\u2272", "LessSlantEqual": "\u2A7D", "LessTilde": "\u2272", "lfisht": "\u297C", "lfloor": "\u230A", "lfr": "\u{1D529}", "Lfr": "\u{1D50F}", "lg": "\u2276", "lgE": "\u2A91", "lHar": "\u2962", "lhard": "\u21BD", "lharu": "\u21BC", "lharul": "\u296A", "lhblk": "\u2584", "ljcy": "\u0459", "LJcy": "\u0409", "ll": "\u226A", "Ll": "\u22D8", "llarr": "\u21C7", "llcorner": "\u231E", "Lleftarrow": "\u21DA", "llhard": "\u296B", "lltri": "\u25FA", "lmidot": "\u0140", "Lmidot": "\u013F", "lmoust": "\u23B0", "lmoustache": "\u23B0", "lnap": "\u2A89", "lnapprox": "\u2A89", "lne": "\u2A87", "lnE": "\u2268", "lneq": "\u2A87", "lneqq": "\u2268", "lnsim": "\u22E6", "loang": "\u27EC", "loarr": "\u21FD", "lobrk": "\u27E6", "longleftarrow": "\u27F5", "Longleftarrow": "\u27F8", "LongLeftArrow": "\u27F5", "longleftrightarrow": "\u27F7", "Longleftrightarrow": "\u27FA", "LongLeftRightArrow": "\u27F7", "longmapsto": "\u27FC", "longrightarrow": "\u27F6", "Longrightarrow": "\u27F9", "LongRightArrow": "\u27F6", "looparrowleft": "\u21AB", "looparrowright": "\u21AC", "lopar": "\u2985", "lopf": "\u{1D55D}", "Lopf": "\u{1D543}", "loplus": "\u2A2D", "lotimes": "\u2A34", "lowast": "\u2217", "lowbar": "_", "LowerLeftArrow": "\u2199", "LowerRightArrow": "\u2198", "loz": "\u25CA", "lozenge": "\u25CA", "lozf": "\u29EB", "lpar": "(", "lparlt": "\u2993", "lrarr": "\u21C6", "lrcorner": "\u231F", "lrhar": "\u21CB", "lrhard": "\u296D", "lrm": "\u200E", "lrtri": "\u22BF", "lsaquo": "\u2039", "lscr": "\u{1D4C1}", "Lscr": "\u2112", "lsh": "\u21B0", "Lsh": "\u21B0", "lsim": "\u2272", "lsime": "\u2A8D", "lsimg": "\u2A8F", "lsqb": "[", "lsquo": "\u2018", "lsquor": "\u201A", "lstrok": "\u0142", "Lstrok": "\u0141", "lt": "<", "Lt": "\u226A", "LT": "<", "ltcc": "\u2AA6", "ltcir": "\u2A79", "ltdot": "\u22D6", "lthree": "\u22CB", "ltimes": "\u22C9", "ltlarr": "\u2976", "ltquest": "\u2A7B", "ltri": "\u25C3", "ltrie": "\u22B4", "ltrif": "\u25C2", "ltrPar": "\u2996", "lurdshar": "\u294A", "luruhar": "\u2966", "lvertneqq": "\u2268\uFE00", "lvnE": "\u2268\uFE00", "macr": "\xAF", "male": "\u2642", "malt": "\u2720", "maltese": "\u2720", "map": "\u21A6", "Map": "\u2905", "mapsto": "\u21A6", "mapstodown": "\u21A7", "mapstoleft": "\u21A4", "mapstoup": "\u21A5", "marker": "\u25AE", "mcomma": "\u2A29", "mcy": "\u043C", "Mcy": "\u041C", "mdash": "\u2014", "mDDot": "\u223A", "measuredangle": "\u2221", "MediumSpace": "\u205F", "Mellintrf": "\u2133", "mfr": "\u{1D52A}", "Mfr": "\u{1D510}", "mho": "\u2127", "micro": "\xB5", "mid": "\u2223", "midast": "*", "midcir": "\u2AF0", "middot": "\xB7", "minus": "\u2212", "minusb": "\u229F", "minusd": "\u2238", "minusdu": "\u2A2A", "MinusPlus": "\u2213", "mlcp": "\u2ADB", "mldr": "\u2026", "mnplus": "\u2213", "models": "\u22A7", "mopf": "\u{1D55E}", "Mopf": "\u{1D544}", "mp": "\u2213", "mscr": "\u{1D4C2}", "Mscr": "\u2133", "mstpos": "\u223E", "mu": "\u03BC", "Mu": "\u039C", "multimap": "\u22B8", "mumap": "\u22B8", "nabla": "\u2207", "nacute": "\u0144", "Nacute": "\u0143", "nang": "\u2220\u20D2", "nap": "\u2249", "napE": "\u2A70\u0338", "napid": "\u224B\u0338", "napos": "\u0149", "napprox": "\u2249", "natur": "\u266E", "natural": "\u266E", "naturals": "\u2115", "nbsp": "\xA0", "nbump": "\u224E\u0338", "nbumpe": "\u224F\u0338", "ncap": "\u2A43", "ncaron": "\u0148", "Ncaron": "\u0147", "ncedil": "\u0146", "Ncedil": "\u0145", "ncong": "\u2247", "ncongdot": "\u2A6D\u0338", "ncup": "\u2A42", "ncy": "\u043D", "Ncy": "\u041D", "ndash": "\u2013", "ne": "\u2260", "nearhk": "\u2924", "nearr": "\u2197", "neArr": "\u21D7", "nearrow": "\u2197", "nedot": "\u2250\u0338", "NegativeMediumSpace": "\u200B", "NegativeThickSpace": "\u200B", "NegativeThinSpace": "\u200B", "NegativeVeryThinSpace": "\u200B", "nequiv": "\u2262", "nesear": "\u2928", "nesim": "\u2242\u0338", "NestedGreaterGreater": "\u226B", "NestedLessLess": "\u226A", "NewLine": "\n", "nexist": "\u2204", "nexists": "\u2204", "nfr": "\u{1D52B}", "Nfr": "\u{1D511}", "nge": "\u2271", "ngE": "\u2267\u0338", "ngeq": "\u2271", "ngeqq": "\u2267\u0338", "ngeqslant": "\u2A7E\u0338", "nges": "\u2A7E\u0338", "nGg": "\u22D9\u0338", "ngsim": "\u2275", "ngt": "\u226F", "nGt": "\u226B\u20D2", "ngtr": "\u226F", "nGtv": "\u226B\u0338", "nharr": "\u21AE", "nhArr": "\u21CE", "nhpar": "\u2AF2", "ni": "\u220B", "nis": "\u22FC", "nisd": "\u22FA", "niv": "\u220B", "njcy": "\u045A", "NJcy": "\u040A", "nlarr": "\u219A", "nlArr": "\u21CD", "nldr": "\u2025", "nle": "\u2270", "nlE": "\u2266\u0338", "nleftarrow": "\u219A", "nLeftarrow": "\u21CD", "nleftrightarrow": "\u21AE", "nLeftrightarrow": "\u21CE", "nleq": "\u2270", "nleqq": "\u2266\u0338", "nleqslant": "\u2A7D\u0338", "nles": "\u2A7D\u0338", "nless": "\u226E", "nLl": "\u22D8\u0338", "nlsim": "\u2274", "nlt": "\u226E", "nLt": "\u226A\u20D2", "nltri": "\u22EA", "nltrie": "\u22EC", "nLtv": "\u226A\u0338", "nmid": "\u2224", "NoBreak": "\u2060", "NonBreakingSpace": "\xA0", "nopf": "\u{1D55F}", "Nopf": "\u2115", "not": "\xAC", "Not": "\u2AEC", "NotCongruent": "\u2262", "NotCupCap": "\u226D", "NotDoubleVerticalBar": "\u2226", "NotElement": "\u2209", "NotEqual": "\u2260", "NotEqualTilde": "\u2242\u0338", "NotExists": "\u2204", "NotGreater": "\u226F", "NotGreaterEqual": "\u2271", "NotGreaterFullEqual": "\u2267\u0338", "NotGreaterGreater": "\u226B\u0338", "NotGreaterLess": "\u2279", "NotGreaterSlantEqual": "\u2A7E\u0338", "NotGreaterTilde": "\u2275", "NotHumpDownHump": "\u224E\u0338", "NotHumpEqual": "\u224F\u0338", "notin": "\u2209", "notindot": "\u22F5\u0338", "notinE": "\u22F9\u0338", "notinva": "\u2209", "notinvb": "\u22F7", "notinvc": "\u22F6", "NotLeftTriangle": "\u22EA", "NotLeftTriangleBar": "\u29CF\u0338", "NotLeftTriangleEqual": "\u22EC", "NotLess": "\u226E", "NotLessEqual": "\u2270", "NotLessGreater": "\u2278", "NotLessLess": "\u226A\u0338", "NotLessSlantEqual": "\u2A7D\u0338", "NotLessTilde": "\u2274", "NotNestedGreaterGreater": "\u2AA2\u0338", "NotNestedLessLess": "\u2AA1\u0338", "notni": "\u220C", "notniva": "\u220C", "notnivb": "\u22FE", "notnivc": "\u22FD", "NotPrecedes": "\u2280", "NotPrecedesEqual": "\u2AAF\u0338", "NotPrecedesSlantEqual": "\u22E0", "NotReverseElement": "\u220C", "NotRightTriangle": "\u22EB", "NotRightTriangleBar": "\u29D0\u0338", "NotRightTriangleEqual": "\u22ED", "NotSquareSubset": "\u228F\u0338", "NotSquareSubsetEqual": "\u22E2", "NotSquareSuperset": "\u2290\u0338", "NotSquareSupersetEqual": "\u22E3", "NotSubset": "\u2282\u20D2", "NotSubsetEqual": "\u2288", "NotSucceeds": "\u2281", "NotSucceedsEqual": "\u2AB0\u0338", "NotSucceedsSlantEqual": "\u22E1", "NotSucceedsTilde": "\u227F\u0338", "NotSuperset": "\u2283\u20D2", "NotSupersetEqual": "\u2289", "NotTilde": "\u2241", "NotTildeEqual": "\u2244", "NotTildeFullEqual": "\u2247", "NotTildeTilde": "\u2249", "NotVerticalBar": "\u2224", "npar": "\u2226", "nparallel": "\u2226", "nparsl": "\u2AFD\u20E5", "npart": "\u2202\u0338", "npolint": "\u2A14", "npr": "\u2280", "nprcue": "\u22E0", "npre": "\u2AAF\u0338", "nprec": "\u2280", "npreceq": "\u2AAF\u0338", "nrarr": "\u219B", "nrArr": "\u21CF", "nrarrc": "\u2933\u0338", "nrarrw": "\u219D\u0338", "nrightarrow": "\u219B", "nRightarrow": "\u21CF", "nrtri": "\u22EB", "nrtrie": "\u22ED", "nsc": "\u2281", "nsccue": "\u22E1", "nsce": "\u2AB0\u0338", "nscr": "\u{1D4C3}", "Nscr": "\u{1D4A9}", "nshortmid": "\u2224", "nshortparallel": "\u2226", "nsim": "\u2241", "nsime": "\u2244", "nsimeq": "\u2244", "nsmid": "\u2224", "nspar": "\u2226", "nsqsube": "\u22E2", "nsqsupe": "\u22E3", "nsub": "\u2284", "nsube": "\u2288", "nsubE": "\u2AC5\u0338", "nsubset": "\u2282\u20D2", "nsubseteq": "\u2288", "nsubseteqq": "\u2AC5\u0338", "nsucc": "\u2281", "nsucceq": "\u2AB0\u0338", "nsup": "\u2285", "nsupe": "\u2289", "nsupE": "\u2AC6\u0338", "nsupset": "\u2283\u20D2", "nsupseteq": "\u2289", "nsupseteqq": "\u2AC6\u0338", "ntgl": "\u2279", "ntilde": "\xF1", "Ntilde": "\xD1", "ntlg": "\u2278", "ntriangleleft": "\u22EA", "ntrianglelefteq": "\u22EC", "ntriangleright": "\u22EB", "ntrianglerighteq": "\u22ED", "nu": "\u03BD", "Nu": "\u039D", "num": "#", "numero": "\u2116", "numsp": "\u2007", "nvap": "\u224D\u20D2", "nvdash": "\u22AC", "nvDash": "\u22AD", "nVdash": "\u22AE", "nVDash": "\u22AF", "nvge": "\u2265\u20D2", "nvgt": ">\u20D2", "nvHarr": "\u2904", "nvinfin": "\u29DE", "nvlArr": "\u2902", "nvle": "\u2264\u20D2", "nvlt": "<\u20D2", "nvltrie": "\u22B4\u20D2", "nvrArr": "\u2903", "nvrtrie": "\u22B5\u20D2", "nvsim": "\u223C\u20D2", "nwarhk": "\u2923", "nwarr": "\u2196", "nwArr": "\u21D6", "nwarrow": "\u2196", "nwnear": "\u2927", "oacute": "\xF3", "Oacute": "\xD3", "oast": "\u229B", "ocir": "\u229A", "ocirc": "\xF4", "Ocirc": "\xD4", "ocy": "\u043E", "Ocy": "\u041E", "odash": "\u229D", "odblac": "\u0151", "Odblac": "\u0150", "odiv": "\u2A38", "odot": "\u2299", "odsold": "\u29BC", "oelig": "\u0153", "OElig": "\u0152", "ofcir": "\u29BF", "ofr": "\u{1D52C}", "Ofr": "\u{1D512}", "ogon": "\u02DB", "ograve": "\xF2", "Ograve": "\xD2", "ogt": "\u29C1", "ohbar": "\u29B5", "ohm": "\u03A9", "oint": "\u222E", "olarr": "\u21BA", "olcir": "\u29BE", "olcross": "\u29BB", "oline": "\u203E", "olt": "\u29C0", "omacr": "\u014D", "Omacr": "\u014C", "omega": "\u03C9", "Omega": "\u03A9", "omicron": "\u03BF", "Omicron": "\u039F", "omid": "\u29B6", "ominus": "\u2296", "oopf": "\u{1D560}", "Oopf": "\u{1D546}", "opar": "\u29B7", "OpenCurlyDoubleQuote": "\u201C", "OpenCurlyQuote": "\u2018", "operp": "\u29B9", "oplus": "\u2295", "or": "\u2228", "Or": "\u2A54", "orarr": "\u21BB", "ord": "\u2A5D", "order": "\u2134", "orderof": "\u2134", "ordf": "\xAA", "ordm": "\xBA", "origof": "\u22B6", "oror": "\u2A56", "orslope": "\u2A57", "orv": "\u2A5B", "oS": "\u24C8", "oscr": "\u2134", "Oscr": "\u{1D4AA}", "oslash": "\xF8", "Oslash": "\xD8", "osol": "\u2298", "otilde": "\xF5", "Otilde": "\xD5", "otimes": "\u2297", "Otimes": "\u2A37", "otimesas": "\u2A36", "ouml": "\xF6", "Ouml": "\xD6", "ovbar": "\u233D", "OverBar": "\u203E", "OverBrace": "\u23DE", "OverBracket": "\u23B4", "OverParenthesis": "\u23DC", "par": "\u2225", "para": "\xB6", "parallel": "\u2225", "parsim": "\u2AF3", "parsl": "\u2AFD", "part": "\u2202", "PartialD": "\u2202", "pcy": "\u043F", "Pcy": "\u041F", "percnt": "%", "period": ".", "permil": "\u2030", "perp": "\u22A5", "pertenk": "\u2031", "pfr": "\u{1D52D}", "Pfr": "\u{1D513}", "phi": "\u03C6", "Phi": "\u03A6", "phiv": "\u03D5", "phmmat": "\u2133", "phone": "\u260E", "pi": "\u03C0", "Pi": "\u03A0", "pitchfork": "\u22D4", "piv": "\u03D6", "planck": "\u210F", "planckh": "\u210E", "plankv": "\u210F", "plus": "+", "plusacir": "\u2A23", "plusb": "\u229E", "pluscir": "\u2A22", "plusdo": "\u2214", "plusdu": "\u2A25", "pluse": "\u2A72", "PlusMinus": "\xB1", "plusmn": "\xB1", "plussim": "\u2A26", "plustwo": "\u2A27", "pm": "\xB1", "Poincareplane": "\u210C", "pointint": "\u2A15", "popf": "\u{1D561}", "Popf": "\u2119", "pound": "\xA3", "pr": "\u227A", "Pr": "\u2ABB", "prap": "\u2AB7", "prcue": "\u227C", "pre": "\u2AAF", "prE": "\u2AB3", "prec": "\u227A", "precapprox": "\u2AB7", "preccurlyeq": "\u227C", "Precedes": "\u227A", "PrecedesEqual": "\u2AAF", "PrecedesSlantEqual": "\u227C", "PrecedesTilde": "\u227E", "preceq": "\u2AAF", "precnapprox": "\u2AB9", "precneqq": "\u2AB5", "precnsim": "\u22E8", "precsim": "\u227E", "prime": "\u2032", "Prime": "\u2033", "primes": "\u2119", "prnap": "\u2AB9", "prnE": "\u2AB5", "prnsim": "\u22E8", "prod": "\u220F", "Product": "\u220F", "profalar": "\u232E", "profline": "\u2312", "profsurf": "\u2313", "prop": "\u221D", "Proportion": "\u2237", "Proportional": "\u221D", "propto": "\u221D", "prsim": "\u227E", "prurel": "\u22B0", "pscr": "\u{1D4C5}", "Pscr": "\u{1D4AB}", "psi": "\u03C8", "Psi": "\u03A8", "puncsp": "\u2008", "qfr": "\u{1D52E}", "Qfr": "\u{1D514}", "qint": "\u2A0C", "qopf": "\u{1D562}", "Qopf": "\u211A", "qprime": "\u2057", "qscr": "\u{1D4C6}", "Qscr": "\u{1D4AC}", "quaternions": "\u210D", "quatint": "\u2A16", "quest": "?", "questeq": "\u225F", "quot": '"', "QUOT": '"', "rAarr": "\u21DB", "race": "\u223D\u0331", "racute": "\u0155", "Racute": "\u0154", "radic": "\u221A", "raemptyv": "\u29B3", "rang": "\u27E9", "Rang": "\u27EB", "rangd": "\u2992", "range": "\u29A5", "rangle": "\u27E9", "raquo": "\xBB", "rarr": "\u2192", "rArr": "\u21D2", "Rarr": "\u21A0", "rarrap": "\u2975", "rarrb": "\u21E5", "rarrbfs": "\u2920", "rarrc": "\u2933", "rarrfs": "\u291E", "rarrhk": "\u21AA", "rarrlp": "\u21AC", "rarrpl": "\u2945", "rarrsim": "\u2974", "rarrtl": "\u21A3", "Rarrtl": "\u2916", "rarrw": "\u219D", "ratail": "\u291A", "rAtail": "\u291C", "ratio": "\u2236", "rationals": "\u211A", "rbarr": "\u290D", "rBarr": "\u290F", "RBarr": "\u2910", "rbbrk": "\u2773", "rbrace": "}", "rbrack": "]", "rbrke": "\u298C", "rbrksld": "\u298E", "rbrkslu": "\u2990", "rcaron": "\u0159", "Rcaron": "\u0158", "rcedil": "\u0157", "Rcedil": "\u0156", "rceil": "\u2309", "rcub": "}", "rcy": "\u0440", "Rcy": "\u0420", "rdca": "\u2937", "rdldhar": "\u2969", "rdquo": "\u201D", "rdquor": "\u201D", "rdsh": "\u21B3", "Re": "\u211C", "real": "\u211C", "realine": "\u211B", "realpart": "\u211C", "reals": "\u211D", "rect": "\u25AD", "reg": "\xAE", "REG": "\xAE", "ReverseElement": "\u220B", "ReverseEquilibrium": "\u21CB", "ReverseUpEquilibrium": "\u296F", "rfisht": "\u297D", "rfloor": "\u230B", "rfr": "\u{1D52F}", "Rfr": "\u211C", "rHar": "\u2964", "rhard": "\u21C1", "rharu": "\u21C0", "rharul": "\u296C", "rho": "\u03C1", "Rho": "\u03A1", "rhov": "\u03F1", "RightAngleBracket": "\u27E9", "rightarrow": "\u2192", "Rightarrow": "\u21D2", "RightArrow": "\u2192", "RightArrowBar": "\u21E5", "RightArrowLeftArrow": "\u21C4", "rightarrowtail": "\u21A3", "RightCeiling": "\u2309", "RightDoubleBracket": "\u27E7", "RightDownTeeVector": "\u295D", "RightDownVector": "\u21C2", "RightDownVectorBar": "\u2955", "RightFloor": "\u230B", "rightharpoondown": "\u21C1", "rightharpoonup": "\u21C0", "rightleftarrows": "\u21C4", "rightleftharpoons": "\u21CC", "rightrightarrows": "\u21C9", "rightsquigarrow": "\u219D", "RightTee": "\u22A2", "RightTeeArrow": "\u21A6", "RightTeeVector": "\u295B", "rightthreetimes": "\u22CC", "RightTriangle": "\u22B3", "RightTriangleBar": "\u29D0", "RightTriangleEqual": "\u22B5", "RightUpDownVector": "\u294F", "RightUpTeeVector": "\u295C", "RightUpVector": "\u21BE", "RightUpVectorBar": "\u2954", "RightVector": "\u21C0", "RightVectorBar": "\u2953", "ring": "\u02DA", "risingdotseq": "\u2253", "rlarr": "\u21C4", "rlhar": "\u21CC", "rlm": "\u200F", "rmoust": "\u23B1", "rmoustache": "\u23B1", "rnmid": "\u2AEE", "roang": "\u27ED", "roarr": "\u21FE", "robrk": "\u27E7", "ropar": "\u2986", "ropf": "\u{1D563}", "Ropf": "\u211D", "roplus": "\u2A2E", "rotimes": "\u2A35", "RoundImplies": "\u2970", "rpar": ")", "rpargt": "\u2994", "rppolint": "\u2A12", "rrarr": "\u21C9", "Rrightarrow": "\u21DB", "rsaquo": "\u203A", "rscr": "\u{1D4C7}", "Rscr": "\u211B", "rsh": "\u21B1", "Rsh": "\u21B1", "rsqb": "]", "rsquo": "\u2019", "rsquor": "\u2019", "rthree": "\u22CC", "rtimes": "\u22CA", "rtri": "\u25B9", "rtrie": "\u22B5", "rtrif": "\u25B8", "rtriltri": "\u29CE", "RuleDelayed": "\u29F4", "ruluhar": "\u2968", "rx": "\u211E", "sacute": "\u015B", "Sacute": "\u015A", "sbquo": "\u201A", "sc": "\u227B", "Sc": "\u2ABC", "scap": "\u2AB8", "scaron": "\u0161", "Scaron": "\u0160", "sccue": "\u227D", "sce": "\u2AB0", "scE": "\u2AB4", "scedil": "\u015F", "Scedil": "\u015E", "scirc": "\u015D", "Scirc": "\u015C", "scnap": "\u2ABA", "scnE": "\u2AB6", "scnsim": "\u22E9", "scpolint": "\u2A13", "scsim": "\u227F", "scy": "\u0441", "Scy": "\u0421", "sdot": "\u22C5", "sdotb": "\u22A1", "sdote": "\u2A66", "searhk": "\u2925", "searr": "\u2198", "seArr": "\u21D8", "searrow": "\u2198", "sect": "\xA7", "semi": ";", "seswar": "\u2929", "setminus": "\u2216", "setmn": "\u2216", "sext": "\u2736", "sfr": "\u{1D530}", "Sfr": "\u{1D516}", "sfrown": "\u2322", "sharp": "\u266F", "shchcy": "\u0449", "SHCHcy": "\u0429", "shcy": "\u0448", "SHcy": "\u0428", "ShortDownArrow": "\u2193", "ShortLeftArrow": "\u2190", "shortmid": "\u2223", "shortparallel": "\u2225", "ShortRightArrow": "\u2192", "ShortUpArrow": "\u2191", "shy": "\xAD", "sigma": "\u03C3", "Sigma": "\u03A3", "sigmaf": "\u03C2", "sigmav": "\u03C2", "sim": "\u223C", "simdot": "\u2A6A", "sime": "\u2243", "simeq": "\u2243", "simg": "\u2A9E", "simgE": "\u2AA0", "siml": "\u2A9D", "simlE": "\u2A9F", "simne": "\u2246", "simplus": "\u2A24", "simrarr": "\u2972", "slarr": "\u2190", "SmallCircle": "\u2218", "smallsetminus": "\u2216", "smashp": "\u2A33", "smeparsl": "\u29E4", "smid": "\u2223", "smile": "\u2323", "smt": "\u2AAA", "smte": "\u2AAC", "smtes": "\u2AAC\uFE00", "softcy": "\u044C", "SOFTcy": "\u042C", "sol": "/", "solb": "\u29C4", "solbar": "\u233F", "sopf": "\u{1D564}", "Sopf": "\u{1D54A}", "spades": "\u2660", "spadesuit": "\u2660", "spar": "\u2225", "sqcap": "\u2293", "sqcaps": "\u2293\uFE00", "sqcup": "\u2294", "sqcups": "\u2294\uFE00", "Sqrt": "\u221A", "sqsub": "\u228F", "sqsube": "\u2291", "sqsubset": "\u228F", "sqsubseteq": "\u2291", "sqsup": "\u2290", "sqsupe": "\u2292", "sqsupset": "\u2290", "sqsupseteq": "\u2292", "squ": "\u25A1", "square": "\u25A1", "Square": "\u25A1", "SquareIntersection": "\u2293", "SquareSubset": "\u228F", "SquareSubsetEqual": "\u2291", "SquareSuperset": "\u2290", "SquareSupersetEqual": "\u2292", "SquareUnion": "\u2294", "squarf": "\u25AA", "squf": "\u25AA", "srarr": "\u2192", "sscr": "\u{1D4C8}", "Sscr": "\u{1D4AE}", "ssetmn": "\u2216", "ssmile": "\u2323", "sstarf": "\u22C6", "star": "\u2606", "Star": "\u22C6", "starf": "\u2605", "straightepsilon": "\u03F5", "straightphi": "\u03D5", "strns": "\xAF", "sub": "\u2282", "Sub": "\u22D0", "subdot": "\u2ABD", "sube": "\u2286", "subE": "\u2AC5", "subedot": "\u2AC3", "submult": "\u2AC1", "subne": "\u228A", "subnE": "\u2ACB", "subplus": "\u2ABF", "subrarr": "\u2979", "subset": "\u2282", "Subset": "\u22D0", "subseteq": "\u2286", "subseteqq": "\u2AC5", "SubsetEqual": "\u2286", "subsetneq": "\u228A", "subsetneqq": "\u2ACB", "subsim": "\u2AC7", "subsub": "\u2AD5", "subsup": "\u2AD3", "succ": "\u227B", "succapprox": "\u2AB8", "succcurlyeq": "\u227D", "Succeeds": "\u227B", "SucceedsEqual": "\u2AB0", "SucceedsSlantEqual": "\u227D", "SucceedsTilde": "\u227F", "succeq": "\u2AB0", "succnapprox": "\u2ABA", "succneqq": "\u2AB6", "succnsim": "\u22E9", "succsim": "\u227F", "SuchThat": "\u220B", "sum": "\u2211", "Sum": "\u2211", "sung": "\u266A", "sup": "\u2283", "Sup": "\u22D1", "sup1": "\xB9", "sup2": "\xB2", "sup3": "\xB3", "supdot": "\u2ABE", "supdsub": "\u2AD8", "supe": "\u2287", "supE": "\u2AC6", "supedot": "\u2AC4", "Superset": "\u2283", "SupersetEqual": "\u2287", "suphsol": "\u27C9", "suphsub": "\u2AD7", "suplarr": "\u297B", "supmult": "\u2AC2", "supne": "\u228B", "supnE": "\u2ACC", "supplus": "\u2AC0", "supset": "\u2283", "Supset": "\u22D1", "supseteq": "\u2287", "supseteqq": "\u2AC6", "supsetneq": "\u228B", "supsetneqq": "\u2ACC", "supsim": "\u2AC8", "supsub": "\u2AD4", "supsup": "\u2AD6", "swarhk": "\u2926", "swarr": "\u2199", "swArr": "\u21D9", "swarrow": "\u2199", "swnwar": "\u292A", "szlig": "\xDF", "Tab": "	", "target": "\u2316", "tau": "\u03C4", "Tau": "\u03A4", "tbrk": "\u23B4", "tcaron": "\u0165", "Tcaron": "\u0164", "tcedil": "\u0163", "Tcedil": "\u0162", "tcy": "\u0442", "Tcy": "\u0422", "tdot": "\u20DB", "telrec": "\u2315", "tfr": "\u{1D531}", "Tfr": "\u{1D517}", "there4": "\u2234", "therefore": "\u2234", "Therefore": "\u2234", "theta": "\u03B8", "Theta": "\u0398", "thetasym": "\u03D1", "thetav": "\u03D1", "thickapprox": "\u2248", "thicksim": "\u223C", "ThickSpace": "\u205F\u200A", "thinsp": "\u2009", "ThinSpace": "\u2009", "thkap": "\u2248", "thksim": "\u223C", "thorn": "\xFE", "THORN": "\xDE", "tilde": "\u02DC", "Tilde": "\u223C", "TildeEqual": "\u2243", "TildeFullEqual": "\u2245", "TildeTilde": "\u2248", "times": "\xD7", "timesb": "\u22A0", "timesbar": "\u2A31", "timesd": "\u2A30", "tint": "\u222D", "toea": "\u2928", "top": "\u22A4", "topbot": "\u2336", "topcir": "\u2AF1", "topf": "\u{1D565}", "Topf": "\u{1D54B}", "topfork": "\u2ADA", "tosa": "\u2929", "tprime": "\u2034", "trade": "\u2122", "TRADE": "\u2122", "triangle": "\u25B5", "triangledown": "\u25BF", "triangleleft": "\u25C3", "trianglelefteq": "\u22B4", "triangleq": "\u225C", "triangleright": "\u25B9", "trianglerighteq": "\u22B5", "tridot": "\u25EC", "trie": "\u225C", "triminus": "\u2A3A", "TripleDot": "\u20DB", "triplus": "\u2A39", "trisb": "\u29CD", "tritime": "\u2A3B", "trpezium": "\u23E2", "tscr": "\u{1D4C9}", "Tscr": "\u{1D4AF}", "tscy": "\u0446", "TScy": "\u0426", "tshcy": "\u045B", "TSHcy": "\u040B", "tstrok": "\u0167", "Tstrok": "\u0166", "twixt": "\u226C", "twoheadleftarrow": "\u219E", "twoheadrightarrow": "\u21A0", "uacute": "\xFA", "Uacute": "\xDA", "uarr": "\u2191", "uArr": "\u21D1", "Uarr": "\u219F", "Uarrocir": "\u2949", "ubrcy": "\u045E", "Ubrcy": "\u040E", "ubreve": "\u016D", "Ubreve": "\u016C", "ucirc": "\xFB", "Ucirc": "\xDB", "ucy": "\u0443", "Ucy": "\u0423", "udarr": "\u21C5", "udblac": "\u0171", "Udblac": "\u0170", "udhar": "\u296E", "ufisht": "\u297E", "ufr": "\u{1D532}", "Ufr": "\u{1D518}", "ugrave": "\xF9", "Ugrave": "\xD9", "uHar": "\u2963", "uharl": "\u21BF", "uharr": "\u21BE", "uhblk": "\u2580", "ulcorn": "\u231C", "ulcorner": "\u231C", "ulcrop": "\u230F", "ultri": "\u25F8", "umacr": "\u016B", "Umacr": "\u016A", "uml": "\xA8", "UnderBar": "_", "UnderBrace": "\u23DF", "UnderBracket": "\u23B5", "UnderParenthesis": "\u23DD", "Union": "\u22C3", "UnionPlus": "\u228E", "uogon": "\u0173", "Uogon": "\u0172", "uopf": "\u{1D566}", "Uopf": "\u{1D54C}", "uparrow": "\u2191", "Uparrow": "\u21D1", "UpArrow": "\u2191", "UpArrowBar": "\u2912", "UpArrowDownArrow": "\u21C5", "updownarrow": "\u2195", "Updownarrow": "\u21D5", "UpDownArrow": "\u2195", "UpEquilibrium": "\u296E", "upharpoonleft": "\u21BF", "upharpoonright": "\u21BE", "uplus": "\u228E", "UpperLeftArrow": "\u2196", "UpperRightArrow": "\u2197", "upsi": "\u03C5", "Upsi": "\u03D2", "upsih": "\u03D2", "upsilon": "\u03C5", "Upsilon": "\u03A5", "UpTee": "\u22A5", "UpTeeArrow": "\u21A5", "upuparrows": "\u21C8", "urcorn": "\u231D", "urcorner": "\u231D", "urcrop": "\u230E", "uring": "\u016F", "Uring": "\u016E", "urtri": "\u25F9", "uscr": "\u{1D4CA}", "Uscr": "\u{1D4B0}", "utdot": "\u22F0", "utilde": "\u0169", "Utilde": "\u0168", "utri": "\u25B5", "utrif": "\u25B4", "uuarr": "\u21C8", "uuml": "\xFC", "Uuml": "\xDC", "uwangle": "\u29A7", "vangrt": "\u299C", "varepsilon": "\u03F5", "varkappa": "\u03F0", "varnothing": "\u2205", "varphi": "\u03D5", "varpi": "\u03D6", "varpropto": "\u221D", "varr": "\u2195", "vArr": "\u21D5", "varrho": "\u03F1", "varsigma": "\u03C2", "varsubsetneq": "\u228A\uFE00", "varsubsetneqq": "\u2ACB\uFE00", "varsupsetneq": "\u228B\uFE00", "varsupsetneqq": "\u2ACC\uFE00", "vartheta": "\u03D1", "vartriangleleft": "\u22B2", "vartriangleright": "\u22B3", "vBar": "\u2AE8", "Vbar": "\u2AEB", "vBarv": "\u2AE9", "vcy": "\u0432", "Vcy": "\u0412", "vdash": "\u22A2", "vDash": "\u22A8", "Vdash": "\u22A9", "VDash": "\u22AB", "Vdashl": "\u2AE6", "vee": "\u2228", "Vee": "\u22C1", "veebar": "\u22BB", "veeeq": "\u225A", "vellip": "\u22EE", "verbar": "|", "Verbar": "\u2016", "vert": "|", "Vert": "\u2016", "VerticalBar": "\u2223", "VerticalLine": "|", "VerticalSeparator": "\u2758", "VerticalTilde": "\u2240", "VeryThinSpace": "\u200A", "vfr": "\u{1D533}", "Vfr": "\u{1D519}", "vltri": "\u22B2", "vnsub": "\u2282\u20D2", "vnsup": "\u2283\u20D2", "vopf": "\u{1D567}", "Vopf": "\u{1D54D}", "vprop": "\u221D", "vrtri": "\u22B3", "vscr": "\u{1D4CB}", "Vscr": "\u{1D4B1}", "vsubne": "\u228A\uFE00", "vsubnE": "\u2ACB\uFE00", "vsupne": "\u228B\uFE00", "vsupnE": "\u2ACC\uFE00", "Vvdash": "\u22AA", "vzigzag": "\u299A", "wcirc": "\u0175", "Wcirc": "\u0174", "wedbar": "\u2A5F", "wedge": "\u2227", "Wedge": "\u22C0", "wedgeq": "\u2259", "weierp": "\u2118", "wfr": "\u{1D534}", "Wfr": "\u{1D51A}", "wopf": "\u{1D568}", "Wopf": "\u{1D54E}", "wp": "\u2118", "wr": "\u2240", "wreath": "\u2240", "wscr": "\u{1D4CC}", "Wscr": "\u{1D4B2}", "xcap": "\u22C2", "xcirc": "\u25EF", "xcup": "\u22C3", "xdtri": "\u25BD", "xfr": "\u{1D535}", "Xfr": "\u{1D51B}", "xharr": "\u27F7", "xhArr": "\u27FA", "xi": "\u03BE", "Xi": "\u039E", "xlarr": "\u27F5", "xlArr": "\u27F8", "xmap": "\u27FC", "xnis": "\u22FB", "xodot": "\u2A00", "xopf": "\u{1D569}", "Xopf": "\u{1D54F}", "xoplus": "\u2A01", "xotime": "\u2A02", "xrarr": "\u27F6", "xrArr": "\u27F9", "xscr": "\u{1D4CD}", "Xscr": "\u{1D4B3}", "xsqcup": "\u2A06", "xuplus": "\u2A04", "xutri": "\u25B3", "xvee": "\u22C1", "xwedge": "\u22C0", "yacute": "\xFD", "Yacute": "\xDD", "yacy": "\u044F", "YAcy": "\u042F", "ycirc": "\u0177", "Ycirc": "\u0176", "ycy": "\u044B", "Ycy": "\u042B", "yen": "\xA5", "yfr": "\u{1D536}", "Yfr": "\u{1D51C}", "yicy": "\u0457", "YIcy": "\u0407", "yopf": "\u{1D56A}", "Yopf": "\u{1D550}", "yscr": "\u{1D4CE}", "Yscr": "\u{1D4B4}", "yucy": "\u044E", "YUcy": "\u042E", "yuml": "\xFF", "Yuml": "\u0178", "zacute": "\u017A", "Zacute": "\u0179", "zcaron": "\u017E", "Zcaron": "\u017D", "zcy": "\u0437", "Zcy": "\u0417", "zdot": "\u017C", "Zdot": "\u017B", "zeetrf": "\u2128", "ZeroWidthSpace": "\u200B", "zeta": "\u03B6", "Zeta": "\u0396", "zfr": "\u{1D537}", "Zfr": "\u2128", "zhcy": "\u0436", "ZHcy": "\u0416", "zigrarr": "\u21DD", "zopf": "\u{1D56B}", "Zopf": "\u2124", "zscr": "\u{1D4CF}", "Zscr": "\u{1D4B5}", "zwj": "\u200D", "zwnj": "\u200C" };
    var decodeMapLegacy = { "aacute": "\xE1", "Aacute": "\xC1", "acirc": "\xE2", "Acirc": "\xC2", "acute": "\xB4", "aelig": "\xE6", "AElig": "\xC6", "agrave": "\xE0", "Agrave": "\xC0", "amp": "&", "AMP": "&", "aring": "\xE5", "Aring": "\xC5", "atilde": "\xE3", "Atilde": "\xC3", "auml": "\xE4", "Auml": "\xC4", "brvbar": "\xA6", "ccedil": "\xE7", "Ccedil": "\xC7", "cedil": "\xB8", "cent": "\xA2", "copy": "\xA9", "COPY": "\xA9", "curren": "\xA4", "deg": "\xB0", "divide": "\xF7", "eacute": "\xE9", "Eacute": "\xC9", "ecirc": "\xEA", "Ecirc": "\xCA", "egrave": "\xE8", "Egrave": "\xC8", "eth": "\xF0", "ETH": "\xD0", "euml": "\xEB", "Euml": "\xCB", "frac12": "\xBD", "frac14": "\xBC", "frac34": "\xBE", "gt": ">", "GT": ">", "iacute": "\xED", "Iacute": "\xCD", "icirc": "\xEE", "Icirc": "\xCE", "iexcl": "\xA1", "igrave": "\xEC", "Igrave": "\xCC", "iquest": "\xBF", "iuml": "\xEF", "Iuml": "\xCF", "laquo": "\xAB", "lt": "<", "LT": "<", "macr": "\xAF", "micro": "\xB5", "middot": "\xB7", "nbsp": "\xA0", "not": "\xAC", "ntilde": "\xF1", "Ntilde": "\xD1", "oacute": "\xF3", "Oacute": "\xD3", "ocirc": "\xF4", "Ocirc": "\xD4", "ograve": "\xF2", "Ograve": "\xD2", "ordf": "\xAA", "ordm": "\xBA", "oslash": "\xF8", "Oslash": "\xD8", "otilde": "\xF5", "Otilde": "\xD5", "ouml": "\xF6", "Ouml": "\xD6", "para": "\xB6", "plusmn": "\xB1", "pound": "\xA3", "quot": '"', "QUOT": '"', "raquo": "\xBB", "reg": "\xAE", "REG": "\xAE", "sect": "\xA7", "shy": "\xAD", "sup1": "\xB9", "sup2": "\xB2", "sup3": "\xB3", "szlig": "\xDF", "thorn": "\xFE", "THORN": "\xDE", "times": "\xD7", "uacute": "\xFA", "Uacute": "\xDA", "ucirc": "\xFB", "Ucirc": "\xDB", "ugrave": "\xF9", "Ugrave": "\xD9", "uml": "\xA8", "uuml": "\xFC", "Uuml": "\xDC", "yacute": "\xFD", "Yacute": "\xDD", "yen": "\xA5", "yuml": "\xFF" };
    var decodeMapNumeric = { "0": "\uFFFD", "128": "\u20AC", "130": "\u201A", "131": "\u0192", "132": "\u201E", "133": "\u2026", "134": "\u2020", "135": "\u2021", "136": "\u02C6", "137": "\u2030", "138": "\u0160", "139": "\u2039", "140": "\u0152", "142": "\u017D", "145": "\u2018", "146": "\u2019", "147": "\u201C", "148": "\u201D", "149": "\u2022", "150": "\u2013", "151": "\u2014", "152": "\u02DC", "153": "\u2122", "154": "\u0161", "155": "\u203A", "156": "\u0153", "158": "\u017E", "159": "\u0178" };
    var invalidReferenceCodePoints = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65e3, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111];
    var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object2, propertyName) {
      return hasOwnProperty.call(object2, propertyName);
    };
    var contains = function(array, value) {
      var index2 = -1;
      var length = array.length;
      while (++index2 < length) {
        if (array[index2] == value) {
          return true;
        }
      }
      return false;
    };
    var merge2 = function(options, defaults2) {
      if (!options) {
        return defaults2;
      }
      var result = {};
      var key2;
      for (key2 in defaults2) {
        result[key2] = has(options, key2) ? options[key2] : defaults2[key2];
      }
      return result;
    };
    var codePointToSymbol = function(codePoint, strict) {
      var output = "";
      if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
        if (strict) {
          parseError("character reference outside the permissible Unicode range");
        }
        return "\uFFFD";
      }
      if (has(decodeMapNumeric, codePoint)) {
        if (strict) {
          parseError("disallowed character reference");
        }
        return decodeMapNumeric[codePoint];
      }
      if (strict && contains(invalidReferenceCodePoints, codePoint)) {
        parseError("disallowed character reference");
      }
      if (codePoint > 65535) {
        codePoint -= 65536;
        output += stringFromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      output += stringFromCharCode(codePoint);
      return output;
    };
    var hexEscape = function(codePoint) {
      return "&#x" + codePoint.toString(16).toUpperCase() + ";";
    };
    var decEscape = function(codePoint) {
      return "&#" + codePoint + ";";
    };
    var parseError = function(message) {
      throw Error("Parse error: " + message);
    };
    var encode2 = function(string, options) {
      options = merge2(options, encode2.options);
      var strict = options.strict;
      if (strict && regexInvalidRawCodePoint.test(string)) {
        parseError("forbidden code point");
      }
      var encodeEverything = options.encodeEverything;
      var useNamedReferences = options.useNamedReferences;
      var allowUnsafeSymbols = options.allowUnsafeSymbols;
      var escapeCodePoint = options.decimal ? decEscape : hexEscape;
      var escapeBmpSymbol = function(symbol) {
        return escapeCodePoint(symbol.charCodeAt(0));
      };
      if (encodeEverything) {
        string = string.replace(regexAsciiWhitelist, function(symbol) {
          if (useNamedReferences && has(encodeMap, symbol)) {
            return "&" + encodeMap[symbol] + ";";
          }
          return escapeBmpSymbol(symbol);
        });
        if (useNamedReferences) {
          string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;");
        }
        if (useNamedReferences) {
          string = string.replace(regexEncodeNonAscii, function(string2) {
            return "&" + encodeMap[string2] + ";";
          });
        }
      } else if (useNamedReferences) {
        if (!allowUnsafeSymbols) {
          string = string.replace(regexEscape, function(string2) {
            return "&" + encodeMap[string2] + ";";
          });
        }
        string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;");
        string = string.replace(regexEncodeNonAscii, function(string2) {
          return "&" + encodeMap[string2] + ";";
        });
      } else if (!allowUnsafeSymbols) {
        string = string.replace(regexEscape, escapeBmpSymbol);
      }
      return string.replace(regexAstralSymbols, function($0) {
        var high = $0.charCodeAt(0);
        var low = $0.charCodeAt(1);
        var codePoint = (high - 55296) * 1024 + low - 56320 + 65536;
        return escapeCodePoint(codePoint);
      }).replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    encode2.options = {
      "allowUnsafeSymbols": false,
      "encodeEverything": false,
      "strict": false,
      "useNamedReferences": false,
      "decimal": false
    };
    var decode = function(html, options) {
      options = merge2(options, decode.options);
      var strict = options.strict;
      if (strict && regexInvalidEntity.test(html)) {
        parseError("malformed character reference");
      }
      return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
        var codePoint;
        var semicolon;
        var decDigits;
        var hexDigits;
        var reference;
        var next;
        if ($1) {
          reference = $1;
          return decodeMap[reference];
        }
        if ($2) {
          reference = $2;
          next = $3;
          if (next && options.isAttributeValue) {
            if (strict && next == "=") {
              parseError("`&` did not start a character reference");
            }
            return $0;
          } else {
            if (strict) {
              parseError(
                "named character reference was not terminated by a semicolon"
              );
            }
            return decodeMapLegacy[reference] + (next || "");
          }
        }
        if ($4) {
          decDigits = $4;
          semicolon = $5;
          if (strict && !semicolon) {
            parseError("character reference was not terminated by a semicolon");
          }
          codePoint = parseInt(decDigits, 10);
          return codePointToSymbol(codePoint, strict);
        }
        if ($6) {
          hexDigits = $6;
          semicolon = $7;
          if (strict && !semicolon) {
            parseError("character reference was not terminated by a semicolon");
          }
          codePoint = parseInt(hexDigits, 16);
          return codePointToSymbol(codePoint, strict);
        }
        if (strict) {
          parseError(
            "named character reference was not terminated by a semicolon"
          );
        }
        return $0;
      });
    };
    decode.options = {
      "isAttributeValue": false,
      "strict": false
    };
    var escape = function(string) {
      return string.replace(regexEscape, function($0) {
        return escapeMap[$0];
      });
    };
    var he2 = {
      "version": "1.2.0",
      "encode": encode2,
      "decode": decode,
      "escape": escape,
      "unescape": decode
    };
    if (freeExports && !freeExports.nodeType) {
      if (freeModule) {
        freeModule.exports = he2;
      } else {
        for (var key in he2) {
          has(he2, key) && (freeExports[key] = he2[key]);
        }
      }
    } else {
      root.he = he2;
    }
  })(commonjsGlobal);
})(he$1, he$1.exports);
var he = he$1.exports;
function titleCase(str) {
  const splitStr = str.toLowerCase().split("_").join(" ").split(" ");
  return splitStr.map((s3) => s3.charAt(0).toUpperCase() + s3.substring(1)).join(" ");
}
function decodeString(str) {
  return he.decode(str);
}
function divideArray(a3, s3) {
  return Array(Math.ceil(a3.length / s3)).fill().map((_2, i2) => a3.slice(i2 * s3, i2 * s3 + s3));
}
const DEFAULT_ITEM_SIZE = Size.medium;
const DEFAULT_BUFFER_SIZE = 5;
const DEFAULT_CONFIG$3 = {
  actions: {
    edit: false,
    create: false,
    add: false,
    remove: false,
    search: false,
    remote: false,
    toggle: false
  },
  buffer: {
    offload: true,
    size: DEFAULT_BUFFER_SIZE,
    resolve: 0
  },
  unique: true,
  replace: false,
  draft: false,
  fields: {
    sys: "sys",
    data: "",
    title: ""
  },
  links: {
    base: "/"
  },
  labels: {
    add: "Add new",
    search: "Add Existing",
    remove: "Remove"
  },
  debug: {
    sys: false,
    verbose: false
  }
};
const DEFAULT_ITEM_PROPS = {
  size: Size.small,
  config: {
    fields: {
      data: "",
      sys: "sys"
    },
    debug: {
      sys: false,
      verbose: false
    },
    links: {
      base: "/",
      path: "",
      query: ""
    },
    actions: {
      edit: false,
      remove: false,
      duplicate: false,
      confirm: ["remove"]
    },
    lazy: false
  },
  highlight: "type",
  draggable: false
};
const DEFAULT_FILTER_CONFIG = {
  show: true,
  fields: [],
  query: null
};
var config = {
  DEFAULT_ITEM_SIZE,
  DEFAULT_CONFIG: DEFAULT_CONFIG$3,
  DEFAULT_ITEM_PROPS,
  DEFAULT_FILTER_CONFIG,
  DEFAULT_BUFFER_SIZE
};
function setStatus(e2, status) {
  try {
    if (!e2.sys)
      throw Error("Entry has no sys");
    e2.sys[status] = true;
    return e2;
  } catch (error) {
    throw Error(error);
  }
}
function isReactiveBuffer(b2) {
  return "ledger" in b2;
}
function useEntryActions(request2, active, emit, contentType, requestOptions) {
  const buffer = reactive({
    view: computed({
      get() {
        return buffer.resolved.concat(buffer.loading).concat(buffer.failed);
      },
      set(value) {
        return buffer.resolved = value;
      }
    }),
    pending: [],
    resolved: [],
    loading: [],
    failed: [],
    resolve: (entries) => {
      const items = entries.filter((i2) => buffer.view.findIndex((v) => {
        var _a;
        return ((_a = v.sys) == null ? void 0 : _a.id) === i2.id;
      }) < 0 && buffer.pending.indexOf(i2.id) < 0);
      return Promise.all(items.map((i2) => resolveBuffered(i2.id)));
    },
    ledger: {
      _data: [],
      get() {
        return this._data;
      },
      chunkAt(index2, size) {
        const start = Math.max(index2, 0) * size;
        return this._data.slice(start, size + start);
      },
      chunkAround(index2, size, count = config.DEFAULT_BUFFER_SIZE) {
        const start = Math.max(index2, 0) * size;
        const bufferSize = size * count;
        return this._data.slice(Math.max(start - bufferSize, 0), size + (start + bufferSize * 2));
      },
      cleanAround: debounce((chunk, size, chunks) => {
        const indices = buffer.ledger.chunkAround(chunk, size, chunks).map((i2) => i2.id);
        buffer.resolved.forEach((entry, i2) => {
          if (!indices.includes(entry.sys.id))
            buffer.resolved.splice(i2, 1);
        });
      }, 1e3),
      set(values, uniq = true) {
        if (!Array.isArray(values)) {
          if (this._data.findIndex((i2) => i2.id === values) >= 0 && uniq)
            return;
          this._data.unshift({ id: values, index: this._data.length });
        } else {
          this._data = this._data.concat(values.filter((id) => uniq ? this._data.findIndex((n) => n.id === id) < 0 : true).map((id, i2) => ({ id, index: i2 + this._data.length })));
        }
      },
      unset(index2) {
        if (index2 >= 0)
          this._data.splice(index2, 1);
      },
      clear() {
        this._data.length = 0;
      }
    }
  });
  const processing = ref(false);
  function spliceBuffer(ids) {
    return Promise.all(ids.map(async (id) => {
      try {
        const pi = buffer.pending.indexOf(id);
        const ri = buffer.resolved.findIndex((r) => {
          var _a;
          return ((_a = r.sys) == null ? void 0 : _a.id) === id;
        });
        const li = buffer.loading.findIndex((l) => {
          var _a;
          return ((_a = l.sys) == null ? void 0 : _a.id) === id;
        });
        const lei = buffer.ledger._data.findIndex((i2) => i2.id === id);
        if (pi >= 0)
          buffer.pending.splice(pi, 1);
        if (ri >= 0)
          buffer.resolved.splice(ri, 1);
        if (li >= 0)
          buffer.loading.splice(li, 1);
        buffer.ledger.unset(lei);
        return true;
      } catch (e2) {
        console.warn("spliceBuffer Error: ", e2);
        return false;
      }
    }));
  }
  async function clearBuffer() {
    buffer.pending.length = 0;
    buffer.resolved.length = 0;
    buffer.loading.length = 0;
    buffer.failed.length = 0;
    buffer.ledger.clear();
    return Promise.resolve(buffer);
  }
  async function updateBufferWith(values, opts) {
    var _a;
    try {
      const { spliceDiff = true, offload = true, uniq = true } = opts || {};
      const items = _.castArray(values);
      const ids = items.map((e2) => {
        var _a2;
        return !isEntry(e2) ? e2 : (_a2 = e2.sys) == null ? void 0 : _a2.id;
      });
      const bufferedIds = buffer.ledger._data.map((i2) => i2.id);
      const spliceIds = bufferedIds.filter((i2) => ids.indexOf(i2) < 0);
      if (spliceDiff)
        await spliceBuffer(spliceIds);
      (_a = buffer.resolved) == null ? void 0 : _a.forEach((buffered, index2) => {
        if (typeof buffered === "string")
          return;
        const item = items.find((i2) => {
          var _a2, _b;
          return typeof i2 == "string" ? false : ((_a2 = i2.sys) == null ? void 0 : _a2.id) === ((_b = buffered == null ? void 0 : buffered.sys) == null ? void 0 : _b.id);
        });
        if (!item)
          return;
        Object.keys(buffer.resolved[index2]).forEach((key) => {
          if (item[key])
            buffer.resolved[index2][key] = item[key];
        });
      });
      if (!offload) {
        items.filter((e2) => {
          var _a2;
          return bufferedIds.indexOf(!isEntry(e2) ? e2 : (_a2 = e2.sys) == null ? void 0 : _a2.id) < 0;
        }).forEach(resolveBuffered);
      } else {
        buffer.ledger.set(items.filter((e2) => {
          var _a2;
          return bufferedIds.indexOf(!isEntry(e2) ? e2 : (_a2 = e2.sys) == null ? void 0 : _a2.id) < 0;
        }).map((e2) => {
          var _a2;
          return isEntry(e2) ? (_a2 = e2.sys) == null ? void 0 : _a2.id : e2;
        }), uniq);
      }
      return Promise.resolve(buffer);
    } catch (e2) {
      throw Error(e2.toString() || "Unknown error during buffer update");
    }
  }
  async function save() {
    console.log("Saving...", active);
    let validated;
    try {
      if (!active || !active.value)
        throw Error("No active object was passed to EntryActions");
      if (typeof active.value.entry === "string")
        return Promise.reject(Error("Entry has not loaded"));
      processing.value = true;
      const entry = active.value.entry;
      Object.keys(active.value.model).forEach((key) => {
        const field = active ? active.value.model[key].field || "" : "";
        if (["link", "link-list"].includes(active ? active.value.model[key].type : "")) {
          entry[field] = Array.isArray(entry[field]) ? entry[field].map((n) => n && typeof n === "object" ? n.sys.id : n).filter((f2) => !!f2) : entry[field] && typeof entry[field] === "object" ? entry[field].sys.id : entry[field];
        }
        if (["single", "tag", "select", "multi-select", "dropdown"].includes(active ? active.value.model[key].type : "")) {
          entry[field] = Array.isArray(entry[field]) ? entry[field].map((e2) => e2.value || e2.label || e2) : entry[field].value || entry[field].label || entry[field];
        }
      });
      validated = Object.keys(active.value.model).map((key) => {
        if (!active || !active.value)
          throw Error("Undefined active object encountered while validating fields");
        const m3 = active.value.model[key];
        let validated2 = m3.validator(entry[m3.field || ""]);
        if (m3.required && entry[m3.field || ""] === void 0 && validated2 !== true)
          validated2 = false;
        return { field: m3.field, value: validated2 };
      });
      if (validated.every((v) => v.value === true)) {
        if (request2) {
          if (!request2.patch && !request2.put)
            throw Error('The passed request handler object does not implement a "patch" or "put" method');
          if (!request2.patch)
            console.log("No patch method implemented, will default to put...");
          const update = active.value.isDraft ? request2.put : request2.patch || request2.put;
          const { items = [] } = await update(entry.sys.id || entry.sys.type || contentType, entry.sys.id ? entry : (requestOptions == null ? void 0 : requestOptions.idField) && entry[requestOptions == null ? void 0 : requestOptions.idField] ? [{ field: requestOptions == null ? void 0 : requestOptions.idField, method: "is", match: entry[requestOptions == null ? void 0 : requestOptions.idField] }] : void 0, entry.sys.id ? void 0 : entry);
          active.value.entry = applyModelDefaults(items[0], active.value.model);
        }
        if (emit)
          emit("save", active);
        processing.value = false;
        return Promise.resolve(active.value);
      } else {
        return Promise.reject(validated);
      }
    } catch (e2) {
      processing.value = false;
      return Promise.reject(e2);
    }
  }
  async function remove() {
    var _a, _b;
    try {
      processing.value = true;
      const entry = active == null ? void 0 : active.value.entry;
      if (request2 && entry) {
        const deleteHandler = request2.delete;
        if (!((_a = entry.sys) == null ? void 0 : _a.id))
          throw Error("Entry has no sys.id. cannot delete");
        if ((_b = entry.sys) == null ? void 0 : _b.draft)
          throw Error("Entry has a draft flag. cannot delete");
        const deleted = await deleteHandler(entry.sys.id);
        console.log("deleted entry", deleted);
      }
      if (emit)
        emit("delete", entry.sys.id);
      processing.value = false;
    } catch (e2) {
      console.error("Error during entry delete", e2);
    }
  }
  async function resolve(uuid2, type) {
    try {
      if (!request2.resolve && !request2.get)
        throw Error('The passed request handler object does not implement a "resolve" or "get" method');
      processing.value = true;
      let e2;
      if (request2.resolve) {
        const uuidChunks = divideArray(_.castArray(uuid2), 100);
        e2 = await Promise.all(uuidChunks.map((chunk) => request2.resolve(chunk, type || contentType, { select: requestOptions == null ? void 0 : requestOptions.select, ...(requestOptions == null ? void 0 : requestOptions.resolve) ? { resolve: requestOptions == null ? void 0 : requestOptions.resolve } : {} })));
        if (e2) {
          e2 = e2.reduce((result, next) => {
            var _a;
            result.items = result.items.concat(next.items || []);
            if (!result.sys)
              result.sys = next.sys || {};
            result.sys.count = result.sys.count + ((_a = next.sys) == null ? void 0 : _a.count);
            return result;
          }, { items: [] });
        }
      } else if (request2.get) {
        e2 = await request2.get(contentType || "id", [{ field: "sys.id", match: uuid2 }, ...(requestOptions == null ? void 0 : requestOptions.select) ? [{ select: requestOptions == null ? void 0 : requestOptions.select }] : []], (requestOptions == null ? void 0 : requestOptions.resolve) ? { resolve: requestOptions == null ? void 0 : requestOptions.resolve } : {});
      }
      processing.value = false;
      return Promise.resolve(e2);
    } catch (e2) {
      processing.value = false;
      const failedIds = _.castArray(uuid2);
      failedIds.forEach((id) => {
        const failedIndex = buffer.failed.findIndex((i2) => {
          var _a;
          return ((_a = i2.sys) == null ? void 0 : _a.id) === id;
        });
        if (failedIndex < 0)
          buffer.failed.push({ sys: { id, error: e2, loading: false } });
        else
          buffer.failed.splice(failedIndex, 1, { sys: { id, error: e2, loading: false } });
      });
      return Promise.reject(e2);
    }
  }
  function resolvePending(id) {
    if (!buffer.pending.includes(id) && buffer.loading.findIndex((i2) => {
      var _a;
      return ((_a = i2.sys) == null ? void 0 : _a.id) === id;
    }) < 0 && buffer.failed.findIndex((i2) => {
      var _a;
      return ((_a = i2.sys) == null ? void 0 : _a.id) === id;
    }) < 0)
      buffer.pending.push(id);
    buffer.ledger.set(id);
    return debouncedResolveHandler();
  }
  const debouncedResolveHandler = _.debounce(async function() {
    const ids = [...buffer.pending];
    try {
      buffer.pending = _.xor(ids, buffer.pending);
      ids.forEach((id) => buffer.loading.push({ sys: { id, loading: true, type: "unknown" } }));
      const { items } = await resolve(ids);
      buffer.resolved = buffer.resolved.concat(items.map((i2) => setStatus(i2, EntryStatus.loaded)));
    } catch (e2) {
      console.error("EntryActions.resolveEntries: ", e2);
      return Promise.reject(e2);
    } finally {
      ids.forEach((id) => {
        const i2 = buffer.loading.findIndex((l) => {
          var _a;
          return ((_a = l.sys) == null ? void 0 : _a.id) === id;
        });
        if (i2 >= 0)
          buffer.loading.splice(i2);
      });
    }
  }, 200, { maxWait: 1e3 });
  async function resolveBuffered(e2, uniq) {
    if (isEntry(e2) && (!e2.sys.reload || e2.sys.loaded)) {
      const index2 = buffer.resolved.findIndex((b2) => {
        var _a;
        return ((_a = b2.sys) == null ? void 0 : _a.id) === e2.sys.id;
      });
      if (index2 >= 0)
        buffer.resolved.splice(index2, 1, setStatus(e2, EntryStatus.loaded));
      else
        buffer.resolved.push(setStatus(e2, EntryStatus.loaded));
      buffer.ledger.set(e2.sys.id, uniq !== void 0 ? uniq : true);
      return e2;
    }
    processing.value = true;
    const id = isEntry(e2) ? e2.sys.id : e2;
    if (buffer.loading.findIndex((l) => {
      var _a;
      return ((_a = l.sys) == null ? void 0 : _a.id) === id;
    }) >= 0)
      return;
    try {
      resolvePending(id);
      processing.value = false;
      return { sys: { id, loading: true } };
    } catch (e22) {
      console.error("ResolveBuffered Error", e22);
      processing.value = false;
      const failedIndex = buffer.failed.findIndex((i2) => {
        var _a;
        return ((_a = i2.sys) == null ? void 0 : _a.id) === id;
      });
      if (failedIndex < 0)
        buffer.failed.push({ sys: { id, error: e22, loading: false } });
      else
        buffer.failed.splice(failedIndex, 1, { sys: { id, error: e22, loading: false } });
      return { sys: { id, error: e22, loading: false } };
    }
  }
  return {
    resolve,
    resolveBuffered,
    updateBufferWith,
    spliceBuffer,
    clearBuffer,
    processing,
    buffer: toRefs(buffer),
    save,
    remove,
    setActive: (e2, replace = false) => {
      if (active && replace)
        active.value = e2;
      else if (active && !replace)
        active.value.entry = e2;
      else
        active = ref(e2);
    }
  };
}
function useColumns(columns) {
  const DEFAULT_COLUMNS_ARR = [12, 12, 12];
  const colArray = computed(() => !columns ? DEFAULT_COLUMNS_ARR : Array.isArray(columns) ? columns : [columns, columns, columns]);
  return {
    colArray
  };
}
var SpinnerType = /* @__PURE__ */ ((SpinnerType2) => {
  SpinnerType2["Ozone"] = "ozone";
  SpinnerType2["Ripple"] = "ripple";
  SpinnerType2["Ellipsis"] = "ellipsis";
  return SpinnerType2;
})(SpinnerType || {});
const _sfc_main$j = defineComponent({
  name: "Spinner",
  props: {
    visible: {
      type: Boolean
    },
    type: {
      type: String,
      default: "ozone"
    },
    mode: {
      type: String,
      default: "light"
    },
    scale: {
      type: Number,
      default: 1
    },
    delayedMessage: {
      type: String
    }
  },
  setup() {
    return {};
  }
});
const _hoisted_1$m = /* @__PURE__ */ createElementVNode("div", null, null, -1);
const _hoisted_2$k = /* @__PURE__ */ createElementVNode("div", null, null, -1);
const _hoisted_3$h = /* @__PURE__ */ createElementVNode("div", null, null, -1);
const _hoisted_4$c = /* @__PURE__ */ createElementVNode("div", null, null, -1);
const _hoisted_5$9 = ["data-message"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "ozn-spinner--container",
    style: normalizeStyle({ marginTop: `-${Math.log(100 * _ctx.scale) * 5}px` })
  }, [
    _ctx.visible ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass([`ozn-spinner--${_ctx.type}`, `ozn-spinner--${_ctx.mode}`]),
      style: normalizeStyle({ transform: `scale(${_ctx.scale})`, width: `${120 * _ctx.scale - 20 * _ctx.scale}px`, height: `${120 * _ctx.scale - 20 * _ctx.scale}px` })
    }, [
      _hoisted_1$m,
      createTextVNode(),
      _hoisted_2$k,
      createTextVNode(),
      _hoisted_3$h,
      createTextVNode(),
      _hoisted_4$c
    ], 6)) : createCommentVNode("", true),
    _ctx.delayedMessage ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "ozn-spinner--delay-message",
      "data-message": _ctx.delayedMessage
    }, null, 8, _hoisted_5$9)) : createCommentVNode("", true)
  ], 4);
}
var Spinner = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$h]]);
const _sfc_main$i = defineComponent({
  name: "OznButton",
  props: {
    id: {
      type: String,
      default: `${Date.now().toString(32)}-${Math.random() * 100}`
    },
    label: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderStyle: {
      type: String,
      default: SpinnerType.Ozone
    },
    size: {
      type: String,
      default: Size.sm
    },
    fullWidth: {
      type: Boolean
    },
    flat: {
      type: Boolean
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const additionalClasses = computed(() => {
      return {
        [`ozn-btn--${props.size}`]: true,
        "ozn-btn--full-width": props.fullWidth,
        "ozn-btn--flat": props.flat
      };
    });
    function handleClick($event) {
      emit("click", $event);
    }
    return {
      additionalClasses,
      handleClick
    };
  }
});
const _hoisted_1$l = ["id"];
const _hoisted_2$j = { class: "ozn-btn__content" };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_spinner = resolveComponent("spinner");
  return openBlock(), createElementBlock("button", {
    id: `ozn-btn__${_ctx.id}`,
    class: normalizeClass(["ozn-btn", _ctx.additionalClasses]),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClick && _ctx.handleClick(...args))
  }, [
    _ctx.loading ? renderSlot(_ctx.$slots, "loader", { key: 0 }, () => [
      createVNode(_component_spinner, {
        class: "ozn-btn__loader-animation",
        scale: 0.3,
        type: _ctx.loaderStyle,
        visible: _ctx.loading,
        style: { "margin": "-13px 0 -4px -15px" }
      }, null, 8, ["scale", "type", "visible"])
    ]) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default", {}, () => [
      createElementVNode("span", _hoisted_2$j, toDisplayString(_ctx.label), 1)
    ])
  ], 10, _hoisted_1$l);
}
var OznButton = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$g]]);
const DEFAULT_CONFIG$2 = {
  fields: {
    data: "",
    sys: "sys"
  },
  debug: {
    sys: false,
    verbose: false
  },
  actions: {
    edit: false,
    remove: false,
    duplicate: false,
    confirm: ["remove"]
  },
  lazy: false
};
const _sfc_main$h = defineComponent({
  name: "EntryItem",
  components: { OznButton },
  props: {
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    index: {
      type: Number
    },
    entry: {
      type: [Object, String],
      default: () => {
        return {};
      }
    },
    contentType: {
      type: String,
      required: false,
      default: null
    },
    config: {
      type: Object,
      default: () => DEFAULT_CONFIG$2
    },
    label: {
      type: String,
      default: null
    },
    highlight: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Size.sm
    },
    request: {
      type: Object,
      default: () => new RequestHandler()
    },
    readonly: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    loaderStyle: {
      type: String,
      default: SpinnerType.Ozone
    }
  },
  emits: [
    "loaded",
    "remove",
    "activate",
    "deactivate",
    "select",
    "replace",
    "expand",
    "show-overlay",
    "hide-overlay",
    "dragstart",
    "dragend",
    "dragover",
    "dragenter",
    "dragleave"
  ],
  setup(props, { emit }) {
    const sizeState = ref(props.size || Size.sm);
    const highlightState = ref(false);
    const additionalClasses = computed(() => {
      return {
        [`ozn-entry-item--${(sizeState == null ? void 0 : sizeState.value) || props.size}`]: !!((sizeState == null ? void 0 : sizeState.value) || props.size),
        ["ozn-entry-item--active"]: props.active,
        ["ozn-entry-item--highlight"]: props.highlight || (highlightState == null ? void 0 : highlightState.value),
        ["ozn-entry-item--placeholder"]: state.resolvedEntry && state.resolvedEntry.sys && state.resolvedEntry.sys.empty,
        [state.mountClass]: !!state.mountClass
      };
    });
    const wrapperClasses = computed(() => {
      return {
        [`ozn-entry-item__wrapper--${(sizeState == null ? void 0 : sizeState.value) || props.size}`]: !!((sizeState == null ? void 0 : sizeState.value) || props.size),
        ["ozn-entry-item__wrapper--active"]: props.active,
        ["ozn-entry-item__wrapper--highlight"]: props.highlight || (highlightState == null ? void 0 : highlightState.value),
        ["ozn-entry-item__wrapper--placeholder"]: state.resolvedEntry && state.resolvedEntry.sys && state.resolvedEntry.sys.empty,
        ["ozn-entry-item__wrapper--editing"]: activity.entry.editing,
        ["ozn-entry-item__wrapper--confirming"]: activity.entry.confirming,
        ["ozn-entry-item__wrapper--removing"]: activity.entry.removing,
        ["ozn-entry-item__wrapper--overlay-showing"]: !activity.overlay.hide
      };
    });
    const parsedConfig = _.defaultsDeep(props.config, DEFAULT_CONFIG$2);
    const { resolve: resolveEntry } = useEntryActions(props.request);
    const validEmptyValue = (value) => value === void 0 || value === null || value === "" || typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0;
    function resolveUUID(uuid2) {
      return new Promise((resolve, reject) => {
        resolveEntry(uuid2).then(({ items: [result] }) => {
          if (!result) {
            reject(setEntryState(uuid2).reset().error("Invalid entry data").loaded().value());
          } else {
            resolve(setEntryState(result).reset().loaded().value());
          }
          emit("loaded", uuid2);
        }).catch((e2) => {
          console.error(e2);
          reject(setEntryState(uuid2).error("Failed to load entry").loaded().value());
        });
      });
    }
    function asEntryObject(value) {
      if (validEmptyValue(value)) {
        return { sys: { empty: true } };
      }
      return typeof value === "string" ? { sys: { id: value } } : value.sys ? value : { ...value, sys: { empty: true } };
    }
    function setEntryState(value) {
      return {
        _entry: asEntryObject(value),
        get entry() {
          return this._entry;
        },
        set entry(value2) {
          this._entry = value2;
        },
        reset: function(keep) {
          if (keep !== "error")
            delete this.entry.sys.error;
          if (keep !== "loading")
            delete this.entry.sys.loading;
          delete this.entry.sys.loaded;
          delete this.entry.sys.empty;
          return this;
        },
        error: function(e2) {
          this.entry = { ...this.entry, sys: { ...this.entry.sys, error: e2 } };
          return this;
        },
        loading: function(b2 = true) {
          this.entry = { ...this.entry, sys: { ...this.entry.sys, loading: true } };
          return this;
        },
        loaded: function(b2 = true) {
          this.entry = { ...this.entry, sys: { ...this.entry.sys, loaded: true } };
          return this;
        },
        empty: function(b2 = true) {
          this.entry = { ...this.entry, sys: { ...this.entry.sys, empty: true } };
          return this;
        },
        value: function() {
          return this.entry;
        }
      };
    }
    function evalState(state2) {
      return {
        empty: function(value, key, setError = true) {
          if (!!state2[key] && typeof state2[key] === "object" && state2[key].sys && state2[key].sys.empty) {
            return;
          }
          if (validEmptyValue(value)) {
            state2[key] = setEntryState(value).reset().empty().loaded().value();
          } else {
            if (!!state2[key] && typeof state2[key] === "object" && state2[key].sys && state2[key].sys.loaded && !!value && typeof value === "object" && value.sys && value.sys.id) {
              state2[key] = setEntryState(value).reset().loaded().value();
            } else {
              if (setError)
                console.warn("received invalid empty state", value, key);
              if (setError)
                state2[key] = setEntryState(value).reset().error("Invalid entry (empty)").loaded().value();
            }
          }
        },
        entry: function(value, key) {
          if (this.string(value, key))
            return;
          if (this.object(value, key))
            return;
          this.empty(value, key);
        },
        string: function(value, key, setError = false) {
          if (isUUID(value)) {
            if (!!state2[key] && state2[key].sys && state2[key].sys.id === value)
              return true;
            state2[key] = setEntryState(value).reset().loading().value();
            resolveUUID(value).then((result) => {
              state2[key] = result;
            }).catch((e2) => {
              console.error("Error during entry resolution", e2);
              state2[key] = e2;
            });
            return true;
          }
          if (setError) {
            state2[key] = setEntryState(value).reset().error("Invalid entry (string)").loaded().value();
          }
          return false;
        },
        object: function(value, key, setError = false) {
          if (this.isValidEntryObject(value)) {
            const keep = props.entry && props.entry.sys ? props.entry.sys.error ? "error" : props.entry.sys.loading ? "loading" : void 0 : void 0;
            state2[key] = setEntryState(value).reset(keep).loaded().value();
            return true;
          }
          if (setError)
            state2[key] = setEntryState(value).reset().error("Invalid entry (object)").loaded().value();
          return false;
        },
        isValidEntryObject: function(value) {
          return !!value && typeof value === "object" && !!value.sys;
        }
      };
    }
    function entryStateHandler(value) {
      const sys = state.entry_ && state.entry_.sys ? state.entry_.sys : {};
      const { id, loading, loaded, empty, error } = sys;
      if (loading)
        return;
      if (parsedConfig.lazy && typeof value === "string") {
        state.entry_ = setEntryState(value).loading().value();
      }
      if (loaded) {
        if (empty) {
          evalState(state).entry(value, "entry_");
        } else {
          evalState(state).empty(value, "entry_", false);
        }
      } else {
        evalState(state).entry(value, "entry_");
      }
    }
    const state = reactive({
      entry_: ref(null),
      actionInputModel: ref({}),
      parsedActions: ref(null),
      resolvedEntry: computed({
        get: () => state.entry_,
        set: entryStateHandler
      }),
      mountClass: "ozn-entry-item--unmounted"
    });
    const activity = reactive({
      entry: {
        editing: false,
        removing: false,
        confirming: false
      },
      overlay: {
        hide: false
      }
    });
    onMounted(() => {
      state.resolvedEntry = props.entry;
      state.mountClass = "ozn-entry-item--mounted";
    });
    onBeforeUnmount(() => {
      state.mountClass = "ozn-entry-item--unmounted";
    });
    watch(() => props.entry, (value) => {
      state.resolvedEntry = value;
    }, { deep: true });
    function get(entry, path = "", def = null) {
      try {
        if (!entry)
          console.warn("Invalid entry of path argument");
        const e2 = !Array.isArray(entry) && typeof entry === "object" ? entry : props.entry;
        const pa = arguments.length <= 2 && (Array.isArray(entry) || typeof entry === "string") ? entry : path;
        const p = Array.isArray(pa) ? parsedConfig.fields.data && !pa.includes(parsedConfig.fields.data) ? [parsedConfig.fields.data].concat(pa) : pa : parsedConfig.fields.data && !pa.includes(`.${parsedConfig.fields.data}`) ? `${parsedConfig.fields.data}.${pa}` : pa;
        return !p && e2 ? _.get(e2, parsedConfig.fields.data, e2) : _.get(e2, p, def);
      } catch (e2) {
        return null;
      }
    }
    function beforeRemoveItem() {
      if (parsedConfig.actions.confirm) {
        activity.entry.confirming = true;
      } else {
        removeItem();
      }
    }
    function cancelRemoval() {
      activity.entry.confirming = false;
    }
    function removeItem() {
      activity.entry.removing = true;
      emit("remove", state.resolvedEntry);
    }
    function setHideOverlay() {
      activity.overlay.hide = true;
    }
    function setUnhideOverlay() {
      activity.overlay.hide = false;
      emit("show-overlay", state.resolvedEntry.sys.id);
    }
    function closeOverlay(e2) {
      e2.stopPropagation();
      emit("hide-overlay", state.resolvedEntry.sys.id);
    }
    function getTitle(entry) {
      const f2 = entry;
      return f2.title || f2.name || f2.label || f2.pageTitle || f2.sectionTitle || f2.pageName || f2.sectionName || f2.headline || f2.heading || f2.head || f2.handle || f2.username || f2.fullname || f2.uid || f2.id || "Untitled";
    }
    function getDescription(entry) {
      const f2 = entry;
      return f2.description || f2.desc || f2.body || f2.note || f2.notes || f2.meta || f2.addition || f2.additionalDescription || "";
    }
    function select() {
      emit("select", state.resolvedEntry);
    }
    function replace() {
      activity.entry.confirming = false;
      if (state.entry_ && state.entry_.sys)
        state.entry_.sys.empty = true;
      emit("replace", props.contentType, state.resolvedEntry);
    }
    function setExpand(state2) {
      if (state2 === true) {
        const size = (sizeState.value || props.size) === Size.small ? Size.medium : sizeState.value || props.size;
        if (sizeState.value !== size)
          emit("expand", state2);
        sizeState.value = size;
      } else {
        if (sizeState.value !== props.size)
          emit("expand", state2);
        sizeState.value = props.size;
      }
    }
    function setProp(prop, value) {
      switch (prop) {
        case "active":
          !value ? emit("deactivate") : emit("activate");
          break;
        case "expand":
          setExpand(value);
          break;
        case "size":
          sizeState.value = Size[value] || sizeState.value || props.size;
          break;
        case "highlight":
          highlightState.value = value;
          break;
        case "overlay":
          activity.overlay.hide = value;
          break;
        case "edit":
          activity.entry.editing = value;
          break;
        case "confirm":
          activity.entry.confirming = value;
          break;
        case "error":
          if (state.resolvedEntry && state.resolvedEntry.sys) {
            state.resolvedEntry.sys.error = value;
          }
          break;
        default:
          return;
      }
    }
    function reload() {
      state.resolvedEntry = props.entry;
    }
    return {
      drag: {
        start: emit("dragstart", state.resolvedEntry, setProp),
        end: emit("dragend", state.resolvedEntry, setProp),
        over: emit("dragover", state.resolvedEntry, setProp),
        enter: emit("dragenter", state.resolvedEntry, setProp),
        leave: emit("dragleave", state.resolvedEntry, setProp)
      },
      wrapperClasses,
      additionalClasses,
      activity,
      select,
      replace,
      parsedConfig,
      beforeRemoveItem,
      cancelRemoval,
      removeItem,
      setHideOverlay,
      setUnhideOverlay,
      closeOverlay,
      reload,
      get,
      getTitle,
      getDescription,
      state,
      Size,
      setProp
    };
  }
});
const _hoisted_1$k = ["draggable"];
const _hoisted_2$i = {
  key: 0,
  class: "ozn-entry-item__label"
};
const _hoisted_3$g = { class: "item-label" };
const _hoisted_4$b = {
  key: 0,
  style: { "font-size": "70%", "font-weight": "400", "text-transform": "none" }
};
const _hoisted_5$8 = {
  key: 0,
  class: "ozn-entry-item__container"
};
const _hoisted_6$8 = {
  key: 2,
  class: "confirm-overlay"
};
const _hoisted_7$8 = /* @__PURE__ */ createElementVNode("span", { class: "confirm-overlay__label" }, "Are you sure?", -1);
const _hoisted_8$7 = { class: "confirm-overlay__actions" };
const _hoisted_9$6 = { class: "ozn-entry-item__inner" };
const _hoisted_10$7 = { class: "ozn-entry-item__header" };
const _hoisted_11$7 = { class: "ozn-entry-item__header--left" };
const _hoisted_12$7 = {
  key: 0,
  class: "ozn-entry-item__meta"
};
const _hoisted_13$5 = { class: "ozn-entry-item__title" };
const _hoisted_14$3 = { class: "entry_main" };
const _hoisted_15$2 = { class: "entry-content" };
const _hoisted_16$2 = { class: "entry-item__content-editor" };
const _hoisted_17$1 = {
  key: 1,
  class: "ozn-entry-item__placeholder"
};
const _hoisted_18 = {
  key: 0,
  class: "entry-item__wrapper entry-item__loader"
};
const _hoisted_19 = /* @__PURE__ */ createElementVNode("span", { class: "entry-item__error entry-item__error--readonly" }, "Empty & readonly", -1);
const _hoisted_20 = [
  _hoisted_19
];
const _hoisted_21 = {
  key: 2,
  class: "entry-item__container entry-item__loader"
};
const _hoisted_22 = {
  key: 0,
  class: "confirm-overlay"
};
const _hoisted_23 = /* @__PURE__ */ createElementVNode("span", null, "Are you sure?", -1);
const _hoisted_24 = { class: "confirm-overlay__actions" };
const _hoisted_25 = { key: 2 };
const _hoisted_26 = {
  key: 3,
  class: "entry-item__error"
};
const _hoisted_27 = { class: "entry-item__error--message" };
const _hoisted_28 = { class: "entry-item__error--id" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OznButton = resolveComponent("OznButton");
  const _component_spinner = resolveComponent("spinner");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["ozn-entry-item__wrapper", _ctx.wrapperClasses]),
    draggable: _ctx.draggable,
    onDragstart: _cache[5] || (_cache[5] = (...args) => _ctx.drag.start && _ctx.drag.start(...args)),
    onDragend: _cache[6] || (_cache[6] = (...args) => _ctx.drag.end && _ctx.drag.end(...args)),
    onDragover: _cache[7] || (_cache[7] = (...args) => _ctx.drag.over && _ctx.drag.over(...args)),
    onDragenter: _cache[8] || (_cache[8] = (...args) => _ctx.drag.enter && _ctx.drag.enter(...args)),
    onDragleave: _cache[9] || (_cache[9] = (...args) => _ctx.drag.leave && _ctx.drag.leave(...args))
  }, [
    _ctx.label ? (openBlock(), createElementBlock("h4", _hoisted_2$i, [
      createElementVNode("span", _hoisted_3$g, toDisplayString(_ctx.label), 1),
      _ctx.parsedConfig.debug.verbose ? (openBlock(), createElementBlock("span", _hoisted_4$b, "(" + toDisplayString(_ctx.contentType) + ")", 1)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["ozn-entry-item", _ctx.additionalClasses]),
      onClick: _cache[4] || (_cache[4] = (...args) => _ctx.select && _ctx.select(...args))
    }, [
      _ctx.state.resolvedEntry && _ctx.state.resolvedEntry.sys && !_ctx.state.resolvedEntry.sys.loading && !_ctx.state.resolvedEntry.sys.error && !_ctx.state.resolvedEntry.sys.empty ? (openBlock(), createElementBlock("div", _hoisted_5$8, [
        !_ctx.readonly && _ctx.parsedConfig.replace ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "entry-item__button-replace",
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.replace && _ctx.replace(...args))
        })) : createCommentVNode("", true),
        _ctx.parsedConfig.actions.remove ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "btn btn--remove",
          onClick: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.beforeRemoveItem && _ctx.beforeRemoveItem(...args), ["stop"]))
        })) : createCommentVNode("", true),
        _ctx.activity.entry.confirming ? (openBlock(), createElementBlock("div", _hoisted_6$8, [
          _hoisted_7$8,
          createElementVNode("div", _hoisted_8$7, [
            createVNode(_component_OznButton, {
              class: "button ozn-btn--danger",
              label: "Yes",
              "loader-style": _ctx.loaderStyle,
              loading: _ctx.activity.entry.removing,
              onClick: withModifiers(_ctx.removeItem, ["stop"])
            }, null, 8, ["loader-style", "loading", "onClick"]),
            createVNode(_component_OznButton, {
              class: "button",
              label: "Cancel",
              onClick: withModifiers(_ctx.cancelRemoval, ["stop"])
            }, null, 8, ["onClick"])
          ])
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_9$6, [
          createElementVNode("div", _hoisted_10$7, [
            renderSlot(_ctx.$slots, "header", {
              entry: _ctx.state.resolvedEntry,
              active: _ctx.active,
              activity: _ctx.activity,
              actions: { closeOverlay: _ctx.closeOverlay, setHideOverlay: _ctx.setHideOverlay, getTitle: _ctx.getTitle, getDescription: _ctx.getDescription, removeItem: _ctx.removeItem, get: _ctx.get, reload: _ctx.reload, setProp: _ctx.setProp }
            }, () => [
              createElementVNode("div", _hoisted_11$7, [
                _ctx.parsedConfig.debug.sys ? (openBlock(), createElementBlock("span", _hoisted_12$7, toDisplayString(_ctx.state.resolvedEntry.sys && _ctx.state.resolvedEntry.sys.id), 1)) : createCommentVNode("", true),
                createElementVNode("h3", _hoisted_13$5, toDisplayString(_ctx.getTitle(_ctx.state.resolvedEntry)), 1)
              ])
            ])
          ]),
          createElementVNode("div", _hoisted_14$3, [
            createElementVNode("div", _hoisted_15$2, [
              renderSlot(_ctx.$slots, "content", {
                entry: _ctx.state.resolvedEntry,
                active: _ctx.active,
                activity: _ctx.activity,
                actions: { activity: _ctx.activity, closeOverlay: _ctx.closeOverlay, setHideOverlay: _ctx.setHideOverlay, getTitle: _ctx.getTitle, getDescription: _ctx.getDescription, get: _ctx.get, removeItem: _ctx.removeItem, reload: _ctx.reload, setProp: _ctx.setProp }
              })
            ]),
            createElementVNode("div", _hoisted_16$2, [
              renderSlot(_ctx.$slots, "editor", {
                entry: _ctx.state.resolvedEntry,
                active: _ctx.active,
                activity: _ctx.activity,
                actions: { activity: _ctx.activity, closeOverlay: _ctx.closeOverlay, setHideOverlay: _ctx.setHideOverlay, getTitle: _ctx.getTitle, getDescription: _ctx.getDescription, get: _ctx.get, removeItem: _ctx.removeItem, reload: _ctx.reload, setProp: _ctx.setProp }
              })
            ])
          ])
        ])
      ])) : _ctx.state.resolvedEntry && _ctx.state.resolvedEntry.sys && _ctx.state.resolvedEntry.sys.empty ? (openBlock(), createElementBlock("div", _hoisted_17$1, [
        _ctx.readonly && _ctx.parsedConfig.replace ? (openBlock(), createElementBlock("div", _hoisted_18, _hoisted_20)) : createCommentVNode("", true),
        !_ctx.readonly && _ctx.parsedConfig.replace ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "btn btn--replace",
          onClick: _cache[2] || (_cache[2] = (...args) => _ctx.replace && _ctx.replace(...args))
        })) : createCommentVNode("", true)
      ])) : (openBlock(), createElementBlock("div", _hoisted_21, [
        _ctx.activity.entry.confirming ? (openBlock(), createElementBlock("div", _hoisted_22, [
          _hoisted_23,
          createElementVNode("div", _hoisted_24, [
            createVNode(_component_OznButton, {
              class: "button",
              label: "Yes",
              "loader-style": _ctx.loaderStyle,
              loading: _ctx.activity.entry.removing,
              onClick: _ctx.removeItem
            }, null, 8, ["loader-style", "loading", "onClick"]),
            createVNode(_component_OznButton, {
              class: "button",
              label: "Cancel",
              onClick: _ctx.cancelRemoval
            }, null, 8, ["onClick"])
          ])
        ])) : createCommentVNode("", true),
        _ctx.parsedConfig.actions.remove ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "entry-item__button-remove",
          onClick: _cache[3] || (_cache[3] = (...args) => _ctx.beforeRemoveItem && _ctx.beforeRemoveItem(...args))
        })) : createCommentVNode("", true),
        _ctx.state.resolvedEntry && _ctx.state.resolvedEntry.sys && _ctx.state.resolvedEntry.sys.loading && !_ctx.state.resolvedEntry.sys.error ? (openBlock(), createElementBlock("div", _hoisted_25, [
          createVNode(_component_spinner, {
            class: "entry-item__loader-animation",
            scale: 0.5,
            "delayed-message": "any moment now...",
            type: _ctx.loaderStyle,
            visible: true
          }, null, 8, ["scale", "type"])
        ])) : createCommentVNode("", true),
        _ctx.state.resolvedEntry && _ctx.state.resolvedEntry.sys && _ctx.state.resolvedEntry.sys.error ? (openBlock(), createElementBlock("div", _hoisted_26, [
          createElementVNode("div", _hoisted_27, toDisplayString(_ctx.state.resolvedEntry.sys.error), 1),
          createElementVNode("div", _hoisted_28, toDisplayString(_ctx.state.resolvedEntry.sys.id), 1)
        ])) : createCommentVNode("", true)
      ]))
    ], 2)
  ], 42, _hoisted_1$k);
}
var EntryItem = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$f]]);
const DEFAULT_CONFIG$1 = {
  fields: {
    data: "",
    sys: "sys",
    title: void 0
  },
  requests: {
    limit: 1e3,
    select: "*"
  },
  debug: {
    sys: false,
    verbose: false
  },
  actions: {
    add: true,
    remove: true,
    confirm: ["add"]
  },
  lazy: true
};
var EntrySearch_vue_vue_type_style_index_0_scoped_true_lang = "";
function CreateSelectionController(type) {
  return {
    type,
    get total() {
      return this.items.length;
    },
    _data: [],
    uniq: true,
    path: {
      id: "sys.id"
    },
    clear() {
      this._data = [];
    },
    add(value) {
      const v = Array.isArray(value) ? value : [value];
      this._data = !this.uniq ? this._data.concat(v) : this._data.concat(v).filter((f2, i2, a3) => a3.indexOf(f2) === i2);
    },
    remove(value, path) {
      typeof value === "number" ? this._data.splice(value, 1) : this._data.splice(
        typeof value === "string" ? this._data.findIndex((d3) => _.get(d3, path || this.path.id) === value) : this._data.findIndex((d3) => _.get(d3, path || this.path.id) === _.get(value, path || this.path.id)),
        1
      );
    },
    indexOf(value, path) {
      return typeof value === "string" ? this._data.findIndex((d3) => _.get(d3, path || this.path.id) === value) : this._data.findIndex((d3) => _.get(d3, path || this.path.id) === _.get(value, path || this.path.id));
    },
    get items() {
      return this._data;
    },
    set items(value) {
      if (typeof value !== "object") {
        console.warn("Selection items are expected to be objects / arrays");
        return;
      }
      this._data = !this.uniq ? value : value.filter((f2, i2, a3) => a3.indexOf(f2) === i2);
    }
  };
}
const _sfc_main$g = defineComponent({
  name: "EntrySearch",
  components: { EntryItem, OznButton },
  props: {
    payload: {
      type: Array,
      default: () => void 0
    },
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    contentType: {
      type: String,
      required: false,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    request: {
      type: Object,
      default: () => new RequestHandler()
    },
    config: {
      type: Object,
      default: () => DEFAULT_CONFIG$1
    },
    target: {
      type: Object,
      default: () => ({
        src: {},
        path: "",
        type: "",
        replace: false,
        callback: void 0
      })
    },
    queryHandler: {
      type: Object
    },
    highlight: {
      type: Boolean,
      default: false
    },
    model: Object,
    size: {
      type: String,
      default: Size.sm
    },
    selectLimit: {
      type: Number,
      default: void 0
    }
  },
  emits: ["close", "selection", "search"],
  setup(props, { emit }) {
    const additionalClasses = computed(() => {
      return {
        [`ozn-entry-search--${props.size}`]: props.size !== void 0,
        highlight: props.highlight
      };
    });
    const parsedConfig = _.defaultsDeep(props.config, DEFAULT_CONFIG$1);
    async function fetch() {
      try {
        if (!props.request.fetch && !props.request.get)
          throw Error('The passed request handler object does not implement a "fetch" or "get" method');
        const config2 = { limit: parsedConfig.requests.limit };
        const fetch2 = props.request.fetch || props.request.get;
        const list = await fetch2(props.contentType, [], config2);
        if (!list.items) {
          throw Error('fetch did not return an object containing an "items" key');
        }
        if (!state.items.length)
          state.items = list.items;
        else
          $setTo(state.items, list.items, "sys.id");
      } catch (e2) {
        return Promise.reject(e2);
      }
    }
    function matchQueryToFields(input, model) {
      return Object.keys(model).map((key) => {
        if (!model[key].field)
          return null;
        switch (typeof model[key] === "string" ? model[key] : model[key].type) {
          case FormInputType.String:
            return model[key];
          case FormInputType.Number:
            return /^\d+$/.test(input) ? model[key] : null;
          case FormInputType.Array:
          case FormInputType.Select:
          case FormInputType.Tag:
            return model[key];
          case FormInputType.Object:
            return null;
          case FormInputType["Link-list"]:
          case FormInputType.Link:
            return isUUID(input) ? model[key] : null;
          case FormInputType.Boolean:
            return input && input.toLowerCase() === key.toLowerCase() ? model[key] : null;
          default:
            return null;
        }
      }).filter((f2) => f2 !== null && f2 !== void 0);
    }
    async function queryRemote() {
      try {
        if (!props.model) {
          console.warn("EntrySearch.queryRemote | A model prop is required, but none was defined");
          return Promise.reject(false);
        }
        const models = matchQueryToFields(state.searchQueryString, props.model);
        const query = models.map(({ field, type }) => ({ field, method: ["string", "link", "number", "boolean"].includes(type) ? "like" : type === "boolean" ? void 0 : "in", match: type === "boolean" ? (state.searchQueryString || "")[0] === "!" ? false : true : state.searchQueryString }));
        const loadHandler = props.queryHandler && typeof props.queryHandler === "function" ? props.queryHandler : load;
        await loadHandler(query, { skip: 0, query: { any: true } });
        return Promise.resolve(true);
      } catch (e2) {
        console.error("Query remote error", e2);
        return Promise.reject(e2);
      }
    }
    async function load(query, config2) {
      var _a;
      try {
        if (!props.request)
          throw Error("A request handler is required, but none was defined.");
        if (props.request && (!props.request.load && !props.request.get))
          throw Error('A dedicated "load" or "get" method is required on the request handler for remote loading, but none was defined.');
        const loader = props.request.load || props.request.get;
        state.loading = true;
        const cf = config2 || { skip: ((_a = state.items) == null ? void 0 : _a.length) || 0 };
        const q2 = query || [];
        const result = await loader(props.contentType, q2, cf);
        if (state.items)
          $setTo(state.items, result.items, "sys.id");
        else
          state.items = result.items || [];
        state.loading = false;
      } catch (e2) {
        state.loading = false;
        console.error("EntryList.load", e2);
      }
    }
    const selection = reactive(CreateSelectionController(props.contentType));
    const filteredItems = computed(() => ((Array.isArray(state.items) ? state.items : !state.items ? [] : [state.items]) || []).filter((f2) => !!grep.contents(f2, state.filterQuery, 2)));
    const state = reactive({
      items: props.payload || [],
      Size,
      fetch,
      parsedConfig,
      searchQueryString: "",
      filterQuery: "",
      loading: false
    });
    watch(() => props.payload, (p) => {
      var _a, _b;
      if (((_a = state.items[0]) == null ? void 0 : _a.sys.type) !== props.contentType && p && ((_b = p[0]) == null ? void 0 : _b.sys.type) === props.contentType)
        state.items = p;
      else
        $setTo(state.items, p || [], "sys.id");
    });
    watch(() => props.contentType, (p) => {
      state.items = state.items.filter((f2) => {
        var _a;
        return ((_a = f2.sys) == null ? void 0 : _a.type) === p;
      });
    });
    watch(() => props.show, (p) => {
      if (p && (!state.items || !props.payload && state.items.length <= 0)) {
        fetch();
      }
    });
    watch(() => state.searchQueryString, _.debounce(setFilter, 100));
    watch(() => state.searchQueryString, _.debounce(() => {
      if ((filteredItems.value || []).length <= 1 && !!props.model)
        queryRemote().catch((e2) => console.error("searchQueryString: entries length watcher error", e2));
    }, 500));
    function setFilter(value) {
      state.filterQuery = value;
      emit("search", value);
    }
    function commit() {
      try {
        emit("selection", { target: props.target, selection: selection.items });
        if (props.target) {
          const { path = "", type, callback } = props.target;
          if (callback && typeof callback !== "function")
            throw Error(`EntrySearch.commit: target.callback should be a function (was ${typeof callback})`);
          if (!props.target.src)
            console.log("EntrySearch.commit. no target props.target.src, skipping to callback...");
          if (Array.isArray(props.target.src) && path !== "")
            console.warn(`EntrySearch.commit. target.path set (${path}), but target.src is array, path will be ignored...`);
          if (callback)
            callback(selection.items, { src: props.target.src, path, type });
        }
        selection.clear();
      } catch (e2) {
        console.error("EntrySearch.commit error", e2);
      }
    }
    function close() {
      emit("close");
    }
    return {
      ...toRefs(state),
      queryRemote,
      filteredItems,
      additionalClasses,
      load,
      selection,
      commit,
      close,
      updateSelection: (item) => {
        if (selection.indexOf(item) >= 0)
          selection.remove(item);
        else if (!props.selectLimit || props.selectLimit && selection.items.length < props.selectLimit)
          selection.add(item);
      }
    };
  }
});
const _withScopeId$3 = (n) => (pushScopeId("data-v-ba9e7650"), n = n(), popScopeId(), n);
const _hoisted_1$j = { class: "ozn-entry-search__container" };
const _hoisted_2$h = {
  key: 0,
  class: "ozn-entry-search__list scrollable--y"
};
const _hoisted_3$f = {
  key: 1,
  class: "ozn-entry-search__list list-placeholder scrollable--y"
};
const _hoisted_4$a = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("span", { class: "placeholder" }, "No items to display", -1));
const _hoisted_5$7 = [
  _hoisted_4$a
];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_OznButton = resolveComponent("OznButton");
  const _component_form_input = resolveComponent("form-input");
  const _component_EntryItem = resolveComponent("EntryItem");
  const _component_spinner = resolveComponent("spinner");
  const _component_ozn_button = resolveComponent("ozn-button");
  return withDirectives((openBlock(), createElementBlock("div", {
    key: `search-${_ctx.id}_${_ctx.show}`,
    class: normalizeClass(["ozn-entry-search fixed bottom right", _ctx.additionalClasses])
  }, [
    createElementVNode("div", _hoisted_1$j, [
      createVNode(_component_OznButton, {
        class: "ozn-entry-search__btn ozn-entry-search__btn--flat",
        flat: "",
        label: "Close",
        onClick: _ctx.close
      }, null, 8, ["onClick"]),
      createVNode(_component_form_input, {
        modelValue: _ctx.searchQueryString,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.searchQueryString = $event),
        class: "ozn-entry-search__search-input minimal",
        placeholder: "search..."
      }, null, 8, ["modelValue"]),
      ((_a = _ctx.filteredItems) == null ? void 0 : _a.length) ? (openBlock(), createElementBlock("div", _hoisted_2$h, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredItems, (item, i2) => {
          var _a2;
          return openBlock(), createBlock(_component_EntryItem, {
            key: `search-entry-item-${(_a2 = item == null ? void 0 : item.sys) == null ? void 0 : _a2.id}_${i2}`,
            "content-type": _ctx.contentType,
            entry: item,
            class: normalizeClass({ "ozn-entry-item--highlight": _ctx.parsedConfig.highlight }),
            size: _ctx.Size[_ctx.size],
            highlight: _ctx.selection.indexOf(item) >= 0,
            request: _ctx.request,
            onSelect: ($event) => _ctx.updateSelection(item)
          }, {
            header: withCtx(() => [
              renderSlot(_ctx.$slots, "search-item-header", {
                contentType: _ctx.contentType,
                item,
                index: i2,
                selection: _ctx.selection
              }, void 0, true)
            ]),
            content: withCtx(() => [
              renderSlot(_ctx.$slots, "search-item-content", {
                contentType: _ctx.contentType,
                item,
                index: i2,
                selection: _ctx.selection
              }, void 0, true)
            ]),
            editor: withCtx(() => [
              renderSlot(_ctx.$slots, "search-item-editor", {
                contentType: _ctx.contentType,
                item,
                index: i2,
                selection: _ctx.selection
              }, void 0, true)
            ]),
            _: 2
          }, 1032, ["content-type", "entry", "class", "size", "highlight", "request", "onSelect"]);
        }), 128)),
        createVNode(_component_spinner, {
          visible: _ctx.loading,
          scale: 0.5,
          style: { "margin": "0 auto", "width": "40px" }
        }, null, 8, ["visible", "scale"])
      ])) : (openBlock(), createElementBlock("div", _hoisted_3$f, _hoisted_5$7)),
      !_ctx.loading && (_ctx.searchQueryString || "").length > 3 ? (openBlock(), createBlock(_component_ozn_button, {
        key: 2,
        label: "Search for more",
        class: "minimal",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.load())
      })) : createCommentVNode("", true),
      createVNode(_component_OznButton, {
        class: "ozn-entry-search__btn ozn-entry-search__btn--full-width",
        label: "Confirm selection",
        "full-width": "",
        onClick: _ctx.commit
      }, null, 8, ["onClick"])
    ])
  ], 2)), [
    [vShow, _ctx.show]
  ]);
}
var EntrySearch = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$e], ["__scopeId", "data-v-ba9e7650"]]);
const DEFAULT_ERROR_STATE$1 = {
  state: false,
  message: ""
};
const _sfc_main$f = {
  props: {
    modelValue: {
      type: [String, Number, Array, Object, Boolean],
      required: true
    },
    value: {
      type: [String, Number, Array, Object, Boolean]
    },
    inputClass: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    debug: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Function,
      default: () => true
    }
  },
  emits: ["update:modelValue", "invalid"],
  data: () => ({
    error: DEFAULT_ERROR_STATE$1
  }),
  computed: {
    inputVal: {
      get() {
        return this.modelValue || this.value;
      },
      set(val) {
        this.error = DEFAULT_ERROR_STATE$1;
        const valid = this.validator(val);
        if (typeof valid === "object" && valid.value === true || typeof valid !== "object" && valid) {
          this.$emit("update:modelValue", val);
        } else {
          this.error = { state: true, message: typeof valid === "object" ? valid.message || "Invalid input" : "Invalid input" };
          this.$emit("invalid", val, valid);
        }
      }
    }
  }
};
_sfc_main$f.install = (Vue) => {
  Vue.component(_sfc_main$f.name, _sfc_main$f);
};
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$3 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$3) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
var formatters$2 = {
  y: function y(date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  G: function G(date, token, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  y: function y2(date, token, localize2) {
    if (token === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$3.y(date, token);
  },
  Y: function Y(date, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function Q(date, token, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function q(date, token, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function M2(date, token, localize2) {
    var month = date.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$3.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function L(date, token, localize2) {
    var month = date.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function w(date, token, localize2, options) {
    var week = getUTCWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function I(date, token, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function d2(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$3.d(date, token);
  },
  D: function D(date, token, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function E(date, token, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function e(date, token, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function c(date, token, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function i(date, token, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function a2(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function b(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function B(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function h2(date, token, localize2) {
    if (token === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$3.h(date, token);
  },
  H: function H2(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$3.H(date, token);
  },
  K: function K(date, token, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function k(date, token, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function m2(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$3.m(date, token);
  },
  s: function s2(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$3.s(date, token);
  },
  S: function S2(date, token) {
    return formatters$3.S(date, token);
  },
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var localize$1 = localize;
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var match$1 = match;
var locale = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function nextMonth(date) {
  const nextMonthDate = new Date(date.getTime());
  nextMonthDate.setDate(1);
  nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
  return nextMonthDate;
}
function prevMonth(date) {
  const prevMonthDate = new Date(date.getTime());
  prevMonthDate.setDate(1);
  prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);
  return prevMonthDate;
}
function yearMonth(date) {
  const month = date.getMonth() + 1;
  return date.getFullYear() + (month < 10 ? "0" : "") + month;
}
function validateDateRange(newDate, min, max) {
  const maxDate = new Date(max);
  const minDate = new Date(min);
  if (max && newDate.getTime() > maxDate.getTime()) {
    return maxDate;
  }
  if (min && newDate.getTime() < minDate.getTime()) {
    return minDate;
  }
  return newDate;
}
const dayNames = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const DEFAULT_LOCALE = {
  direction: "ltr",
  format: "dd-MM-yyyy",
  separator: " - ",
  applyLabel: "Apply",
  cancelLabel: "Cancel",
  weekLabel: "W",
  customRangeLabel: "Custom Range",
  daysOfWeek: dayNames.slice(0, 7).map((d3) => d3.substring(0, 2)),
  monthNames: monthNames.slice(0, 12),
  firstDay: 1
};
var FormCalendar_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$e = defineComponent({
  name: "FormCalendar",
  props: {
    monthDate: {
      type: Date
    },
    localeData: {
      type: Object
    },
    start: {
      type: Date
    },
    end: {
      type: Date
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    showDropdowns: {
      type: Boolean
    },
    showWeekNumbers: {
      type: Boolean
    },
    dateFormat: {
      type: Function
    }
  },
  emits: ["dateClick", "hoverDate", "change-month"],
  setup(props, { emit }) {
    const yearSelect = ref(null);
    const locale2 = ref({ ...DEFAULT_LOCALE, ...props.localeData });
    const currentMonthDate = ref(props.monthDate || props.start || new Date());
    const yearText = ref(currentMonthDate.value.getFullYear());
    const state = reactive({
      locale: locale2,
      monthName: computed(() => state.locale.monthNames[currentMonthDate.value.getMonth()]),
      year: computed({
        get: () => yearText.value,
        set: (value) => {
          yearText.value = value;
          const newDate = validateDateRange(new Date(parseInt(value), state.month, 1), props.minDate, props.maxDate);
          if (isValid(newDate)) {
            emit("change-month", {
              month: newDate.getMonth(),
              year: newDate.getFullYear()
            });
          }
        }
      }),
      month: computed({
        get: () => currentMonthDate.value.getMonth() + 1,
        set: (value) => {
          const newDate = validateDateRange(new Date(parseInt(state.year), value - 1, 1), props.minDate, props.maxDate);
          emit("change-month", {
            month: newDate.getMonth() + 1,
            year: newDate.getFullYear()
          });
        }
      }),
      calendar: computed(() => {
        const month = state.month;
        const year = currentMonthDate.value.getFullYear();
        const firstDay = new Date(year, month - 1, 1);
        const lastMonth = prevMonth(firstDay).getMonth() + 1;
        const lastYear = prevMonth(firstDay).getFullYear();
        const daysInLastMonth = new Date(lastYear, month - 1, 0).getDate();
        const dayOfWeek = firstDay.getDay();
        const calendar = [];
        for (let i2 = 0; i2 < 6; i2++) {
          calendar[i2] = [];
        }
        let startDay = daysInLastMonth - dayOfWeek + state.locale.firstDay + 1;
        if (startDay > daysInLastMonth) {
          startDay -= 7;
        }
        if (dayOfWeek === state.locale.firstDay) {
          startDay = daysInLastMonth - 6;
        }
        const curDate = new Date(lastYear, lastMonth - 1, startDay, 12, 0, 0);
        for (let i2 = 0, col = 0, row = 0; i2 < 6 * 7; i2++, col++, curDate.setDate(curDate.getDate() + 1)) {
          if (i2 > 0 && col % 7 === 0) {
            col = 0;
            row++;
          }
          calendar[row][col] = new Date(curDate.getTime());
        }
        return calendar;
      }),
      months: computed(() => {
        const monthsData = state.locale.monthNames.map((m3, idx) => ({ label: m3, value: idx }));
        if (props.maxDate && props.minDate) {
          const y3 = props.maxDate.getFullYear() - props.minDate.getFullYear();
          if (y3 < 2) {
            const months = [];
            if (y3 < 1) {
              for (let i2 = props.minDate.getMonth(); i2 <= props.maxDate.getMonth(); i2++) {
                months.push(i2);
              }
            } else {
              for (let i2 = 0; i2 <= props.maxDate.getMonth(); i2++) {
                months.push(i2);
              }
              for (let i2 = props.minDate.getMonth(); i2 < 12; i2++) {
                months.push(i2);
              }
            }
            if (months.length > 0) {
              return monthsData.filter((m3) => {
                return months.find((i2) => m3.value === i2) > -1;
              });
            }
          }
        }
        return monthsData;
      })
    });
    watch(() => props.monthDate, (value) => {
      if (currentMonthDate.value.getTime() !== value.getTime()) {
        changeMonthDate(value, false);
      }
    });
    function prevMonthClick() {
      changeMonthDate(prevMonth(currentMonthDate.value));
    }
    function nextMonthClick() {
      changeMonthDate(nextMonth(currentMonthDate.value));
    }
    function changeMonthDate(date, event = true) {
      const currentYearMonth = yearMonth(currentMonthDate.value);
      currentMonthDate.value = validateDateRange(date, props.minDate, props.maxDate);
      if (event && currentYearMonth !== yearMonth(currentMonthDate.value)) {
        emit("change-month", {
          month: currentMonthDate.value.getMonth() + 1,
          year: currentMonthDate.value.getFullYear()
        });
      }
      checkYear();
    }
    function dayClass(date) {
      const dt = new Date(date);
      dt.setHours(0, 0, 0, 0);
      const start = new Date(props.start);
      start.setHours(0, 0, 0, 0);
      const end = new Date(props.end);
      end.setHours(0, 0, 0, 0);
      const classes = {
        off: date.getMonth() + 1 !== state.month,
        weekend: date.getDay() === 6 || date.getDay() === 0,
        today: dt.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0),
        active: dt.setHours(0, 0, 0, 0) === new Date(props.start).setHours(0, 0, 0, 0) || dt.setHours(0, 0, 0, 0) === new Date(props.end).setHours(0, 0, 0, 0),
        "in-range": dt >= start && dt <= end,
        "start-date": dt.getTime() === start.getTime(),
        "end-date": dt.getTime() === end.getTime(),
        disabled: props.minDate && dt.getTime() < props.minDate.getTime() || props.maxDate && dt.getTime() > props.maxDate.getTime()
      };
      return props.dateFormat ? props.dateFormat(classes, date) : classes;
    }
    function checkYear() {
      if (yearSelect.value !== document.activeElement) {
        nextTick(() => {
          yearText.value = props.monthDate.getFullYear();
        });
      }
    }
    return {
      ...toRefs(state),
      yearSelect,
      prevMonthClick,
      nextMonthClick,
      changeMonthDate,
      dayClass,
      checkYear,
      getWeek,
      getISOWeek
    };
  }
});
const _withScopeId$2 = (n) => (pushScopeId("data-v-e0b977be"), n = n(), popScopeId(), n);
const _hoisted_1$i = { class: "table-condensed" };
const _hoisted_2$g = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("span", null, null, -1));
const _hoisted_3$e = [
  _hoisted_2$g
];
const _hoisted_4$9 = ["colspan"];
const _hoisted_5$6 = { class: "row mx-1" };
const _hoisted_6$7 = ["value"];
const _hoisted_7$7 = ["colspan"];
const _hoisted_8$6 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("span", null, null, -1));
const _hoisted_9$5 = [
  _hoisted_8$6
];
const _hoisted_10$6 = {
  key: 0,
  class: "week"
};
const _hoisted_11$6 = {
  key: 0,
  class: "week"
};
const _hoisted_12$6 = ["onClick", "onMouseover"];
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("table", _hoisted_1$i, [
    createElementVNode("thead", null, [
      createElementVNode("tr", null, [
        createElementVNode("th", {
          class: "table-button--previous available",
          tabindex: "0",
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.prevMonthClick && _ctx.prevMonthClick(...args))
        }, _hoisted_3$e),
        _ctx.showDropdowns ? (openBlock(), createElementBlock("th", {
          key: 0,
          colspan: _ctx.showWeekNumbers ? 6 : 5,
          class: "month"
        }, [
          createElementVNode("div", _hoisted_5$6, [
            withDirectives(createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.month = $event),
              class: "select--month col"
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.months, (m3) => {
                return openBlock(), createElementBlock("option", {
                  key: m3.value,
                  value: m3.value + 1
                }, toDisplayString(m3.label), 9, _hoisted_6$7);
              }), 128))
            ], 512), [
              [vModelSelect, _ctx.month]
            ]),
            withDirectives(createElementVNode("input", {
              ref: "yearSelect",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.year = $event),
              type: "number",
              class: "select--year col",
              onBlur: _cache[3] || (_cache[3] = (...args) => _ctx.checkYear && _ctx.checkYear(...args))
            }, null, 544), [
              [vModelText, _ctx.year]
            ])
          ])
        ], 8, _hoisted_4$9)) : (openBlock(), createElementBlock("th", {
          key: 1,
          colspan: _ctx.showWeekNumbers ? 6 : 5,
          class: "month"
        }, toDisplayString(_ctx.monthName) + " " + toDisplayString(_ctx.year), 9, _hoisted_7$7)),
        createElementVNode("th", {
          class: "table-button--next available",
          tabindex: "0",
          onClick: _cache[4] || (_cache[4] = (...args) => _ctx.nextMonthClick && _ctx.nextMonthClick(...args))
        }, _hoisted_9$5)
      ])
    ]),
    createElementVNode("tbody", null, [
      createElementVNode("tr", null, [
        _ctx.showWeekNumbers ? (openBlock(), createElementBlock("th", _hoisted_10$6, toDisplayString(_ctx.locale.weekLabel), 1)) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.locale.daysOfWeek, (weekDay) => {
          return openBlock(), createElementBlock("th", { key: weekDay }, toDisplayString(weekDay), 1);
        }), 128))
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.calendar, (dateRow, index2) => {
        return openBlock(), createElementBlock("tr", { key: index2 }, [
          _ctx.showWeekNumbers && (parseInt(index2) % 7 || parseInt(index2) === 0) ? (openBlock(), createElementBlock("td", _hoisted_11$6, toDisplayString(_ctx.getISOWeek(dateRow[0])), 1)) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(dateRow, (date, idx) => {
            return renderSlot(_ctx.$slots, "date-slot", {}, () => [
              (openBlock(), createElementBlock("td", {
                key: idx,
                class: normalizeClass(_ctx.dayClass(date)),
                onClick: ($event) => _ctx.$emit("dateClick", date),
                onMouseover: ($event) => _ctx.$emit("hoverDate", date)
              }, toDisplayString(date.getDate()), 43, _hoisted_12$6))
            ], true);
          }), 256))
        ]);
      }), 128))
    ])
  ]);
}
var Calendar = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$d], ["__scopeId", "data-v-e0b977be"]]);
const _sfc_main$d = defineComponent({
  name: "FormCalendarTime",
  props: {
    minuteIncrement: {
      type: Number,
      default: 5
    },
    hour24: {
      type: Boolean,
      default: false
    },
    secondPicker: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Date,
      default: () => new Date()
    },
    readonly: {
      type: Boolean
    }
  },
  emits: ["update"],
  setup(props, { emit }) {
    const current = ref(props.currentTime ? props.currentTime : new Date());
    const currentHour = ref(current.value.getHours());
    const hour = ref(props.hour24 ? currentHour.value : currentHour.value % 12 || 12);
    const minute = ref(current.value.getMinutes() - current.value.getMinutes() % props.minuteIncrement);
    const second = ref(current.value.getSeconds());
    const ampm = ref(currentHour.value < 12 ? "AM" : "PM");
    const state = reactive({
      hours: computed(() => {
        const values = [];
        const max = props.hour24 ? 24 : 12;
        for (let i2 = 0; i2 < max; i2++) {
          values.push(props.hour24 ? i2 : i2 + 1);
        }
        return values;
      }),
      minutes: computed(() => {
        const values = [];
        const max = 60;
        for (let i2 = 0; i2 < max; i2 = i2 + props.minuteIncrement) {
          values.push(i2);
        }
        return values;
      })
    });
    watch([hour, minute, second, ampm], () => {
      onChange();
    });
    function formatNumber(value) {
      if (value < 10) {
        return `0${value.toString()}`;
      }
      return value.toString();
    }
    function getHour() {
      if (hour.value) {
        return hour.value;
      } else {
        if (hour.value === 12) {
          return ampm.value === "AM" ? 0 : 12;
        } else {
          return hour.value + (ampm.value === "PM" ? 12 : 0);
        }
      }
    }
    function onChange() {
      emit("update", {
        hours: getHour(),
        minutes: minute.value,
        seconds: second.value
      });
    }
    return {
      ...toRefs(state),
      hour,
      minute,
      second,
      ampm,
      formatNumber
    };
  }
});
const _hoisted_1$h = { class: "daterange-picker--time" };
const _hoisted_2$f = ["disabled"];
const _hoisted_3$d = ["value"];
const _hoisted_4$8 = /* @__PURE__ */ createElementVNode("span", { class: "spacer" }, ":", -1);
const _hoisted_5$5 = ["disabled"];
const _hoisted_6$6 = ["value"];
const _hoisted_7$6 = /* @__PURE__ */ createElementVNode("span", { class: "spacer" }, ":", -1);
const _hoisted_8$5 = ["disabled"];
const _hoisted_9$4 = ["value"];
const _hoisted_10$5 = ["disabled"];
const _hoisted_11$5 = /* @__PURE__ */ createElementVNode("option", { value: "AM" }, "AM", -1);
const _hoisted_12$5 = /* @__PURE__ */ createElementVNode("option", { value: "PM" }, "PM", -1);
const _hoisted_13$4 = [
  _hoisted_11$5,
  _hoisted_12$5
];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$h, [
    withDirectives(createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.hour = $event),
      class: "select--hour form-control mr-1",
      disabled: _ctx.readonly
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.hours, (h3) => {
        return openBlock(), createElementBlock("option", {
          key: h3,
          value: h3
        }, toDisplayString(_ctx.formatNumber(h3)), 9, _hoisted_3$d);
      }), 128))
    ], 8, _hoisted_2$f), [
      [vModelSelect, _ctx.hour]
    ]),
    _hoisted_4$8,
    withDirectives(createElementVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.minute = $event),
      class: "select--minute form-control ml-1",
      disabled: _ctx.readonly
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.minutes, (m3) => {
        return openBlock(), createElementBlock("option", {
          key: m3,
          value: m3
        }, toDisplayString(_ctx.formatNumber(m3)), 9, _hoisted_6$6);
      }), 128))
    ], 8, _hoisted_5$5), [
      [vModelSelect, _ctx.minute]
    ]),
    _ctx.secondPicker ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      _hoisted_7$6,
      withDirectives(createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.second = $event),
        class: "select--second form-control ml-1",
        disabled: _ctx.readonly
      }, [
        (openBlock(), createElementBlock(Fragment, null, renderList(60, (s3) => {
          return createElementVNode("option", {
            key: s3 - 1,
            value: s3 - 1
          }, toDisplayString(_ctx.formatNumber(s3 - 1)), 9, _hoisted_9$4);
        }), 64))
      ], 8, _hoisted_8$5), [
        [vModelSelect, _ctx.second]
      ])
    ], 64)) : createCommentVNode("", true),
    !_ctx.hour24 ? withDirectives((openBlock(), createElementBlock("select", {
      key: 1,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.ampm = $event),
      class: "select--ampm",
      disabled: _ctx.readonly
    }, _hoisted_13$4, 8, _hoisted_10$5)), [
      [vModelSelect, _ctx.ampm]
    ]) : createCommentVNode("", true)
  ]);
}
var CalendarTime = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$c]]);
const _sfc_main$c = defineComponent({
  name: "FormCalendarRanges",
  props: {
    ranges: {
      type: Object
    },
    selected: {
      type: Object
    },
    localeData: {
      type: Object,
      default: () => ({})
    },
    alwaysShowCalendars: {
      type: Boolean
    }
  },
  emits: ["showCustomRange", "click"],
  setup(props, { emit }) {
    const state = reactive({
      customRangeActive: ref(false),
      listedRanges: computed(() => {
        if (!props.ranges) {
          return false;
        } else {
          return Object.keys(props.ranges).map((value) => {
            return {
              label: value,
              value: props.ranges[value],
              selected: isSameDay(props.selected.start, props.ranges[value][0]) && isSameDay(props.selected.end, props.ranges[value][1])
            };
          });
        }
      }),
      showCustomRangeLabel: computed(() => !props.alwaysShowCalendars),
      selectedRange: computed(() => {
        return state.listedRanges === false ? void 0 : state.listedRanges.find((range) => range.selected === true);
      })
    });
    function clickRange(range) {
      state.customRangeActive = false;
      emit("click", range);
    }
    function clickCustomRange() {
      state.customRangeActive = true;
      emit("showCustomRange");
    }
    function rangeClass(range) {
      return { active: range.selected === true };
    }
    return {
      ...toRefs(state),
      clickRange,
      clickCustomRange,
      rangeClass
    };
  }
});
const _hoisted_1$g = { class: "daterange-picker--ranges" };
const _hoisted_2$e = { key: 0 };
const _hoisted_3$c = ["data-range-key", "onClick"];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$g, [
    _ctx.ranges && _ctx.listedRanges ? (openBlock(), createElementBlock("ul", _hoisted_2$e, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.listedRanges, (range) => {
        return openBlock(), createElementBlock("li", {
          key: range.label,
          "data-range-key": range.label,
          class: normalizeClass(_ctx.rangeClass(range)),
          tabindex: "0",
          onClick: ($event) => _ctx.clickRange(range.value)
        }, toDisplayString(range.label), 11, _hoisted_3$c);
      }), 128)),
      _ctx.showCustomRangeLabel ? (openBlock(), createElementBlock("li", {
        key: 0,
        class: normalizeClass({ active: _ctx.customRangeActive || !_ctx.selectedRange }),
        tabindex: "0",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.clickCustomRange && _ctx.clickCustomRange(...args))
      }, toDisplayString(_ctx.localeData.customRangeLabel), 3)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true)
  ]);
}
var CalendarRanges = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$b]]);
const appendToBody = {
  mounted(el, binding, vnode) {
    if (binding.instance.appendToBody) {
      const { height, top, left, width, right } = binding.instance.$refs.toggle.getBoundingClientRect();
      el.unbindPosition = binding.instance.calculatePosition(el, binding.instance, {
        width,
        top: window.scrollY + top + height,
        left: window.scrollX + left,
        right
      });
      document.body.appendChild(el);
    } else {
      binding.instance.$el.appendChild(el);
    }
  },
  unmounted(el, binding, vnode) {
    if (binding.instance.appendToBody) {
      if (el.unbindPosition && typeof el.unbindPosition === "function") {
        el.unbindPosition();
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
};
const _hoisted_1$f = {
  version: "1.1",
  id: "Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 32 32",
  "enable-background": "new 0 0 32 32",
  "xml:space": "preserve"
};
const _hoisted_2$d = /* @__PURE__ */ createElementVNode("g", null, [
  /* @__PURE__ */ createElementVNode("path", { d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\n		S22.6,28,16,28z" }),
  /* @__PURE__ */ createElementVNode("path", { d: "M17,15.6V7c0-0.6-0.4-1-1-1s-1,0.4-1,1v9.4l4.3,4.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L17,15.6z\n		" })
], -1);
const _hoisted_3$b = [
  _hoisted_2$d
];
function render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$f, _hoisted_3$b);
}
const _sfc_main$b = defineComponent({
  name: "FormDateRangePicker",
  components: { Calendar, CalendarTime, CalendarRanges, IconClock: render$4 },
  directives: { appendToBody },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    minDate: {
      type: [String, Date],
      default() {
        return null;
      }
    },
    maxDate: {
      type: [String, Date],
      default() {
        return null;
      }
    },
    showWeekNumbers: {
      type: Boolean
    },
    linkedCalendars: {
      type: Boolean,
      default: true
    },
    singleDatePicker: {
      type: [Boolean, String]
    },
    showDropdowns: {
      type: Boolean
    },
    timePicker: {
      type: Boolean,
      default: true
    },
    timePickerIncrement: {
      type: Number,
      default: 1
    },
    timePicker24Hour: {
      type: Boolean,
      default: true
    },
    timePickerSeconds: {
      type: Boolean
    },
    autoApply: {
      type: Boolean
    },
    localeData: {
      type: Object,
      default() {
        return {};
      }
    },
    label: {
      type: String,
      default: "Date"
    },
    ranges: {
      type: [Object, Boolean],
      default() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return {
          Today: [today, today],
          Yesterday: [yesterday, yesterday],
          "This month": [thisMonthStart, thisMonthEnd],
          "This year": [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
          "Last month": [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)]
        };
      }
    },
    opens: {
      type: String,
      default: "center"
    },
    dateFormat: Function,
    alwaysShowCalendars: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    },
    controlContainerClass: {
      type: [Object, String],
      default: "daterange-picker--range-text"
    },
    appendToBody: {
      type: Boolean
    },
    calculatePosition: {
      type: Function,
      default(dropdownList, component, { width, top, left, right }) {
        if (component.opens === "center") {
          dropdownList.style.left = left + width / 2 + "px";
        } else if (component.opens === "left") {
          dropdownList.style.right = window.innerWidth - right + "px";
        } else if (component.opens === "right") {
          dropdownList.style.left = left + "px";
        }
        dropdownList.style.top = top + "px";
      }
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean
    }
  },
  emits: ["change-month", "toggle", "hoverDate", "select", "update:modelValue"],
  setup(props, { emit }) {
    const daterangepicker = ref(null);
    const dropdown = ref(null);
    const locale2 = ref({ ...DEFAULT_LOCALE, ...props.localeData });
    const startDate = ref(props.modelValue.start || null);
    const endDate = ref(props.modelValue.end || null);
    const start = ref(startDate.value ? new Date(startDate.value) : new Date());
    const end = ref(props.singleDatePicker && props.singleDatePicker !== "range" ? start.value : endDate.value ? new Date(endDate.value) : null);
    const monthDate = ref(startDate.value ? new Date(startDate.value) : new Date());
    const nextMonthDate = ref(nextMonth(monthDate.value));
    const showCustomRangeCalendars = ref(false);
    const state = reactive({
      locale: locale2,
      open: false,
      inSelection: false,
      start,
      end,
      monthDate,
      nextMonthDate,
      showRanges: computed(() => props.ranges !== false && !props.readonly),
      showCalendars: computed(() => props.alwaysShowCalendars || showCustomRangeCalendars.value),
      startText: computed(() => {
        if (state.start === null) {
          return "";
        }
        return format(state.start, locale2.value.format);
      }),
      endText: computed(() => {
        if (state.end === null) {
          return "";
        }
        return format(state.end, locale2.value.format);
      }),
      rangeText: computed(() => {
        let range = state.startText;
        if (!props.singleDatePicker || props.singleDatePicker === "range") {
          range += locale2.value.separator + state.endText;
        }
        return range;
      }),
      min: computed(() => {
        return state.minDate ? new Date(state.minDate) : null;
      }),
      max: computed(() => {
        return state.maxDate ? new Date(state.maxDate) : null;
      }),
      pickerStyles: computed(() => {
        return {
          "show-calendar": state.open || props.opens === "inline",
          "show-ranges": state.showRanges,
          "show-weeknumbers": props.showWeekNumbers,
          single: props.singleDatePicker,
          ["opens" + props.opens]: true,
          linked: props.linkedCalendars,
          "hide-calendars": !state.showCalendars
        };
      })
    });
    watch(() => state.open, (value) => {
      if (typeof document === "object") {
        nextTick(() => {
          value ? document.body.addEventListener("click", clickAway) : document.body.removeEventListener("click", clickAway);
          value ? document.addEventListener("keydown", handleEscape) : document.removeEventListener("keydown", handleEscape);
          if (!props.alwaysShowCalendars && state.ranges) {
            showCustomRangeCalendars.value = !Object.keys(state.ranges).find((key) => {
              return isSameDay(state.start, state.ranges[key][0]) && isSameDay(state.end, state.ranges[key][1]);
            });
          }
        });
      }
    }, { immediate: true });
    function dateFormatFn(classes, date) {
      const dt = new Date(date);
      dt.setHours(0, 0, 0, 0);
      const start2 = new Date(state.start);
      start2.setHours(0, 0, 0, 0);
      const end2 = new Date(state.end);
      end2.setHours(0, 0, 0, 0);
      classes["in-range"] = dt >= start2 && dt <= end2;
      return props.dateFormat ? props.dateFormat(classes, date) : classes;
    }
    function changeLeftMonth(value) {
      const newDate = new Date(value.year, value.month - 1, 1);
      state.monthDate = newDate;
      if (props.linkedCalendars || yearMonth(state.monthDate) >= yearMonth(state.nextMonthDate)) {
        state.nextMonthDate = validateDateRange(nextMonth(newDate), props.minDate, props.maxDate);
        if ((!props.singleDatePicker || props.singleDatePicker === "range") && yearMonth(state.monthDate) === yearMonth(state.nextMonthDate)) {
          state.monthDate = validateDateRange(prevMonth(state.monthDate), props.minDate, props.maxDate);
        }
      }
      emit("change-month", state.monthDate, 0);
    }
    function changeRightMonth(value) {
      const newDate = new Date(value.year, value.month - 1, 1);
      state.nextMonthDate = newDate;
      if (props.linkedCalendars || yearMonth(state.nextMonthDate) <= yearMonth(state.monthDate)) {
        state.monthDate = validateDateRange(prevMonth(newDate), props.minDate, props.maxDate);
        if (yearMonth(state.monthDate) === yearMonth(state.nextMonthDate)) {
          state.nextMonthDate = validateDateRange(nextMonth(state.nextMonthDate), props.minDate, props.maxDate);
        }
      }
      emit("change-month", state.monthDate, 1);
    }
    function normalizeDatetime(value, oldValue) {
      const newDate = new Date(value);
      if (props.timePicker && oldValue) {
        newDate.setHours(oldValue.getHours());
        newDate.setMinutes(oldValue.getMinutes());
        newDate.setSeconds(oldValue.getSeconds());
        newDate.setMilliseconds(oldValue.getMilliseconds());
      }
      return newDate;
    }
    function onDateClick(value) {
      if (props.readonly) {
        return false;
      }
      if (state.inSelection) {
        state.inSelection = false;
        state.end = normalizeDatetime(value, state.end);
        if (state.end < state.start) {
          state.inSelection = true;
          state.start = normalizeDatetime(value, state.start);
        }
        if (!state.inSelection) {
          onSelect();
          if (props.autoApply) {
            onClickApply();
          }
        }
      } else {
        state.start = normalizeDatetime(value, state.start);
        state.end = normalizeDatetime(value, state.end);
        if (!props.singleDatePicker || props.singleDatePicker === "range") {
          state.inSelection = true;
        } else {
          onSelect();
          if (props.autoApply) {
            onClickApply();
          }
        }
      }
    }
    function onHoverDate(value) {
      if (props.readonly) {
        return false;
      }
      const dt = normalizeDatetime(value, state.end);
      if (state.inSelection && dt >= state.start) {
        state.end = dt;
      }
      emit("hoverDate", value);
    }
    function togglePicker(value, event) {
      if (typeof value === "boolean") {
        state.open = value;
      } else {
        state.open = !state.open;
      }
      if (event) {
        emit("toggle", state.open, togglePicker);
      }
    }
    function onClickPicker() {
      if (!props.disabled) {
        togglePicker(null, true);
      }
    }
    function onClickApply() {
      togglePicker(false, true);
      if (props.singleDatePicker && props.singleDatePicker !== "range") {
        emit("update:modelValue", state.start);
      } else {
        emit("update:modelValue", {
          start: state.start,
          end: state.end
        });
      }
    }
    function onClickCancel() {
      if (state.open) {
        const startDate2 = props.modelValue.start || state.start;
        const endDate2 = props.modelValue.end || state.end;
        state.start = startDate2 ? new Date(startDate2) : null;
        state.end = endDate2 ? new Date(endDate2) : null;
        togglePicker(false, true);
      }
    }
    function onSelect() {
      emit("select", {
        start: state.start,
        end: state.end
      });
    }
    function clickAway($event) {
      if ($event && $event.target && !daterangepicker.value.contains($event.target) && dropdown.value && !dropdown.value.contains($event.target)) {
        onClickCancel();
      }
    }
    function onClickRange(value) {
      state.inSelection = false;
      if (isValid(value[0]) && isValid(value[1])) {
        state.start = validateDateRange(new Date(value[0]), props.minDate, props.maxDate);
        state.end = validateDateRange(new Date(value[1]), props.minDate, props.maxDate);
        changeLeftMonth({
          month: state.start.getMonth() + 1,
          year: state.start.getFullYear()
        });
      } else {
        state.start = null;
        state.end = null;
      }
      onSelect();
      if (props.autoApply) {
        onClickApply();
      }
    }
    function onUpdateStartTime(value) {
      const newStart = new Date(state.start);
      newStart.setHours(value.hours);
      newStart.setMinutes(value.minutes);
      newStart.setSeconds(value.seconds);
      state.start = validateDateRange(newStart, props.minDate, props.maxDate);
      if (props.autoApply) {
        if (props.singleDatePicker && props.singleDatePicker !== "range") {
          emit("update:modelValue", state.start);
        } else {
          emit("update:modelValue", {
            start: state.start,
            end: state.end
          });
        }
      }
    }
    function onUpdateEndTime(value) {
      const newEnd = new Date(state.end);
      newEnd.setHours(value.hours);
      newEnd.setMinutes(value.minutes);
      newEnd.setSeconds(value.seconds);
      state.end = validateDateRange(newEnd, props.minDate, props.maxDate);
      if (props.autoApply) {
        if (props.singleDatePicker && props.singleDatePicker !== "range") {
          emit("update:modelValue", state.start);
        } else {
          emit("update:modelValue", {
            start: state.start,
            end: state.end
          });
        }
      }
    }
    function handleEscape(e2) {
      if (state.open && e2.code === "Escape" && props.closeOnEsc) {
        onClickCancel();
      }
    }
    return {
      ...toRefs(state),
      daterangepicker,
      dropdown,
      showCustomRangeCalendars,
      dateFormatFn,
      changeLeftMonth,
      changeRightMonth,
      onDateClick,
      onHoverDate,
      onClickPicker,
      onClickApply,
      onClickCancel,
      onClickRange,
      onUpdateStartTime,
      onUpdateEndTime,
      handleEscape
    };
  }
});
const _hoisted_1$e = /* @__PURE__ */ createElementVNode("b", { class: "caret" }, null, -1);
const _hoisted_2$c = { class: "calendars row no-gutters" };
const _hoisted_3$a = {
  key: 1,
  class: "calendars-container"
};
const _hoisted_6$5 = { class: "calendar-table" };
const _hoisted_7$5 = {
  key: 0,
  class: "dropdown-calendar col right"
};
const _hoisted_10$4 = { class: "calendar-table" };
const _hoisted_11$4 = {
  key: 0,
  class: "dropdown-buttons"
};
const _hoisted_12$4 = {
  key: 0,
  class: "dropdown-selected"
};
const _hoisted_13$3 = ["disabled"];
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconClock = resolveComponent("IconClock");
  const _component_CalendarRanges = resolveComponent("CalendarRanges");
  const _component_Calendar = resolveComponent("Calendar");
  const _component_CalendarTime = resolveComponent("CalendarTime");
  const _directive_append_to_body = resolveDirective("append-to-body");
  return openBlock(), createElementBlock("div", {
    ref: "daterangepicker",
    class: normalizeClass(["ozn-daterange-picker", { inline: _ctx.opens === "inline", single: _ctx.singleDatePicker }])
  }, [
    createElementVNode("div", {
      class: normalizeClass(["daterange-picker--label", { "active": _ctx.open }])
    }, toDisplayString(_ctx.label), 3),
    createElementVNode("div", {
      ref: "toggle",
      class: normalizeClass([_ctx.controlContainerClass, { "active": _ctx.open }]),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClickPicker && _ctx.onClickPicker(...args))
    }, [
      renderSlot(_ctx.$slots, "input", {
        start: _ctx.start,
        end: _ctx.end,
        ranges: _ctx.ranges
      }, () => [
        createVNode(_component_IconClock, {
          class: "ozn-icon ozn-icon--prepend",
          alt: "datetime"
        }),
        createElementVNode("span", null, toDisplayString(_ctx.rangeText), 1),
        _hoisted_1$e
      ])
    ], 2),
    createVNode(Transition, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: withCtx(() => [
        _ctx.open || _ctx.opens === "inline" ? withDirectives((openBlock(), createElementBlock("div", {
          key: 0,
          ref: "dropdown",
          class: normalizeClass(["daterange-picker dropdown-menu ltr", _ctx.pickerStyles])
        }, [
          renderSlot(_ctx.$slots, "header", {
            rangeText: _ctx.rangeText,
            locale: _ctx.locale.value,
            onClickCancel: _ctx.onClickCancel,
            onClickApply: _ctx.onClickApply,
            inSelection: _ctx.inSelection,
            autoApply: _ctx.autoApply
          }),
          createElementVNode("div", _hoisted_2$c, [
            _ctx.showRanges ? renderSlot(_ctx.$slots, "ranges", {
              key: 0,
              start: _ctx.start,
              end: _ctx.end,
              ranges: _ctx.ranges,
              click: _ctx.onClickRange
            }, () => [
              createVNode(_component_CalendarRanges, {
                class: "col-12 col-md-auto",
                "always-show-calendars": _ctx.alwaysShowCalendars,
                "locale-data": _ctx.locale,
                ranges: _ctx.ranges,
                selected: { start: _ctx.start, end: _ctx.end },
                onClick: _ctx.onClickRange,
                onShowCustomRange: _cache[1] || (_cache[1] = ($event) => _ctx.showCustomRangeCalendars.value = true)
              }, null, 8, ["always-show-calendars", "locale-data", "ranges", "selected", "onClick"])
            ]) : createCommentVNode("", true),
            _ctx.showCalendars ? (openBlock(), createElementBlock("div", _hoisted_3$a, [
              createElementVNode("div", {
                class: normalizeClass(["dropdown-calendar col left", { single: _ctx.singleDatePicker }])
              }, [
                createCommentVNode("", true),
                createElementVNode("div", _hoisted_6$5, [
                  createVNode(_component_Calendar, {
                    "month-date": _ctx.monthDate,
                    "locale-data": _ctx.locale,
                    start: _ctx.start,
                    end: _ctx.end,
                    "min-date": _ctx.min,
                    "max-date": _ctx.max,
                    "show-dropdowns": _ctx.showDropdowns,
                    "date-format": _ctx.dateFormatFn,
                    "show-week-numbers": _ctx.showWeekNumbers,
                    onChangeMonth: _ctx.changeLeftMonth,
                    onDateClick: _ctx.onDateClick,
                    onHoverDate: _ctx.onHoverDate
                  }, null, 8, ["month-date", "locale-data", "start", "end", "min-date", "max-date", "show-dropdowns", "date-format", "show-week-numbers", "onChangeMonth", "onDateClick", "onHoverDate"])
                ]),
                _ctx.timePicker && _ctx.start ? (openBlock(), createBlock(_component_CalendarTime, {
                  key: 1,
                  "minute-increment": _ctx.timePickerIncrement,
                  hour24: _ctx.timePicker24Hour,
                  "second-picker": _ctx.timePickerSeconds,
                  "current-time": _ctx.start,
                  readonly: _ctx.readonly,
                  onUpdate: _ctx.onUpdateStartTime
                }, null, 8, ["minute-increment", "hour24", "second-picker", "current-time", "readonly", "onUpdate"])) : createCommentVNode("", true)
              ], 2),
              !_ctx.singleDatePicker ? (openBlock(), createElementBlock("div", _hoisted_7$5, [
                createCommentVNode("", true),
                createElementVNode("div", _hoisted_10$4, [
                  createVNode(_component_Calendar, {
                    "month-date": _ctx.nextMonthDate,
                    "locale-data": _ctx.locale,
                    start: _ctx.start,
                    end: _ctx.end,
                    "min-date": _ctx.min,
                    "max-date": _ctx.max,
                    "show-dropdowns": _ctx.showDropdowns,
                    "date-format": _ctx.dateFormatFn,
                    "show-week-numbers": _ctx.showWeekNumbers,
                    onChangeMonth: _ctx.changeRightMonth,
                    onDateClick: _ctx.onDateClick,
                    onHoverDate: _ctx.onHoverDate
                  }, null, 8, ["month-date", "locale-data", "start", "end", "min-date", "max-date", "show-dropdowns", "date-format", "show-week-numbers", "onChangeMonth", "onDateClick", "onHoverDate"])
                ]),
                _ctx.timePicker && _ctx.end ? (openBlock(), createBlock(_component_CalendarTime, {
                  key: 1,
                  "minite-increment": _ctx.timePickerIncrement,
                  hour24: _ctx.timePicker24Hour,
                  "second-picker": _ctx.timePickerSeconds,
                  "current-time": _ctx.end,
                  readonly: _ctx.readonly,
                  onUpdate: _ctx.onUpdateEndTime
                }, null, 8, ["minite-increment", "hour24", "second-picker", "current-time", "readonly", "onUpdate"])) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ]),
          renderSlot(_ctx.$slots, "footer", {
            rangeText: _ctx.rangeText,
            locale: _ctx.locale,
            onClickCancel: _ctx.onClickCancel,
            onClickApply: _ctx.onClickApply,
            inSelection: _ctx.inSelection,
            autoApply: _ctx.autoApply
          }, () => [
            !_ctx.autoApply ? (openBlock(), createElementBlock("div", _hoisted_11$4, [
              _ctx.showCalendars ? (openBlock(), createElementBlock("span", _hoisted_12$4, toDisplayString(_ctx.rangeText), 1)) : createCommentVNode("", true),
              !_ctx.readonly ? (openBlock(), createElementBlock("button", {
                key: 1,
                class: "cancelBtn btn btn-sm btn-secondary",
                type: "button",
                onClick: _cache[2] || (_cache[2] = (...args) => _ctx.onClickCancel && _ctx.onClickCancel(...args))
              }, toDisplayString(_ctx.locale.cancelLabel), 1)) : createCommentVNode("", true),
              !_ctx.readonly ? (openBlock(), createElementBlock("button", {
                key: 2,
                class: "applyBtn btn btn-sm btn-success",
                disabled: _ctx.inSelection,
                type: "button",
                onClick: _cache[3] || (_cache[3] = (...args) => _ctx.onClickApply && _ctx.onClickApply(...args))
              }, toDisplayString(_ctx.locale.applyLabel), 9, _hoisted_13$3)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ])
        ], 2)), [
          [_directive_append_to_body]
        ]) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 2);
}
var FormDateRangePicker$1 = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$a]]);
FormDateRangePicker$1.install = (Vue) => {
  Vue.component(FormDateRangePicker$1.name, FormDateRangePicker$1);
};
const InputTypes$2 = [
  "text",
  "date",
  "time",
  "datetime",
  "email",
  "password",
  "tel",
  "year",
  "month",
  "week",
  "day",
  "number",
  "currency",
  "url"
];
const _sfc_main$a = defineComponent({
  name: "FormInput",
  extends: _sfc_main$f,
  props: {
    modelValue: {
      type: [String, Number]
    },
    value: {
      type: [String, Number]
    },
    id: {
      type: String,
      default: guid()
    },
    type: {
      type: String,
      default: "",
      enum: (value) => InputTypes$2.indexOf(value) >= 0
    },
    step: {
      type: [String, Number]
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    inputMode: {
      type: String
    },
    pattern: {
      type: String
    }
  },
  setup(props) {
    const additionalClasses = computed(() => {
      return {
        ["ozn-input--disabled"]: props.readonly
      };
    });
    const parsedType = computed(() => {
      switch (props.type) {
        case "currency":
          return "number";
        case "year":
        case "month":
        case "week":
        case "day":
        case "datetime":
          return "date";
        default:
          return props.type;
      }
    });
    return {
      additionalClasses,
      parsedType
    };
  }
});
const _hoisted_1$d = ["id", "disabled", "type", "placeholder", "autofocus", "step", "min", "max", "inputmode", "pattern"];
const _hoisted_2$b = ["for"];
const _hoisted_3$9 = {
  key: 0,
  class: "ozn-input__error-container"
};
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["ozn-input", _ctx.additionalClasses])
  }, [
    withDirectives(createElementVNode("input", {
      id: `ozn-input-${_ctx.id}`,
      ref: `ozn-input-${_ctx.id}`,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.inputVal = $event),
      disabled: _ctx.readonly,
      class: normalizeClass(`ozn-input__input input ${_ctx.inputClass} ${((_a = _ctx.error) == null ? void 0 : _a.state) ? "ozn-input--error" : ""}`),
      type: _ctx.parsedType,
      placeholder: _ctx.placeholder,
      autofocus: _ctx.autofocus,
      step: ["number", "currency"].includes(_ctx.type) ? (_b = _ctx.step) != null ? _b : 0.1 : void 0,
      min: _ctx.min,
      max: _ctx.max,
      inputmode: _ctx.inputMode,
      pattern: _ctx.pattern
    }, null, 10, _hoisted_1$d), [
      [vModelDynamic, _ctx.inputVal]
    ]),
    createElementVNode("label", {
      class: "ozn-input__label",
      for: `ozn-input-${_ctx.id}`
    }, toDisplayString(_ctx.label), 9, _hoisted_2$b),
    _ctx.error.state && _ctx.error.message ? (openBlock(), createElementBlock("div", _hoisted_3$9, [
      createElementVNode("span", null, toDisplayString(_ctx.error.message), 1)
    ])) : createCommentVNode("", true)
  ], 2);
}
var FormInput$1 = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$9]]);
FormInput$1.install = (Vue) => {
  Vue.component(FormInput$1.name, FormInput$1);
};
function isEmpty(opt) {
  if (opt === 0)
    return false;
  if (Array.isArray(opt) && opt.length === 0)
    return true;
  return !opt;
}
function not(fun) {
  return (...params) => !fun(...params);
}
function includes(str, query) {
  if (str === void 0)
    str = "undefined";
  if (str === null)
    str = "null";
  if (str === false)
    str = "false";
  const text = str.toString().toLowerCase();
  return text.indexOf(query.trim()) !== -1;
}
function filterOptions(options, search, label, customLabel) {
  return options.filter((option) => includes(customLabel(option, label), search));
}
function stripGroups(options) {
  return options.filter((option) => !option.$isLabel);
}
function flattenOptions(values, label) {
  console.log(values);
  return (options) => options.reduce((prev, curr) => {
    if (curr[values] && curr[values].length) {
      prev.push({
        $groupLabel: curr[label],
        $isLabel: true
      });
      return prev.concat(curr[values]);
    }
    return prev;
  }, []);
}
function filterGroups(search, label, values, groupLabel, customLabel) {
  return (groups) => groups.map((group) => {
    if (!group[values]) {
      console.warn("Options passed to vue-multiselect do not contain groups, despite the config.");
      return [];
    }
    const groupOptions = filterOptions(group[values], search, label, customLabel);
    return groupOptions.length ? { [groupLabel]: group[groupLabel], [values]: groupOptions } : [];
  });
}
var dist = {};
var clipboard = { exports: {} };
/*!
* clipboard.js v2.0.11
* https://clipboardjs.com/
*
* Licensed MIT © Zeno Rocha
*/
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    return function() {
      var __webpack_modules__ = {
        686: function(__unused_webpack_module, __webpack_exports__, __webpack_require__2) {
          __webpack_require__2.d(__webpack_exports__, {
            "default": function() {
              return clipboard2;
            }
          });
          var tiny_emitter = __webpack_require__2(279);
          var tiny_emitter_default = /* @__PURE__ */ __webpack_require__2.n(tiny_emitter);
          var listen = __webpack_require__2(370);
          var listen_default = /* @__PURE__ */ __webpack_require__2.n(listen);
          var src_select = __webpack_require__2(817);
          var select_default = /* @__PURE__ */ __webpack_require__2.n(src_select);
          function command(type) {
            try {
              return document.execCommand(type);
            } catch (err) {
              return false;
            }
          }
          var ClipboardActionCut = function ClipboardActionCut2(target) {
            var selectedText = select_default()(target);
            command("cut");
            return selectedText;
          };
          var actions_cut = ClipboardActionCut;
          function createFakeElement(value) {
            var isRTL = document.documentElement.getAttribute("dir") === "rtl";
            var fakeElement = document.createElement("textarea");
            fakeElement.style.fontSize = "12pt";
            fakeElement.style.border = "0";
            fakeElement.style.padding = "0";
            fakeElement.style.margin = "0";
            fakeElement.style.position = "absolute";
            fakeElement.style[isRTL ? "right" : "left"] = "-9999px";
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            fakeElement.style.top = "".concat(yPosition, "px");
            fakeElement.setAttribute("readonly", "");
            fakeElement.value = value;
            return fakeElement;
          }
          var fakeCopyAction = function fakeCopyAction2(value, options) {
            var fakeElement = createFakeElement(value);
            options.container.appendChild(fakeElement);
            var selectedText = select_default()(fakeElement);
            command("copy");
            fakeElement.remove();
            return selectedText;
          };
          var ClipboardActionCopy = function ClipboardActionCopy2(target) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
              container: document.body
            };
            var selectedText = "";
            if (typeof target === "string") {
              selectedText = fakeCopyAction(target, options);
            } else if (target instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(target === null || target === void 0 ? void 0 : target.type)) {
              selectedText = fakeCopyAction(target.value, options);
            } else {
              selectedText = select_default()(target);
              command("copy");
            }
            return selectedText;
          };
          var actions_copy = ClipboardActionCopy;
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          var ClipboardActionDefault = function ClipboardActionDefault2() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text;
            if (action !== "copy" && action !== "cut") {
              throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
            if (target !== void 0) {
              if (target && _typeof2(target) === "object" && target.nodeType === 1) {
                if (action === "copy" && target.hasAttribute("disabled")) {
                  throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                }
                if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) {
                  throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                }
              } else {
                throw new Error('Invalid "target" value, use a valid Element');
              }
            }
            if (text) {
              return actions_copy(text, {
                container
              });
            }
            if (target) {
              return action === "cut" ? actions_cut(target) : actions_copy(target, {
                container
              });
            }
          };
          var actions_default = ClipboardActionDefault;
          function clipboard_typeof(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              clipboard_typeof = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              clipboard_typeof = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return clipboard_typeof(obj);
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i2 = 0; i2 < props.length; i2++) {
              var descriptor = props[i2];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
              o2.__proto__ = p2;
              return o2;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived), result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self2, call) {
            if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self2);
          }
          function _assertThisInitialized(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              }));
              return true;
            } catch (e2) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf(o);
          }
          function getAttributeValue(suffix, element) {
            var attribute = "data-clipboard-".concat(suffix);
            if (!element.hasAttribute(attribute)) {
              return;
            }
            return element.getAttribute(attribute);
          }
          var Clipboard = /* @__PURE__ */ function(_Emitter) {
            _inherits(Clipboard2, _Emitter);
            var _super = _createSuper(Clipboard2);
            function Clipboard2(trigger, options) {
              var _this;
              _classCallCheck(this, Clipboard2);
              _this = _super.call(this);
              _this.resolveOptions(options);
              _this.listenClick(trigger);
              return _this;
            }
            _createClass(Clipboard2, [{
              key: "resolveOptions",
              value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
              }
            }, {
              key: "listenClick",
              value: function listenClick(trigger) {
                var _this2 = this;
                this.listener = listen_default()(trigger, "click", function(e2) {
                  return _this2.onClick(e2);
                });
              }
            }, {
              key: "onClick",
              value: function onClick(e2) {
                var trigger = e2.delegateTarget || e2.currentTarget;
                var action = this.action(trigger) || "copy";
                var text = actions_default({
                  action,
                  container: this.container,
                  target: this.target(trigger),
                  text: this.text(trigger)
                });
                this.emit(text ? "success" : "error", {
                  action,
                  text,
                  trigger,
                  clearSelection: function clearSelection() {
                    if (trigger) {
                      trigger.focus();
                    }
                    window.getSelection().removeAllRanges();
                  }
                });
              }
            }, {
              key: "defaultAction",
              value: function defaultAction(trigger) {
                return getAttributeValue("action", trigger);
              }
            }, {
              key: "defaultTarget",
              value: function defaultTarget(trigger) {
                var selector = getAttributeValue("target", trigger);
                if (selector) {
                  return document.querySelector(selector);
                }
              }
            }, {
              key: "defaultText",
              value: function defaultText(trigger) {
                return getAttributeValue("text", trigger);
              }
            }, {
              key: "destroy",
              value: function destroy() {
                this.listener.destroy();
              }
            }], [{
              key: "copy",
              value: function copy(target) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                };
                return actions_copy(target, options);
              }
            }, {
              key: "cut",
              value: function cut(target) {
                return actions_cut(target);
              }
            }, {
              key: "isSupported",
              value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"];
                var actions = typeof action === "string" ? [action] : action;
                var support = !!document.queryCommandSupported;
                actions.forEach(function(action2) {
                  support = support && !!document.queryCommandSupported(action2);
                });
                return support;
              }
            }]);
            return Clipboard2;
          }(tiny_emitter_default());
          var clipboard2 = Clipboard;
        },
        828: function(module2) {
          var DOCUMENT_NODE_TYPE = 9;
          if (typeof Element !== "undefined" && !Element.prototype.matches) {
            var proto = Element.prototype;
            proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
          }
          function closest(element, selector) {
            while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
              if (typeof element.matches === "function" && element.matches(selector)) {
                return element;
              }
              element = element.parentNode;
            }
          }
          module2.exports = closest;
        },
        438: function(module2, __unused_webpack_exports, __webpack_require__2) {
          var closest = __webpack_require__2(828);
          function _delegate(element, selector, type, callback, useCapture) {
            var listenerFn = listener.apply(this, arguments);
            element.addEventListener(type, listenerFn, useCapture);
            return {
              destroy: function() {
                element.removeEventListener(type, listenerFn, useCapture);
              }
            };
          }
          function delegate(elements, selector, type, callback, useCapture) {
            if (typeof elements.addEventListener === "function") {
              return _delegate.apply(null, arguments);
            }
            if (typeof type === "function") {
              return _delegate.bind(null, document).apply(null, arguments);
            }
            if (typeof elements === "string") {
              elements = document.querySelectorAll(elements);
            }
            return Array.prototype.map.call(elements, function(element) {
              return _delegate(element, selector, type, callback, useCapture);
            });
          }
          function listener(element, selector, type, callback) {
            return function(e2) {
              e2.delegateTarget = closest(e2.target, selector);
              if (e2.delegateTarget) {
                callback.call(element, e2);
              }
            };
          }
          module2.exports = delegate;
        },
        879: function(__unused_webpack_module, exports2) {
          exports2.node = function(value) {
            return value !== void 0 && value instanceof HTMLElement && value.nodeType === 1;
          };
          exports2.nodeList = function(value) {
            var type = Object.prototype.toString.call(value);
            return value !== void 0 && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports2.node(value[0]));
          };
          exports2.string = function(value) {
            return typeof value === "string" || value instanceof String;
          };
          exports2.fn = function(value) {
            var type = Object.prototype.toString.call(value);
            return type === "[object Function]";
          };
        },
        370: function(module2, __unused_webpack_exports, __webpack_require__2) {
          var is = __webpack_require__2(879);
          var delegate = __webpack_require__2(438);
          function listen(target, type, callback) {
            if (!target && !type && !callback) {
              throw new Error("Missing required arguments");
            }
            if (!is.string(type)) {
              throw new TypeError("Second argument must be a String");
            }
            if (!is.fn(callback)) {
              throw new TypeError("Third argument must be a Function");
            }
            if (is.node(target)) {
              return listenNode(target, type, callback);
            } else if (is.nodeList(target)) {
              return listenNodeList(target, type, callback);
            } else if (is.string(target)) {
              return listenSelector(target, type, callback);
            } else {
              throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
            }
          }
          function listenNode(node, type, callback) {
            node.addEventListener(type, callback);
            return {
              destroy: function() {
                node.removeEventListener(type, callback);
              }
            };
          }
          function listenNodeList(nodeList, type, callback) {
            Array.prototype.forEach.call(nodeList, function(node) {
              node.addEventListener(type, callback);
            });
            return {
              destroy: function() {
                Array.prototype.forEach.call(nodeList, function(node) {
                  node.removeEventListener(type, callback);
                });
              }
            };
          }
          function listenSelector(selector, type, callback) {
            return delegate(document.body, selector, type, callback);
          }
          module2.exports = listen;
        },
        817: function(module2) {
          function select(element) {
            var selectedText;
            if (element.nodeName === "SELECT") {
              element.focus();
              selectedText = element.value;
            } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
              var isReadOnly = element.hasAttribute("readonly");
              if (!isReadOnly) {
                element.setAttribute("readonly", "");
              }
              element.select();
              element.setSelectionRange(0, element.value.length);
              if (!isReadOnly) {
                element.removeAttribute("readonly");
              }
              selectedText = element.value;
            } else {
              if (element.hasAttribute("contenteditable")) {
                element.focus();
              }
              var selection = window.getSelection();
              var range = document.createRange();
              range.selectNodeContents(element);
              selection.removeAllRanges();
              selection.addRange(range);
              selectedText = selection.toString();
            }
            return selectedText;
          }
          module2.exports = select;
        },
        279: function(module2) {
          function E2() {
          }
          E2.prototype = {
            on: function(name2, callback, ctx) {
              var e2 = this.e || (this.e = {});
              (e2[name2] || (e2[name2] = [])).push({
                fn: callback,
                ctx
              });
              return this;
            },
            once: function(name2, callback, ctx) {
              var self2 = this;
              function listener() {
                self2.off(name2, listener);
                callback.apply(ctx, arguments);
              }
              listener._ = callback;
              return this.on(name2, listener, ctx);
            },
            emit: function(name2) {
              var data = [].slice.call(arguments, 1);
              var evtArr = ((this.e || (this.e = {}))[name2] || []).slice();
              var i2 = 0;
              var len = evtArr.length;
              for (i2; i2 < len; i2++) {
                evtArr[i2].fn.apply(evtArr[i2].ctx, data);
              }
              return this;
            },
            off: function(name2, callback) {
              var e2 = this.e || (this.e = {});
              var evts = e2[name2];
              var liveEvents = [];
              if (evts && callback) {
                for (var i2 = 0, len = evts.length; i2 < len; i2++) {
                  if (evts[i2].fn !== callback && evts[i2].fn._ !== callback)
                    liveEvents.push(evts[i2]);
                }
              }
              liveEvents.length ? e2[name2] = liveEvents : delete e2[name2];
              return this;
            }
          };
          module2.exports = E2;
          module2.exports.TinyEmitter = E2;
        }
      };
      var __webpack_module_cache__ = {};
      function __webpack_require__(moduleId) {
        if (__webpack_module_cache__[moduleId]) {
          return __webpack_module_cache__[moduleId].exports;
        }
        var module2 = __webpack_module_cache__[moduleId] = {
          exports: {}
        };
        __webpack_modules__[moduleId](module2, module2.exports, __webpack_require__);
        return module2.exports;
      }
      !function() {
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? function() {
            return module2["default"];
          } : function() {
            return module2;
          };
          __webpack_require__.d(getter, { a: getter });
          return getter;
        };
      }();
      !function() {
        __webpack_require__.d = function(exports2, definition) {
          for (var key in definition) {
            if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports2, key)) {
              Object.defineProperty(exports2, key, { enumerable: true, get: definition[key] });
            }
          }
        };
      }();
      !function() {
        __webpack_require__.o = function(obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        };
      }();
      return __webpack_require__(686);
    }().default;
  });
})(clipboard);
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(dist, "__esModule", { value: true });
var clipboard_1 = __importDefault(clipboard.exports);
var _default = dist.default = function(opts) {
  var appendToBody2 = (opts === null || opts === void 0 ? void 0 : opts.appendToBody) === void 0 ? true : opts.appendToBody;
  return {
    toClipboard: function(text, container) {
      return new Promise(function(resolve, reject) {
        var fakeEl = document.createElement("button");
        var clipboard2 = new clipboard_1.default(fakeEl, {
          text: function() {
            return text;
          },
          action: function() {
            return "copy";
          },
          container: container !== void 0 ? container : document.body
        });
        clipboard2.on("success", function(e2) {
          clipboard2.destroy();
          resolve(e2);
        });
        clipboard2.on("error", function(e2) {
          clipboard2.destroy();
          reject(e2);
        });
        if (appendToBody2)
          document.body.appendChild(fakeEl);
        fakeEl.click();
        if (appendToBody2)
          document.body.removeChild(fakeEl);
      });
    }
  };
};
const flow = (...fns) => (x2) => fns.reduce((v, f2) => f2(v), x2);
const _sfc_main$9 = defineComponent({
  name: "FormMultiSelect",
  props: {
    modelValue: {
      type: [Object, Array, String, Number],
      default: () => [],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    max: {
      type: [Number, Boolean],
      default: false
    },
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    groupValues: {
      type: String
    },
    groupLabel: {
      type: String
    },
    groupSelect: {
      type: Boolean
    },
    blockKeys: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 99999
    },
    limitText: {
      type: Function,
      default: (count) => {
        return `and ${count} more`;
      }
    },
    openDirection: {
      type: String,
      default: ""
    },
    tabindex: {
      type: Number,
      default: 0
    },
    optionHeight: {
      type: Number,
      default: 40
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    inputClass: {
      type: String,
      default: null
    },
    inputContainerClass: {
      type: String,
      default: null
    },
    taggable: {
      type: Boolean
    },
    tagPosition: {
      type: String,
      default: "top"
    },
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    searchable: {
      type: Boolean,
      default: true
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "Select option"
    },
    label: {
      type: String,
      default: ""
    },
    inputLabel: {
      type: String,
      default: ""
    },
    customLabel: {
      type: Function,
      default: (option, label) => {
        if (isEmpty(option))
          return "";
        return label ? option[label] : option;
      }
    },
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    preserveSearch: {
      type: Boolean
    },
    preselectFirst: {
      type: Boolean
    },
    multiple: {
      type: Boolean
    },
    trackBy: {
      type: String
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    resetAfter: {
      type: Boolean
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    hideSelected: {
      type: Boolean
    },
    showNoOptions: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    showPointer: {
      type: Boolean,
      default: true
    }
  },
  emits: ["tag", "close", "remove", "open", "update:modelValue", "search-change", "select", "clipboard"],
  setup(props, { emit }) {
    const rootRef = ref(null);
    const tagsRef = ref(null);
    const searchRef = ref(null);
    const listRef = ref(null);
    const { toClipboard } = _default();
    const state = reactive({
      search: ref(""),
      isOpen: ref(false),
      preferredOpenDirection: ref("below"),
      optimizedHeight: ref(props.maxHeight),
      internalValue: computed(() => {
        return props.modelValue || props.modelValue === 0 ? Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue] : [];
      }),
      filteredOptions: computed(() => {
        const search = state.search || "";
        const normalizedSearch = search.toLowerCase().trim();
        let options = props.options.concat();
        if (props.internalSearch) {
          options = props.groupValues ? filterAndFlat(options, normalizedSearch, props.label) : filterOptions(options, normalizedSearch, props.label, props.customLabel);
        } else {
          options = props.groupValues ? flattenOptions(props.groupValues, props.groupLabel)(options) : options;
        }
        options = props.hideSelected ? options.filter(not(isSelected)) : options;
        if (props.taggable && normalizedSearch.length && !isExistingOption(normalizedSearch)) {
          if (props.tagPosition === "bottom") {
            options.push({ isTag: true, label: normalizedSearch });
          } else {
            options.unshift({ isTag: true, label: normalizedSearch });
          }
        }
        return options.slice(0, props.optionsLimit);
      }),
      valueKeys: computed(() => {
        if (props.trackBy) {
          return state.internalValue.map((element) => element[props.trackBy]);
        } else {
          return state.internalValue;
        }
      }),
      optionKeys: computed(() => {
        const options = props.groupValues ? flatAndStrip(props.options) : props.options;
        return options.map((element) => props.customLabel(element, props.label).toString().toLowerCase());
      }),
      currentOptionLabel: computed(() => {
        return props.multiple ? props.searchable ? "" : props.placeholder : state.internalValue.length ? getOptionLabel(state.internalValue[0]) : props.searchable ? "" : props.placeholder;
      })
    });
    const visualState = reactive({
      isSingleLabelVisible: computed(() => {
        return (visualState.singleValue || visualState.singleValue === 0) && (!state.isOpen || !props.searchable) && !visualState.visibleValues.length;
      }),
      isPlaceholderVisible: computed(() => {
        return !state.internalValue.length && (!props.searchable || !state.isOpen);
      }),
      visibleValues: computed(() => {
        return props.multiple ? state.internalValue.slice(0, props.limit) : [];
      }),
      singleValue: computed(() => state.internalValue[0]),
      deselectLabelText: computed(() => props.showLabels ? props.deselectLabel : ""),
      deselectGroupLabelText: computed(() => props.showLabels ? props.deselectGroupLabel : ""),
      selectLabelText: computed(() => props.showLabels ? props.selectLabel : ""),
      selectGroupLabelText: computed(() => props.showLabels ? props.selectGroupLabel : ""),
      selectedLabelText: computed(() => props.showLabels ? props.selectedLabel : ""),
      inputStyle: computed(() => {
        if (props.searchable || props.multiple && props.modelValue && props.modelValue.length) {
          return state.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" };
        }
        return "";
      }),
      contentStyle: computed(() => props.options.length ? { display: "inline-block" } : { display: "block" }),
      isAbove: computed(() => {
        if (props.openDirection === "above" || props.openDirection === "top") {
          return true;
        } else if (props.openDirection === "below" || props.openDirection === "bottom") {
          return false;
        } else {
          return state.preferredOpenDirection === "above";
        }
      })
    });
    const pointerState = reactive({
      pointer: 0,
      pointerDirty: false,
      pointerPosition: computed(() => pointerState.pointer * props.optionHeight),
      visibleElement: computed(() => state.optimizedHeight / props.optionHeight)
    });
    onMounted(() => {
      if (!props.multiple && !props.clearOnSelect) {
        console.warn("[Vue-Multiselect warn]: ClearOnSelect and Multiple props can\u2019t be both set to false.");
      }
      if (!props.multiple && props.max) {
        console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false.");
      }
      if (props.preselectFirst && !state.internalValue.length && props.options.length) {
        select(state.filteredOptions[0]);
      }
    });
    watch(() => state.internalValue, () => {
      if (props.resetAfter && state.internalValue.length) {
        state.search = "";
        emit("update:modelValue", props.multiple ? [] : null);
      }
    });
    watch(() => state.search, () => {
      emit("search-change", state.search);
    });
    watch(() => state.filteredOptions, () => {
      pointerAdjust();
    });
    watch(() => state.isOpen, () => {
      pointerState.pointerDirty = false;
    });
    watch(() => pointerState.pointer, () => {
      searchRef.value.setAttribute("aria-activedescendant", props.id + "-" + pointerState.pointer.toString());
    });
    function getValue() {
      return props.multiple ? state.internalValue : state.internalValue.length === 0 ? null : state.internalValue[0];
    }
    function filterAndFlat(options, search, label) {
      return flow(
        filterGroups(search, label, props.groupValues, props.groupLabel, props.customLabel),
        flattenOptions(props.groupValues, props.groupLabel)
      )(options);
    }
    function flatAndStrip(options) {
      return flow(
        flattenOptions(props.groupValues, props.groupLabel),
        stripGroups
      )(options);
    }
    function updateSearch(query) {
      state.search = query;
    }
    function isExistingOption(query) {
      return !props.options ? false : state.optionKeys.indexOf(query) > -1;
    }
    function isSelected(option) {
      const opt = props.trackBy ? option[props.trackBy] : option;
      return state.valueKeys.indexOf(opt) > -1;
    }
    function isOptionDisabled(option) {
      return !!option.$isDisabled;
    }
    function getOptionLabel(option) {
      var _a;
      if (isEmpty(option))
        return "";
      if (option.isTag || ((_a = option.value) != null ? _a : option.label))
        return option.label;
      if (option.$isLabel)
        return option.$groupLabel;
      const label = props.customLabel(option, props.label);
      if (isEmpty(label))
        return "";
      return label;
    }
    function select(option, key) {
      if (option.$isLabel && props.groupSelect) {
        selectGroup(option);
        return;
      }
      if (props.blockKeys.indexOf(key) !== -1 || props.disabled || option.$isLabel || option.$isDisabled)
        return;
      if (props.max && props.multiple && state.internalValue.length === props.max)
        return;
      if (key === "Tab" && !pointerState.pointerDirty)
        return;
      if (option.isTag) {
        emit("tag", option.label, props.id);
        state.search = "";
        if (props.closeOnSelect && !props.multiple)
          deactivate();
      } else {
        if (isSelected(option)) {
          if (key !== "Tab")
            removeElement(option);
          return;
        }
        emit("select", option, props.id);
        if (props.multiple) {
          emit("update:modelValue", state.internalValue.concat([option]));
        } else {
          emit("update:modelValue", option);
        }
        if (props.clearOnSelect)
          state.search = "";
      }
      if (props.closeOnSelect)
        deactivate();
    }
    function selectGroup(selectedGroup) {
      const group = props.options.find((option) => {
        return option[props.groupLabel] === selectedGroup.$groupLabel;
      });
      if (!group)
        return;
      if (wholeGroupSelected(group)) {
        emit("remove", group[props.groupValues], props.id);
        const newValue = state.internalValue.filter(
          (option) => group[props.groupValues].indexOf(option) === -1
        );
        emit("update:modelValue", newValue);
      } else {
        const optionsToAdd = group[props.groupValues].filter(
          (option) => !(isOptionDisabled(option) || isSelected(option))
        );
        emit("select", optionsToAdd, props.id);
        emit("update:modelValue", state.internalValue.concat(optionsToAdd));
      }
      if (props.closeOnSelect)
        deactivate();
    }
    function wholeGroupSelected(group) {
      return group[props.groupValues].every((option) => isSelected(option) || isOptionDisabled(option));
    }
    function wholeGroupDisabled(group) {
      return group[props.groupValues].every(isOptionDisabled);
    }
    function removeElement(option, shouldClose = true) {
      if (props.disabled)
        return;
      if (option.$isDisabled)
        return;
      if (!props.allowEmpty && state.internalValue.length <= 1) {
        deactivate();
        return;
      }
      const index2 = typeof option === "object" ? state.valueKeys.indexOf(option[props.trackBy]) : state.valueKeys.indexOf(option);
      state.internalValue.splice(index2, 1);
      emit("update:modelValue", getValue(), props.id);
      emit("remove", option, props.id);
      if (props.closeOnSelect && shouldClose)
        deactivate();
    }
    function removeLastElement() {
      if (props.blockKeys.indexOf("Delete") !== -1)
        return;
      if (state.search.length === 0 && Array.isArray(state.internalValue) && state.internalValue.length) {
        removeElement(state.internalValue[state.internalValue.length - 1], false);
      }
    }
    function activate() {
      if (state.isOpen || props.disabled)
        return;
      adjustPosition();
      if (props.groupValues && pointerState.pointer === 0 && state.filteredOptions.length) {
        pointerState.pointer = 1;
      }
      state.isOpen = true;
      if (props.searchable) {
        if (!props.preserveSearch)
          state.search = "";
        nextTick(() => searchRef.value && searchRef.value.focus());
      } else {
        rootRef.value.focus();
      }
      emit("open", props.id);
    }
    function deactivate() {
      if (!state.isOpen)
        return;
      state.isOpen = false;
      if (props.searchable) {
        searchRef.value.blur();
      } else {
        rootRef.value.blur();
      }
      if (!props.preserveSearch)
        state.search = "";
      emit("close", getValue(), props.id);
    }
    function toggle() {
      state.isOpen ? deactivate() : activate();
    }
    function adjustPosition() {
      if (typeof window === "undefined")
        return;
      const spaceAbove = rootRef.value.getBoundingClientRect().top;
      const spaceBelow = window.innerHeight - rootRef.value.getBoundingClientRect().bottom;
      const hasEnoughSpaceBelow = spaceBelow > props.maxHeight;
      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || props.openDirection === "below" || props.openDirection === "bottom") {
        state.preferredOpenDirection = "below";
        state.optimizedHeight = Math.min(spaceBelow - 40, props.maxHeight);
      } else {
        state.preferredOpenDirection = "above";
        state.optimizedHeight = Math.min(spaceAbove - 40, props.maxHeight);
      }
    }
    function optionHighlight(index2, option) {
      return {
        "multiselect__option--highlight": index2 === pointerState.pointer && props.showPointer,
        "multiselect__option--selected": isSelected(option)
      };
    }
    function groupHighlight(index2, selectedGroup) {
      if (!props.groupSelect) {
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": selectedGroup.$isLabel }
        ];
      }
      const group = props.options.find((option) => {
        return option[props.groupLabel] === selectedGroup.$groupLabel;
      });
      return group && !wholeGroupDisabled(group) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": index2 === pointerState.pointer && props.showPointer },
        { "multiselect__option--group-selected": wholeGroupSelected(group) }
      ] : "multiselect__option--disabled";
    }
    function addPointerElement({ key = "Enter" }) {
      if (state.filteredOptions.length > 0) {
        select(state.filteredOptions[pointerState.pointer], key);
      }
      pointerReset();
    }
    function pointerForward() {
      if (pointerState.pointer < state.filteredOptions.length - 1) {
        pointerState.pointer++;
        if (listRef.value.scrollTop <= pointerState.pointerPosition - (state.visibleElements - 1) * props.optionHeight) {
          listRef.value.scrollTop = pointerState.pointerPosition - (state.visibleElements - 1) * props.optionHeight;
        }
        if (state.filteredOptions[pointerState.pointer].$isLabel)
          pointerForward();
      }
      pointerState.pointerDirty = true;
    }
    function pointerBackward() {
      if (pointerState.pointer > 0) {
        pointerState.pointer--;
        if (listRef.value.scrollTop >= pointerState.pointerPosition) {
          listRef.value.scrollTop = pointerState.pointerPosition;
        }
        if (state.filteredOptions[pointerState.pointer].$isLabel)
          pointerBackward();
      } else {
        if (state.filteredOptions[0].$isLabel)
          pointerForward();
      }
      pointerState.pointerDirty = true;
    }
    function pointerReset() {
      if (!props.closeOnSelect)
        return;
      pointerState.pointer = 0;
      if (listRef.value !== null) {
        listRef.value.scrollTop = 0;
      }
    }
    function pointerAdjust() {
      if (pointerState.pointer >= state.filteredOptions.length - 1) {
        pointerState.pointer = state.filteredOptions.length ? state.filteredOptions.length - 1 : 0;
      }
      if (state.filteredOptions.length > 0 && state.filteredOptions[pointerState.pointer].$isLabel && !props.groupSelect) {
        pointerForward();
      }
    }
    function pointerSet(index2) {
      pointerState.pointer = index2;
      pointerState.pointerDirty = true;
    }
    return {
      ...toRefs(state),
      ...toRefs(visualState),
      ...toRefs(pointerState),
      rootRef,
      tagsRef,
      clipboard: debounce(async (data) => {
        await toClipboard(data);
        emit("clipboard", data);
      }, 300),
      searchRef,
      listRef,
      getValue,
      filterAndFlat,
      flatAndStrip,
      updateSearch,
      isExistingOption,
      isSelected,
      isOptionDisabled,
      getOptionLabel,
      select,
      selectGroup,
      wholeGroupSelected,
      wholeGroupDisabled,
      removeElement,
      removeLastElement,
      activate,
      deactivate,
      toggle,
      optionHighlight,
      groupHighlight,
      addPointerElement,
      pointerForward,
      pointerBackward,
      pointerReset,
      pointerAdjust,
      pointerSet
    };
  }
});
const _hoisted_1$c = ["tabindex", "aria-owns"];
const _hoisted_2$a = {
  ref: "tagsRef",
  class: "multiselect__tags"
};
const _hoisted_3$8 = { class: "multiselect__tags-wrap" };
const _hoisted_4$7 = ["onClick"];
const _hoisted_5$4 = ["textContent"];
const _hoisted_6$4 = ["onKeypress", "onMousedown"];
const _hoisted_7$4 = ["textContent"];
const _hoisted_8$4 = { class: "multiselect__spinner" };
const _hoisted_9$3 = ["id", "name", "placeholder", "value", "disabled", "tabindex", "aria-controls"];
const _hoisted_10$3 = ["id"];
const _hoisted_11$3 = { key: 0 };
const _hoisted_12$3 = { class: "multiselect__option" };
const _hoisted_13$2 = ["id", "role"];
const _hoisted_14$2 = ["data-select", "data-selected", "data-deselect", "onClick", "onMouseenter"];
const _hoisted_15$1 = ["data-select", "data-deselect", "onMouseenter", "onMousedown"];
const _hoisted_16$1 = { class: "multiselect__option" };
const _hoisted_17 = { class: "multiselect__option" };
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "rootRef",
    tabindex: _ctx.searchable ? -1 : _ctx.tabindex,
    class: normalizeClass([{ "multiselect--active": _ctx.isOpen, "multiselect--disabled": _ctx.disabled, "multiselect--above": _ctx.isAbove, "multiselect--has-options": _ctx.filteredOptions.length > 0 }, "multiselect"]),
    role: "combobox",
    "aria-owns": "listbox-" + _ctx.id,
    onFocus: _cache[13] || (_cache[13] = ($event) => _ctx.activate()),
    onBlur: _cache[14] || (_cache[14] = ($event) => _ctx.searchable ? false : _ctx.deactivate()),
    onKeydown: [
      _cache[15] || (_cache[15] = withKeys(withModifiers(($event) => _ctx.pointerForward(), ["self", "prevent"]), ["down"])),
      _cache[16] || (_cache[16] = withKeys(withModifiers(($event) => _ctx.pointerBackward(), ["self", "prevent"]), ["up"]))
    ],
    onKeypress: _cache[17] || (_cache[17] = withKeys(withModifiers(($event) => _ctx.addPointerElement($event), ["stop", "self"]), ["enter", "tab"])),
    onKeyup: _cache[18] || (_cache[18] = withKeys(($event) => _ctx.deactivate(), ["esc"]))
  }, [
    renderSlot(_ctx.$slots, "caret", { toggle: _ctx.toggle }, () => [
      createElementVNode("div", {
        class: "multiselect__select",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.toggle(), ["prevent", "stop"]))
      }, null, 32)
    ]),
    renderSlot(_ctx.$slots, "clear", { search: _ctx.search }),
    createElementVNode("div", {
      class: normalizeClass(["multiselect__label", { disabled: _ctx.disabled }])
    }, toDisplayString(_ctx.inputLabel), 3),
    createElementVNode("div", _hoisted_2$a, [
      renderSlot(_ctx.$slots, "selection", {
        search: _ctx.search,
        remove: _ctx.removeElement,
        values: _ctx.visibleValues,
        isOpen: _ctx.isOpen
      }, () => [
        withDirectives(createElementVNode("div", _hoisted_3$8, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.visibleValues, (option, index2) => {
            return renderSlot(_ctx.$slots, "tag", {
              option,
              search: _ctx.search,
              remove: _ctx.removeElement
            }, () => [
              (openBlock(), createElementBlock("span", {
                key: index2,
                class: "multiselect__tag",
                onClick: ($event) => _ctx.clipboard(_ctx.getOptionLabel(option))
              }, [
                createElementVNode("span", {
                  textContent: toDisplayString(_ctx.getOptionLabel(option))
                }, null, 8, _hoisted_5$4),
                createElementVNode("i", {
                  tabindex: "1",
                  class: "multiselect__tag-icon",
                  onKeypress: withKeys(withModifiers(($event) => _ctx.removeElement(option), ["prevent"]), ["enter"]),
                  onMousedown: withModifiers(($event) => _ctx.removeElement(option), ["prevent"])
                }, null, 40, _hoisted_6$4)
              ], 8, _hoisted_4$7))
            ]);
          }), 256))
        ], 512), [
          [vShow, _ctx.visibleValues.length > 0]
        ]),
        _ctx.internalValue && _ctx.internalValue.length > _ctx.limit ? renderSlot(_ctx.$slots, "limit", { key: 0 }, () => [
          createElementVNode("strong", {
            class: "multiselect__strong",
            textContent: toDisplayString(_ctx.limitText(_ctx.internalValue.length - _ctx.limit))
          }, null, 8, _hoisted_7$4)
        ]) : createCommentVNode("", true)
      ]),
      createVNode(Transition, { name: "multiselect__loading" }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "loading", {}, () => [
            withDirectives(createElementVNode("div", _hoisted_8$4, null, 512), [
              [vShow, _ctx.loading]
            ])
          ])
        ]),
        _: 3
      }),
      _ctx.searchable ? (openBlock(), createElementBlock("input", {
        key: 0,
        id: _ctx.id,
        ref: "searchRef",
        name: _ctx.name,
        type: "text",
        autocomplete: "off",
        spellcheck: "false",
        placeholder: _ctx.placeholder,
        style: normalizeStyle(_ctx.inputStyle),
        value: _ctx.search,
        disabled: _ctx.disabled,
        tabindex: _ctx.tabindex,
        class: "multiselect__input",
        "aria-controls": "listbox-" + _ctx.id,
        onInput: _cache[1] || (_cache[1] = ($event) => _ctx.updateSearch($event.target.value)),
        onFocus: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.activate(), ["prevent"])),
        onBlur: _cache[3] || (_cache[3] = withModifiers(($event) => _ctx.deactivate(), ["prevent"])),
        onKeyup: _cache[4] || (_cache[4] = withKeys(($event) => _ctx.deactivate(), ["esc"])),
        onKeydown: [
          _cache[5] || (_cache[5] = withKeys(withModifiers(($event) => _ctx.pointerForward(), ["prevent"]), ["down"])),
          _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => _ctx.pointerBackward(), ["prevent"]), ["up"])),
          _cache[8] || (_cache[8] = withKeys(withModifiers(($event) => _ctx.removeLastElement(), ["stop"]), ["delete"]))
        ],
        onKeypress: _cache[7] || (_cache[7] = withKeys(withModifiers(($event) => _ctx.addPointerElement($event), ["prevent", "stop", "self"]), ["enter"]))
      }, null, 44, _hoisted_9$3)) : createCommentVNode("", true),
      _ctx.isSingleLabelVisible ? (openBlock(), createElementBlock("span", {
        key: 1,
        class: "multiselect__single",
        onMousedown: _cache[9] || (_cache[9] = withModifiers((...args) => _ctx.toggle && _ctx.toggle(...args), ["prevent"]))
      }, [
        renderSlot(_ctx.$slots, "singleLabel", { option: _ctx.singleValue }, () => [
          createTextVNode(toDisplayString(_ctx.currentOptionLabel), 1)
        ])
      ], 32)) : createCommentVNode("", true),
      _ctx.isPlaceholderVisible ? (openBlock(), createElementBlock("span", {
        key: 2,
        class: "multiselect__placeholder",
        onMousedown: _cache[10] || (_cache[10] = withModifiers((...args) => _ctx.toggle && _ctx.toggle(...args), ["prevent"]))
      }, [
        renderSlot(_ctx.$slots, "placeholder", {}, () => [
          createTextVNode(toDisplayString(_ctx.placeholder), 1)
        ])
      ], 32)) : createCommentVNode("", true)
    ], 512),
    _ctx.filteredOptions.length > 0 ? (openBlock(), createBlock(Transition, {
      key: 0,
      name: "multiselect"
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          ref: "list",
          class: "multiselect__content-wrapper",
          tabindex: "-1",
          style: normalizeStyle({ maxHeight: _ctx.optimizedHeight + "px" }),
          onFocus: _cache[11] || (_cache[11] = (...args) => _ctx.activate && _ctx.activate(...args)),
          onMousedown: _cache[12] || (_cache[12] = withModifiers(() => {
          }, ["prevent"]))
        }, [
          createElementVNode("ul", {
            id: "listbox-" + _ctx.id,
            class: "multiselect__content",
            style: normalizeStyle(_ctx.contentStyle),
            role: "listbox"
          }, [
            renderSlot(_ctx.$slots, "beforeList"),
            _ctx.multiple && _ctx.max === _ctx.internalValue.length ? (openBlock(), createElementBlock("li", _hoisted_11$3, [
              createElementVNode("span", _hoisted_12$3, [
                renderSlot(_ctx.$slots, "maxElements", {}, () => [
                  createTextVNode("Maximum of " + toDisplayString(_ctx.max) + " options selected. First remove a selected option to select another.", 1)
                ])
              ])
            ])) : createCommentVNode("", true),
            !_ctx.max || _ctx.internalValue.length < _ctx.max ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.filteredOptions, (option, index2) => {
              return openBlock(), createElementBlock("li", {
                id: _ctx.id + "-" + index2,
                key: index2,
                class: "multiselect__element",
                role: !(option && (option.$isLabel || option.$isDisabled)) ? "option" : null
              }, [
                !(option && (option.$isLabel || option.$isDisabled)) ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  class: normalizeClass([_ctx.optionHighlight(index2, option), "multiselect__option"]),
                  "data-select": option && option.isTag ? _ctx.tagPlaceholder : _ctx.selectLabelText,
                  "data-selected": _ctx.selectedLabelText,
                  "data-deselect": _ctx.deselectLabelText,
                  onClick: withModifiers(($event) => _ctx.select(option), ["stop"]),
                  onMouseenter: withModifiers(($event) => _ctx.pointerSet(index2), ["self"])
                }, [
                  renderSlot(_ctx.$slots, "option", {
                    option,
                    search: _ctx.search,
                    index: index2
                  }, () => [
                    createElementVNode("span", null, toDisplayString(_ctx.getOptionLabel(option)), 1)
                  ])
                ], 42, _hoisted_14$2)) : createCommentVNode("", true),
                option && (option.$isLabel || option.$isDisabled) ? (openBlock(), createElementBlock("span", {
                  key: 1,
                  "data-select": _ctx.groupSelect && _ctx.selectGroupLabelText,
                  "data-deselect": _ctx.groupSelect && _ctx.deselectGroupLabelText,
                  class: normalizeClass([_ctx.groupHighlight(index2, option), "multiselect__option"]),
                  onMouseenter: withModifiers(($event) => _ctx.groupSelect && _ctx.pointerSet(index2), ["self"]),
                  onMousedown: withModifiers(($event) => _ctx.selectGroup(option), ["prevent"])
                }, [
                  renderSlot(_ctx.$slots, "option", {
                    option,
                    search: _ctx.search,
                    index: index2
                  }, () => [
                    createElementVNode("span", null, toDisplayString(_ctx.getOptionLabel(option)), 1)
                  ])
                ], 42, _hoisted_15$1)) : createCommentVNode("", true)
              ], 8, _hoisted_13$2);
            }), 128)) : createCommentVNode("", true),
            withDirectives(createElementVNode("li", null, [
              createElementVNode("span", _hoisted_16$1, [
                renderSlot(_ctx.$slots, "noResult", { search: _ctx.search }, () => [
                  createTextVNode("No elements found. Consider changing the search query.")
                ])
              ])
            ], 512), [
              [vShow, _ctx.showNoResults && (_ctx.filteredOptions.length === 0 && _ctx.search && !_ctx.loading)]
            ]),
            withDirectives(createElementVNode("li", null, [
              createElementVNode("span", _hoisted_17, [
                renderSlot(_ctx.$slots, "noOptions", {}, () => [
                  createTextVNode("List is empty.")
                ])
              ])
            ], 512), [
              [vShow, _ctx.showNoOptions && (_ctx.options.length === 0 && !_ctx.search && !_ctx.loading)]
            ]),
            renderSlot(_ctx.$slots, "afterList")
          ], 12, _hoisted_10$3)
        ], 36), [
          [vShow, _ctx.isOpen]
        ])
      ]),
      _: 3
    })) : createCommentVNode("", true)
  ], 42, _hoisted_1$c);
}
var FormMultiSelect = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$8]]);
FormMultiSelect.install = (Vue) => {
  Vue.component(FormMultiSelect.name, FormMultiSelect);
};
const InputTypes$1 = [
  "check",
  "radio",
  "list-item"
];
const _sfc_main$8 = defineComponent({
  name: "FormSelectOption",
  extends: _sfc_main$f,
  props: {
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    modelValue: {
      type: [String, Number, Array, Object, Boolean],
      required: true
    },
    data: {
      type: [String, Number, Array, Object, Boolean]
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "",
      enum: (value) => InputTypes$1.indexOf(value) >= 0
    }
  }
});
const _hoisted_1$b = { class: "ozn-select-option" };
const _hoisted_2$9 = ["for"];
const _hoisted_3$7 = ["id", "value", "type"];
const _hoisted_4$6 = /* @__PURE__ */ createElementVNode("span", { class: "ozn-select-option__slider" }, null, -1);
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    createElementVNode("label", {
      for: `opt-${_ctx.id}`,
      class: "ozn-select-option__label"
    }, toDisplayString(_ctx.label), 9, _hoisted_2$9),
    _ctx.type !== "list-item" ? withDirectives((openBlock(), createElementBlock("input", {
      key: 0,
      id: `opt-${_ctx.id}`,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.inputVal = $event),
      value: _ctx.data,
      class: normalizeClass(`ozn-select-option__input--${_ctx.inputClass}`),
      type: _ctx.type
    }, null, 10, _hoisted_3$7)), [
      [vModelDynamic, _ctx.inputVal]
    ]) : createCommentVNode("", true),
    _hoisted_4$6
  ]);
}
var FormSelectOption = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$7]]);
FormSelectOption.install = (Vue) => {
  Vue.component(FormSelectOption.name, FormSelectOption);
};
const InputTypes = [
  "boolean",
  "array",
  "multi-select",
  "select",
  "tag",
  "single",
  "multi",
  "multi-list",
  "dropdown",
  "toggle"
];
const DEFAULT_ERROR_STATE = {
  state: false,
  message: ""
};
const _sfc_main$7 = defineComponent({
  name: "FormSelect",
  components: { FormSelectOption, FormMultiSelect },
  extends: _sfc_main$f,
  props: {
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    modelValue: {
      type: [String, Number, Array, Object, Boolean],
      required: true
    },
    placeholder: {
      type: String,
      default: "Type or click for options"
    },
    for: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "",
      enum: (value) => InputTypes.indexOf(value) >= 0
    },
    options: {
      type: Array,
      default: () => []
    },
    validator: {
      type: Function,
      default: (e2) => true
    }
  },
  emits: ["select", "remove", "tag", "invalid", "update:modelValue", "clipboard"],
  setup(props, { emit }) {
    const state = reactive({
      show: false,
      error: { state: false, message: "" },
      inputVal: computed({
        get: () => props.modelValue,
        set: (val) => {
          state.error = DEFAULT_ERROR_STATE;
          const validate2 = props.validator;
          const valid = validate2(val);
          if (typeof valid === "object" && valid.value === true || typeof valid !== "object" && valid) {
            state.error = { state: false, message: "" };
            emit("update:modelValue", val);
          } else {
            state.error = { state: true, message: typeof valid === "object" ? valid.message || "Invalid input" : "Invalid input" };
            emit("invalid", val, valid);
          }
        }
      })
    });
    const parsedOptions = computed(() => {
      return props.options.map((option) => {
        if (typeof option === "string") {
          return option;
        } else {
          return typeof option === "object" ? option : { label: option.toString(), value: option };
        }
      });
    });
    const optionType = computed(() => {
      switch (props.type) {
        case "single":
          return "radio";
        case "boolean":
        case "toggle":
        case "multi-list":
          return "checkbox";
        case "array":
        case "multi":
        case "multi-select":
          return "multi-select";
        case "tag":
          return "tag";
        case "select":
        case "dropdown":
          return "select";
        default:
          return "list-item";
      }
    });
    function emitTag(label, value, current = []) {
      const validate2 = props.validator;
      const valid = validate2([{ label, value }]);
      if (typeof valid === "object" && valid.value === true || typeof valid !== "object" && valid) {
        state.error = { state: false, message: "" };
        if (props.options.length && typeof props.options[0] === "object") {
          emit("update:modelValue", [...current || [], { label, value: value || label }]);
        } else {
          emit("update:modelValue", [...current || [], value || label]);
        }
      } else {
        state.error = { state: true, message: typeof valid === "object" ? valid.message || "Invalid input" : "Invalid input" };
        emit("invalid", [{ label, value }], valid);
      }
      emit("tag", label);
    }
    return {
      ...toRefs(state),
      optionType,
      parsedOptions,
      emitSelect: (e2) => emit("select", e2),
      emitTag,
      emitClip: (v) => emit("clipboard", v),
      emitRemove: (r) => emit("remove", r)
    };
  },
  computed: { guid }
});
const _hoisted_1$a = { class: "ozn-select" };
const _hoisted_2$8 = {
  key: 0,
  class: "ozn-select__dropdown"
};
const _hoisted_3$6 = { key: 0 };
const _hoisted_4$5 = { key: 1 };
const _hoisted_5$3 = {
  key: 1,
  class: "ozn-select__multiselect-container"
};
const _hoisted_6$3 = {
  key: 0,
  class: "ozn-select__error-container"
};
const _hoisted_7$3 = {
  key: 2,
  class: "ozn-select__select-container"
};
const _hoisted_8$3 = {
  key: 0,
  class: "ozn-select__error-container"
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_form_multi_select = resolveComponent("form-multi-select");
  const _component_FormSelectOption = resolveComponent("FormSelectOption");
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    _ctx.type === "dropdown" || _ctx.readonly ? (openBlock(), createElementBlock("div", _hoisted_2$8, [
      !_ctx.readonly ? (openBlock(), createElementBlock("span", _hoisted_3$6, toDisplayString(_ctx.inputVal), 1)) : createCommentVNode("", true),
      _ctx.readonly ? (openBlock(), createElementBlock("span", _hoisted_4$5, toDisplayString(Array.isArray(_ctx.inputVal) ? _ctx.inputVal.join(", ") : _ctx.inputVal.toString()), 1)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    ["multi-select", "select", "tag"].includes(_ctx.optionType) ? (openBlock(), createElementBlock("div", _hoisted_5$3, [
      renderSlot(_ctx.$slots, "multi-select", {
        data: _ctx.inputVal,
        label: _ctx.label,
        options: _ctx.parsedOptions,
        actions: { emitTag: _ctx.emitTag, emitSelect: _ctx.emitSelect }
      }, () => [
        createVNode(_component_form_multi_select, {
          modelValue: _ctx.inputVal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.inputVal = $event),
          class: normalizeClass({ "ozn-select--error": _ctx.error.state }),
          options: _ctx.parsedOptions,
          "input-label": _ctx.label,
          "hide-selected": true,
          multiple: ["multi-select", "tag"].includes(_ctx.optionType),
          taggable: ["tag"].includes(_ctx.optionType),
          label: _ctx.parsedOptions.length > 0 ? typeof _ctx.parsedOptions[0] === "object" ? "label" : "" : "",
          "track-by": ["multi-select", "tag"].includes(_ctx.optionType) ? "label" : "",
          "show-labels": ["multi-select"].includes(_ctx.optionType),
          "close-on-select": ["select", "tag"].includes(_ctx.optionType),
          disabled: _ctx.readonly,
          placeholder: _ctx.placeholder,
          onTag: _cache[1] || (_cache[1] = (l, v) => _ctx.emitTag(l, v, _ctx.inputVal)),
          onSelect: _ctx.emitSelect,
          onRemove: _ctx.emitRemove,
          onClipboard: _ctx.emitClip
        }, null, 8, ["modelValue", "class", "options", "input-label", "multiple", "taggable", "label", "track-by", "show-labels", "close-on-select", "disabled", "placeholder", "onSelect", "onRemove", "onClipboard"])
      ]),
      _ctx.error.state && _ctx.error.message ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
        createElementVNode("span", null, toDisplayString(_ctx.error.message), 1)
      ])) : createCommentVNode("", true)
    ])) : (openBlock(), createElementBlock("div", _hoisted_7$3, [
      createElementVNode("div", {
        class: normalizeClass(["ozn-select__options-container", { "ozn-select__options-container--dropdown": _ctx.type === "dropdown", visible: _ctx.type === "dropdown" ? _ctx.show : true, "ozn-select--error": _ctx.error.state }])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.parsedOptions, (option, i2) => {
          return openBlock(), createBlock(_component_FormSelectOption, {
            key: `option-${i2}-${_ctx.guid}`,
            modelValue: _ctx.inputVal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.inputVal = $event),
            label: option.label,
            data: option.value,
            type: _ctx.optionType,
            readonly: _ctx.readonly,
            onSelect: _ctx.emitSelect
          }, null, 8, ["modelValue", "label", "data", "type", "readonly", "onSelect"]);
        }), 128))
      ], 2),
      _ctx.error.state && _ctx.error.message ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
        createElementVNode("span", null, toDisplayString(_ctx.error.message), 1)
      ])) : createCommentVNode("", true)
    ]))
  ]);
}
var FormSelect$1 = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$6]]);
FormSelect$1.install = (Vue) => {
  Vue.component(FormSelect$1.name, FormSelect$1);
};
const _sfc_main$6 = defineComponent({
  name: "FormUnknownField",
  props: {
    label: {
      type: String,
      default: "unknown"
    },
    baseType: {
      type: String,
      default: "unknown"
    },
    debug: {
      type: Boolean,
      default: false
    }
  }
});
const _hoisted_1$9 = { class: "ozn-unknown-field" };
const _hoisted_2$7 = {
  key: 0,
  class: "field-error warn"
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$9, [
    _ctx.debug ? (openBlock(), createElementBlock("span", _hoisted_2$7, toDisplayString(`DEBUG: The field type ${_ctx.baseType} for field ${_ctx.label} ${_ctx.baseType && _ctx.baseType !== "unknown" ? "has no input defined" : "could not be asserted"}, and will not be displayed unless a model is passed to the editor instance`), 1)) : createCommentVNode("", true)
  ]);
}
var FormUnknownField$1 = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$5]]);
FormUnknownField$1.install = (Vue) => {
  Vue.component(FormUnknownField$1.name, FormUnknownField$1);
};
var FormInputs = {
  FormBase: _sfc_main$f,
  FormDateRangePicker: FormDateRangePicker$1,
  FormInput: FormInput$1,
  FormMultiSelect,
  FormSelect: FormSelect$1,
  FormSelectOption,
  FormUnknownField: FormUnknownField$1
};
EntryItem.install = (Vue) => {
  Vue.component(EntryItem.name, EntryItem);
};
function validate(binding) {
  if (typeof binding.value !== "function") {
    console.warn("[Vue-click-outside:] provided expression", binding.expression, "is not a function.");
    return false;
  }
  return true;
}
function isPopup(popupItem, elements) {
  if (!popupItem || !elements)
    return false;
  for (let i2 = 0, len = elements.length; i2 < len; i2++) {
    try {
      if (popupItem.contains(elements[i2])) {
        return true;
      }
      if (elements[i2].contains(popupItem)) {
        return false;
      }
    } catch (e2) {
      return false;
    }
  }
  return false;
}
function isServer$1(vNode) {
  return typeof vNode.componentInstance !== "undefined" && vNode.componentInstance.$isServer;
}
const ClickOutside = {
  beforeMount: function(el, binding, vNode) {
    if (!validate(binding))
      return;
    function handler(e2) {
      if (!binding.instance)
        return;
      const elements = e2.path || e2.composedPath && e2.composedPath();
      elements && elements.length > 0 && elements.unshift(e2.target);
      if (el.contains(e2.target) || isPopup(binding.instance.popupItem, elements))
        return;
      el.__vueClickOutside__.callback(e2);
    }
    el.__vueClickOutside__ = {
      handler,
      callback: binding.value
    };
    const clickHandler = "ontouchstart" in document.documentElement ? "touchstart" : "click";
    !isServer$1(vNode) && document.addEventListener(clickHandler, handler);
  },
  updated: function(el, binding) {
    if (validate(binding))
      el.__vueClickOutside__.callback = binding.value;
  },
  unmounted: function(el, binding, vNode) {
    const clickHandler = "ontouchstart" in document.documentElement ? "touchstart" : "click";
    !isServer$1(vNode) && el.__vueClickOutside__ && document.removeEventListener(clickHandler, el.__vueClickOutside__.handler);
    delete el.__vueClickOutside__;
  }
};
const _hoisted_1$8 = {
  version: "1.1",
  id: "Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 32 32",
  "enable-background": "new 0 0 32 32",
  "xml:space": "preserve"
};
const _hoisted_2$6 = /* @__PURE__ */ createElementVNode("g", null, [
  /* @__PURE__ */ createElementVNode("polygon", { points: "28.3,23.2 16,10.9 3.7,23.2 2.3,21.8 16,8.1 29.7,21.8 	" })
], -1);
const _hoisted_3$5 = [
  _hoisted_2$6
];
function render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$8, _hoisted_3$5);
}
const _hoisted_1$7 = {
  version: "1.1",
  id: "Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 32 32",
  "enable-background": "new 0 0 32 32",
  "xml:space": "preserve"
};
const _hoisted_2$5 = /* @__PURE__ */ createElementVNode("g", null, [
  /* @__PURE__ */ createElementVNode("polygon", { points: "16,23.9 2.3,10.2 3.7,8.8 16,21.1 28.3,8.8 29.7,10.2 	" })
], -1);
const _hoisted_3$4 = [
  _hoisted_2$5
];
function render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$7, _hoisted_3$4);
}
const _hoisted_1$6 = {
  width: "13px",
  height: "12px",
  viewBox: "0 0 13 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$4 = /* @__PURE__ */ createElementVNode("title", null, "search", -1);
const _hoisted_3$3 = /* @__PURE__ */ createElementVNode("g", {
  id: "icon-search",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    id: "search",
    class: "vue-contentful-utils__icon-search",
    fill: "currentColor",
    d: "M4.5,0 C6.98528137,0 9,2.01471863 9,4.5 C9,5.44721218 8.70734374,6.32607082 8.20751944,7.05108772 L12.3535534,11.1464466 L11.6464466,11.8535534 L7.5513178,7.80751621 C6.74931319,8.54776707 5.67746892,9 4.5,9 C2.01471863,9 0,6.98528137 0,4.5 C0,2.01471863 2.01471863,0 4.5,0 Z M4.5,1 C2.56700338,1 1,2.56700338 1,4.5 C1,6.43299662 2.56700338,8 4.5,8 C6.43299662,8 8,6.43299662 8,4.5 C8,2.56700338 6.43299662,1 4.5,1 Z",
    "fill-rule": "nonzero"
  })
], -1);
const _hoisted_4$4 = [
  _hoisted_2$4,
  _hoisted_3$3
];
function render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$6, _hoisted_4$4);
}
const _hoisted_1$5 = {
  width: "11px",
  height: "9px",
  viewBox: "0 0 11 11",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$3 = /* @__PURE__ */ createStaticVNode('<title>icon/add-alt</title><g class="vue-contentful-utils__icon-shape vue-contentful-utils__icon-add"><line x1="7.5" y1="2.5" x2="7.5" y2="8.5" id="Line" stroke="currentColor" class="icon-shape--primary" stroke-linecap="square"></line><line x1="4.5" y1="5.5" x2="10.5" y2="5.5" id="Line-2" stroke="currentColor" class="icon-shape--primary" stroke-linecap="square"></line><rect fill="#7EA3FF" class="icon-shape--secondary" x="3" y="0" width="2" height="2"></rect><rect fill="#7EA3FF" class="icon-shape--secondary" x="1" y="3" width="1" height="1"></rect></g>', 2);
const _hoisted_4$3 = [
  _hoisted_2$3
];
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$5, _hoisted_4$3);
}
function useListActions(buffer, { config: config2, request: request2, itemConfig, filterConfig, groupBy = null, paginate = 0 }, emit) {
  const list = isReactiveBuffer(buffer) ? buffer.view : buffer;
  const state = reactive({
    groupdataObjects: {},
    rawQuery: null,
    get filterQuery() {
      return this.rawQuery || "";
    },
    set filterQuery(query) {
      if (query && query.length > (this.rawQuery || "").length) {
        this.rawQuery = query;
        this.intermediate = this.applyFilters(this.entries);
      } else {
        this.rawQuery = query;
        this.intermediate = this.applyFilters(this.entries);
        this.resetIfDiff(list.value);
      }
    },
    sortPath: ["sys", "updated_at"],
    get list() {
      return [...list.value];
    },
    intermediate: list.value,
    get entries() {
      return this.intermediate || [];
    },
    get dict() {
      return Object.fromEntries((list.value || []).map((i2) => {
        var _a;
        return [(_a = i2 == null ? void 0 : i2.sys) == null ? void 0 : _a.id, i2];
      }));
    },
    set entries(value) {
      this.intermediate = this.applyFilters(value);
    },
    get chunkCount() {
      var _a;
      const length = isReactiveBuffer(buffer) ? ((_a = buffer.ledger.value.get()) == null ? void 0 : _a.length) || 0 : this.intermediate.length;
      return paginate > 0 ? Math.round(length / paginate) : 1;
    },
    getChunk(i2) {
      return this.intermediate ? this.intermediate.slice(i2 * paginate, paginate ? i2 * paginate + paginate : this.intermediate.length) : [];
    },
    applyFilters(value) {
      const values = config2.unique === false ? applyFilter(this.filterQuery, value) : applyFilter(this.filterQuery, uniqById(value));
      return _.sortBy(values, this.sortPath);
    },
    tick() {
      this.entries = [...this.intermediate];
    },
    reset() {
      this.entries = list.value;
    },
    resetIfDiff(values = list.value) {
      const int = values.filter((f2) => this.entries.findIndex((e2) => {
        var _a;
        return ((_a = e2.sys) == null ? void 0 : _a.id) === (f2.sys ? f2.sys.id : f2) && (!e2.sys ? 0 : Object.keys(e2.sys).length) === (!f2.sys ? 0 : Object.keys(f2.sys).length);
      }) < 0);
      if (int.length > 0 || values.length > 0 && this.entries.length <= 0)
        this.reset();
    },
    replace(entries) {
      if (isReactiveBuffer(buffer)) {
        buffer.resolved.value = entries;
      } else {
        list.value = entries;
      }
    },
    add(value, uniq = true) {
      var _a;
      if (Array.isArray(value)) {
        if (isReactiveBuffer(buffer)) {
          buffer.ledger.value.set(value.map((v) => {
            var _a2;
            return (_a2 = v.sys) == null ? void 0 : _a2.id;
          }), uniq);
          buffer.resolved.value = value.concat(buffer.resolved.value);
        } else {
          list.value = value.concat(list.value);
        }
      } else {
        if (isReactiveBuffer(buffer)) {
          buffer.ledger.value.set((_a = value.sys) == null ? void 0 : _a.id, uniq);
          buffer.resolved.value.unshift(value);
        } else {
          list.value.unshift(value);
        }
      }
    },
    update(index2, value) {
      if (isReactiveBuffer(buffer)) {
        buffer.resolved.value[index2] = value;
      } else {
        list.value[index2] = value;
      }
    },
    remove(value, index2, array) {
      if (isReactiveBuffer(buffer)) {
        const i2 = buffer.resolved.value.findIndex((e2) => e2.sys.id === value.sys.id);
        buffer.resolved.value.splice(i2, 1);
      } else {
        const i2 = list.value.findIndex((e2) => e2.sys.id === value.sys.id);
        list.value.splice(i2, 1);
      }
    }
  });
  const paginationHandler = reactive({
    get: (i2) => {
      if (config2.buffer.offload) {
        if (!isReactiveBuffer(buffer))
          console.warn("offload prop is set on the list, but no reactive buffer was passed. make sure to pass the entire buffer provided by useEntryActions to useListActions. The list will be unable to render properly as offloaded entries cannot be resolved");
        if (!request2)
          console.warn("No valid request handler was passed to useListActions. The list will be unable to render properly as offloaded entries cannot be resolved");
        if (isReactiveBuffer(buffer) && request2) {
          const val = buffer.ledger.value.chunkAt(i2, paginate);
          return state.filterQuery ? state.entries : val.map((e2) => state.dict[e2.id] || { sys: { id: e2.id, loading: true } });
        }
      } else {
        const val = state.getChunk(i2);
        if (Array.isArray(val) && val.length <= 0) {
          paginationHandler.set(0);
          return state.getChunk(0);
        }
        return val;
      }
    },
    count: computed(() => state.chunkCount),
    current: ref(0),
    currentPage: computed(() => {
      const i2 = paginationHandler.current;
      if (config2.buffer.offload) {
        if (!isReactiveBuffer(buffer))
          console.warn("offload prop is set on the list, but no reactive buffer was passed. make sure to pass the entire buffer provided by useEntryActions to useListActions. The list will be unable to render properly as offloaded entries cannot be resolved");
        if (!request2)
          console.warn("No valid request handler was passed to useListActions. The list will be unable to render properly as offloaded entries cannot be resolved");
        if (isReactiveBuffer(buffer) && request2) {
          const val = buffer.ledger.value.chunkAt(i2, paginate);
          return state.filterQuery ? state.entries : val.map((e2) => state.dict[e2.id] || { sys: { id: e2.id, loading: true } });
        } else {
          const val = state.getChunk(i2);
          if (Array.isArray(val) && val.length <= 0) {
            paginationHandler.set(0);
            return state.getChunk(0);
          }
          return val;
        }
      } else {
        const val = state.getChunk(i2);
        if (Array.isArray(val) && val.length <= 0) {
          paginationHandler.set(0);
          return state.getChunk(0);
        }
        return val;
      }
    }),
    setAt: Date.now(),
    set: (index2, force = false) => {
      if (index2 < 0 || index2 !== 0 && index2 > state.chunkCount - 1)
        return;
      paginationHandler.current = index2;
      if (config2.buffer.offload) {
        if (isReactiveBuffer(buffer) && request2) {
          const val = buffer.ledger.value.chunkAround(index2, paginate, config2.buffer.size);
          buffer.resolve.value(val);
          buffer.ledger.value.cleanAround(index2, paginate, config2.buffer.size);
        }
      }
      if (force)
        paginationHandler.setAt = Date.now();
    }
  });
  function uniqById(value) {
    return value.filter((f2, i2, a3) => a3.findIndex((n) => n.sys.id === f2.sys.id) === i2);
  }
  state.applyFilters = state.applyFilters.bind(state);
  state.getChunk = state.getChunk.bind(state);
  watch(() => list.value, () => {
    state.resetIfDiff(list.value);
  });
  function updateList(selection) {
    Promise.all(selection.items.map(updateEntry)).then((done) => {
    }).catch(console.error);
  }
  function updateEntry(entry) {
    return new Promise((resolve, reject) => {
      const index2 = isReactiveBuffer(buffer) ? buffer.resolved.value.findIndex((r) => {
        var _a;
        return ((_a = r.sys) == null ? void 0 : _a.id) === entry.sys.id;
      }) : list.value.findIndex((o) => {
        var _a;
        return ((_a = o.sys) == null ? void 0 : _a.id) === entry.sys.id;
      });
      if (index2 < 0 || config2.unique === false) {
        state.add(entry, config2.unique);
        resolve();
      } else {
        state.update(index2, entry);
        emit("update", [entry]);
        resolve();
      }
    });
  }
  async function addToList(payload) {
    const items = Array.isArray(payload) ? payload : [payload];
    if (!config2.replace) {
      await Promise.all(items.map(updateEntry));
    } else {
      state.replace(items.concat(list.value));
    }
    try {
      emit("update:modelValue", config2.unique === false ? state.list : uniqById(state.list));
    } catch (e2) {
      console.warn("useListAction | Failed to emit update:modelValue", e2);
    }
  }
  function removeFromList(payload, options = { delete: false }) {
    const items = Array.isArray(payload) ? payload : [payload];
    items.forEach((v, i2, a3) => state.remove(v, i2, a3));
    try {
      emit("update:modelValue", config2.unique === false ? state.list : uniqById(state.list));
    } catch (e2) {
      console.warn("useListAction | Failed to emit update:modelValue", e2);
    }
  }
  function applyFilter(query, target) {
    return target.filter((f2) => !!grep.contents(f2, query, 2));
  }
  function setFilter(query) {
    state.filterQuery = query;
  }
  function setSort(path) {
    state.sortPath = typeof path === "string" ? path.split(".") : path;
    state.tick();
  }
  return {
    ...toRefs(state),
    pagination: paginationHandler,
    applyFilter,
    setFilter,
    setSort,
    addToList,
    removeFromList,
    updateList
  };
}
function useResize() {
  const windowWidth = ref(window.innerWidth);
  const windowHeight = ref(window.innerHeight);
  function onResize() {
    windowWidth.value = window.innerWidth;
    windowHeight.value = window.innerHeight;
  }
  onBeforeUnmount(() => {
    window.removeEventListener("resize", onResize);
  });
  return {
    windowWidth,
    windowHeight,
    onResize
  };
}
OznButton.install = (Vue) => {
  Vue.component(OznButton.name, OznButton);
};
const DEFAULT_LABELS = {
  first: "&laquo;",
  prev: "&lsaquo;",
  next: "&rsaquo;",
  last: "&raquo;"
};
var PaginationLayout = /* @__PURE__ */ ((PaginationLayout2) => {
  PaginationLayout2["Default"] = "fullwidth";
  PaginationLayout2["Fullwidth"] = "fullwidth";
  PaginationLayout2["Minimal"] = "minimal";
  PaginationLayout2["Select"] = "select";
  return PaginationLayout2;
})(PaginationLayout || {});
var OznPagination_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$5 = defineComponent({
  name: "OznPagination",
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    labels: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: String,
      default: PaginationLayout.Fullwidth
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, { emit }) {
    const input = ref(null);
    const state = reactive({
      labels: computed(() => {
        return { ...DEFAULT_LABELS, ...props.labels };
      }),
      items: computed(() => {
        let valPrev = props.modelValue > 0 ? props.modelValue - 1 : 0;
        let valNext = props.modelValue < props.count ? props.modelValue + 1 : props.count;
        let dotsBefore = valPrev > 1 ? 1 : null;
        let dotsAfter = valNext < props.count - 1 ? props.count - 1 : null;
        let output = [];
        for (let i2 = 0; i2 <= props.count; i2 += 1) {
          if ([0, props.count, props.modelValue, valPrev, valNext, dotsBefore, dotsAfter].includes(i2)) {
            output.push({
              label: i2,
              active: props.modelValue === i2,
              dots: [dotsBefore, dotsAfter].includes(i2)
            });
          }
        }
        return output;
      }),
      includesFirst: computed(() => props.modelValue === 0),
      includesLast: computed(() => props.modelValue === props.count)
    });
    onMounted(() => {
      if (props.modelValue > props.count) {
        emit("update:modelValue", props.count);
      }
    });
    watch(() => props.modelValue, () => {
      emit("change");
    });
    function handleClickFirst() {
      if (!state.includesFirst) {
        emit("update:modelValue", 0);
      }
    }
    function handleClickLast() {
      if (!state.includesLast) {
        emit("update:modelValue", props.count);
      }
    }
    function handleClickNext() {
      if (!state.includesLast) {
        emit("update:modelValue", props.modelValue + 1);
      }
    }
    function handleClickPrevious() {
      if (!state.includesFirst) {
        emit("update:modelValue", props.modelValue - 1);
      }
    }
    function handleGoto(page) {
      emit("update:modelValue", page);
      if (input.value !== null) {
        input.value.value = null;
      }
    }
    return {
      ...toRefs(state),
      input,
      handleClickFirst,
      handleClickLast,
      handleClickNext,
      handleClickPrevious,
      handleGoto,
      PaginationLayout,
      decodeString
    };
  }
});
const _hoisted_1$4 = {
  key: 0,
  class: "ozn-pagination ozn-pagination--minimal ozn-pagination--align-right"
};
const _hoisted_2$2 = ["disabled"];
const _hoisted_3$2 = { class: "ozn-pagination__item ozn-pagination__mini-counter" };
const _hoisted_4$2 = { class: "ozn-pagination__mini-counter--content" };
const _hoisted_5$2 = ["disabled"];
const _hoisted_6$2 = {
  key: 1,
  class: "ozn-pagination ozn-pagination--fullwidth"
};
const _hoisted_7$2 = ["disabled"];
const _hoisted_8$2 = ["disabled"];
const _hoisted_9$2 = ["max"];
const _hoisted_10$2 = ["onClick"];
const _hoisted_11$2 = ["disabled"];
const _hoisted_12$2 = ["disabled"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    _ctx.layout === _ctx.PaginationLayout.Minimal ? (openBlock(), createElementBlock("ul", _hoisted_1$4, [
      _ctx.labels.prev ? (openBlock(), createElementBlock("li", {
        key: 0,
        class: normalizeClass(["ozn-pagination__item ozn-pagination--align-left", `${_ctx.includesFirst ? "ozn-pagination__item--disabled" : ""}`])
      }, [
        createElementVNode("button", {
          class: normalizeClass(["ozn-pagination__btn", `${_ctx.includesFirst ? "ozn-pagination__btn--disabled" : ""}`]),
          disabled: _ctx.includesFirst,
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClickPrevious && _ctx.handleClickPrevious(...args))
        }, toDisplayString(_ctx.decodeString(_ctx.labels.prev)), 11, _hoisted_2$2)
      ], 2)) : createCommentVNode("", true),
      createElementVNode("li", _hoisted_3$2, [
        createElementVNode("span", _hoisted_4$2, toDisplayString(_ctx.modelValue + 1) + " / " + toDisplayString(_ctx.count + 1), 1)
      ]),
      _ctx.labels.next ? (openBlock(), createElementBlock("li", {
        key: 1,
        class: normalizeClass(["ozn-pagination__item ozn-pagination--align-right", `${_ctx.includesLast ? "ozn-pagination__item--disabled" : ""}`])
      }, [
        createElementVNode("button", {
          class: normalizeClass(["ozn-pagination__btn", `${_ctx.includesLast ? "ozn-pagination__btn--disabled" : ""}`]),
          disabled: _ctx.includesLast,
          onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleClickNext && _ctx.handleClickNext(...args))
        }, toDisplayString(_ctx.decodeString(_ctx.labels.next)), 11, _hoisted_5$2)
      ], 2)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    _ctx.layout === _ctx.PaginationLayout.Fullwidth ? (openBlock(), createElementBlock("ul", _hoisted_6$2, [
      _ctx.labels.first ? (openBlock(), createElementBlock("li", {
        key: 0,
        class: normalizeClass(["ozn-pagination__item", `${_ctx.includesFirst ? "ozn-pagination__item--disabled" : ""}`])
      }, [
        createElementVNode("button", {
          class: normalizeClass(["ozn-pagination__btn", `${_ctx.includesFirst ? "ozn-pagination__btn--disabled" : ""}`]),
          disabled: _ctx.includesFirst,
          onClick: _cache[2] || (_cache[2] = (...args) => _ctx.handleClickFirst && _ctx.handleClickFirst(...args))
        }, toDisplayString(_ctx.decodeString(_ctx.labels.first)), 11, _hoisted_7$2)
      ], 2)) : createCommentVNode("", true),
      _ctx.labels.prev ? (openBlock(), createElementBlock("li", {
        key: 1,
        class: normalizeClass(["ozn-pagination__item ozn-pagination--align-left", `${_ctx.includesFirst ? "ozn-pagination__item--disabled" : ""}`])
      }, [
        createElementVNode("button", {
          class: normalizeClass(["ozn-pagination__btn", `${_ctx.includesFirst ? "ozn-pagination__btn--disabled" : ""}`]),
          disabled: _ctx.includesFirst,
          onClick: _cache[3] || (_cache[3] = (...args) => _ctx.handleClickPrevious && _ctx.handleClickPrevious(...args))
        }, toDisplayString(_ctx.decodeString(_ctx.labels.prev)), 11, _hoisted_8$2)
      ], 2)) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (page) => {
        return openBlock(), createElementBlock("li", {
          key: page.label,
          class: normalizeClass(["ozn-pagination__item", `${page.active ? "ozn-pagination__item--active" : ""} ${page.disable ? "ozn-pagination__item--disabled" : ""}`])
        }, [
          page.dots ? (openBlock(), createElementBlock("input", {
            key: 0,
            ref_for: true,
            ref: "input",
            class: "ozn-pagination__input",
            type: "number",
            min: "1",
            max: _ctx.count + 1,
            placeholder: "...",
            onChange: _cache[4] || (_cache[4] = ($event) => _ctx.handleGoto($event.target.value - 1))
          }, null, 40, _hoisted_9$2)) : (openBlock(), createElementBlock("button", {
            key: 1,
            class: normalizeClass(["ozn-pagination__link", `${page.active ? "ozn-pagination__link--active" : ""}`]),
            onClick: ($event) => _ctx.handleGoto(page.label)
          }, toDisplayString(page.label + 1), 11, _hoisted_10$2))
        ], 2);
      }), 128)),
      _ctx.labels.next ? (openBlock(), createElementBlock("li", {
        key: 2,
        class: normalizeClass(["ozn-pagination__item ozn-pagination--align-right", `${_ctx.includesLast ? "ozn-pagination__item--disabled" : ""}`])
      }, [
        createElementVNode("button", {
          class: normalizeClass(["ozn-pagination__btn", `${_ctx.includesLast ? "ozn-pagination__btn--disabled" : ""}`]),
          disabled: _ctx.includesLast,
          onClick: _cache[5] || (_cache[5] = (...args) => _ctx.handleClickNext && _ctx.handleClickNext(...args))
        }, toDisplayString(_ctx.decodeString(_ctx.labels.next)), 11, _hoisted_11$2)
      ], 2)) : createCommentVNode("", true),
      _ctx.labels.last ? (openBlock(), createElementBlock("li", {
        key: 3,
        class: normalizeClass(["ozn-pagination__item", `${_ctx.includesLast ? "ozn-pagination__item--disabled" : ""}`])
      }, [
        createElementVNode("button", {
          class: normalizeClass(["ozn-pagination__btn", `${_ctx.includesLast ? "ozn-pagination__btn--disabled" : ""}`]),
          disabled: _ctx.includesLast,
          onClick: _cache[6] || (_cache[6] = (...args) => _ctx.handleClickLast && _ctx.handleClickLast(...args))
        }, toDisplayString(_ctx.decodeString(_ctx.labels.last)), 11, _hoisted_12$2)
      ], 2)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true)
  ], 64);
}
var OznPagination = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$4], ["__scopeId", "data-v-ffd32292"]]);
OznPagination.install = (Vue) => {
  Vue.component(OznPagination.name, OznPagination);
};
Spinner.install = (Vue) => {
  Vue.component(Spinner.name, Spinner);
};
EntrySearch.install = (Vue) => {
  Vue.component(EntrySearch.name, EntrySearch);
};
var EntryList_vue_vue_type_style_index_0_scoped_true_lang = "";
function getTypeDefault(type) {
  switch (type) {
    case FormInputType.String:
      return "";
    case FormInputType.Number:
      return 0;
    case FormInputType.Array:
    case FormInputType.Select:
    case FormInputType.Tag:
      return [];
    case FormInputType.Object:
      return {};
    case FormInputType["Link-list"]:
    case FormInputType.Link:
    case FormInputType.Placeholder:
    case FormInputType.Nullable:
      return null;
    case FormInputType.Boolean:
      return false;
    default:
      return null;
  }
}
const _sfc_main$4 = defineComponent({
  name: "EntryList",
  directives: { ClickOutside },
  components: {
    EntrySearch,
    EntryItem,
    FormSelect: FormSelect$1,
    OznButton,
    OznPagination,
    Spinner,
    IconChevronUp: render$3,
    IconChevronDown: render$2,
    IconSearch: render$1,
    IconAdd: render
  },
  props: {
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    modelValue: {
      type: Array,
      required: true,
      default: () => []
    },
    store: {
      type: Object,
      default: () => void 0
    },
    contentType: {
      type: String,
      required: true,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    request: {
      type: Object,
      default: () => new RequestHandler()
    },
    config: {
      type: Object,
      default: () => config.DEFAULT_CONFIG
    },
    model: Object,
    itemConfig: {
      type: Object,
      default: () => config.DEFAULT_ITEM_PROPS
    },
    filterConfig: {
      type: Object,
      default: () => config.DEFAULT_FILTER_CONFIG
    },
    columns: {
      type: [Array, Number],
      default: () => [8, 8, 8]
    },
    highlight: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderStyle: {
      type: String,
      default: SpinnerType.Ozone
    },
    groupBy: {
      type: [String, Array, Object],
      default: null
    },
    sortBy: {
      type: [String, Array, Object],
      default: null
    },
    activeGroups: {
      type: Boolean,
      default: false
    },
    query: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    paginate: {
      type: Number,
      default: 50
    },
    paginationLayout: {
      type: String,
      default: PaginationLayout.Minimal
    }
  },
  emits: ["select", "deselect", "remove", "search", "add", "update", "update:modelValue", "update:sortBy"],
  setup(props, { emit }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const loading = ref(false);
    const { windowWidth, onResize } = useResize();
    const { colArray } = useColumns(props.columns);
    const entryListContainer = ref(null);
    const parsedConfig = ref({ ...defaultsDeep(props.config, config.DEFAULT_CONFIG) });
    const parsedItemProps = ref({ ...defaultsDeep(props.itemConfig, config.DEFAULT_ITEM_PROPS), replace: false, lazy: true, actions: { ...parsedConfig.value.actions || {}, ...((_a = props.itemConfig) == null ? void 0 : _a.actions) || {} } });
    const parsedFilterConfig = _.defaultsDeep(props.filterConfig, config.DEFAULT_FILTER_CONFIG);
    const INITIAL_ACTIVE_STATE = { entry: "", model: props.model, diff: { state: false, payload: {} }, validation: { state: true, fields: [] } };
    const active = INITIAL_ACTIVE_STATE;
    const {
      resolve,
      resolveBuffered,
      updateBufferWith,
      clearBuffer,
      buffer,
      save,
      setActive
    } = useEntryActions(
      props.request,
      ref(active),
      emit,
      props.contentType,
      { ...((_c = (_b = parsedConfig.value) == null ? void 0 : _b.buffer) == null ? void 0 : _c.resolve) ? { resolve: parsedConfig.value.buffer.resolve } : {}, ...((_e = (_d = parsedConfig.value) == null ? void 0 : _d.buffer) == null ? void 0 : _e.select) ? { select: parsedConfig.value.buffer.select } : {} },
      ((_f = parsedConfig.value) == null ? void 0 : _f.unique) !== void 0 ? (_g = parsedConfig.value) == null ? void 0 : _g.unique : true
    );
    const {
      entries,
      setFilter,
      applyFilter,
      setSort,
      updateList,
      addToList,
      removeFromList,
      chunkCount,
      getChunk,
      pagination
    } = useListActions(buffer, { ...props, config: parsedConfig.value, itemConfig: parsedItemProps.value, filterConfig: parsedFilterConfig }, emit);
    onMounted(() => {
      if (props.modelValue.length > 0) {
        clearBuffer().then((buffer2) => {
          var _a2, _b2;
          updateBufferWith(props.modelValue, { spliceDiff: true, offload: (_a2 = parsedConfig.value.buffer) == null ? void 0 : _a2.offload, uniq: (_b2 = parsedConfig.value) == null ? void 0 : _b2.unique }).then((buffer3) => {
            pagination.set(0);
          });
        });
      }
      parsedItemProps.value.size = calcSizeBreakpoints(
        entryListContainer.value.clientWidth,
        parsedItemProps.value.breakPoints,
        Size[state.size]
      ) || config.DEFAULT_ITEM_SIZE;
      nextTick(() => {
        window.addEventListener("resize", onResize);
      });
    });
    const state = reactive({
      active,
      searching: false,
      size: computed(() => props.itemConfig.size || config.DEFAULT_ITEM_SIZE),
      filterDropdownActive: false,
      currentTarget: {
        src: entries,
        path: "",
        replace: parsedConfig.value.replace,
        callback: handleSelection,
        type: typeof entries
      },
      searchQueryString: "",
      sortByQuery: computed({
        get: () => props.sortBy || "sys.updated_at",
        set: (value) => {
          emit("update:sortBy", value);
        }
      }),
      fieldKeys: props.modelValue.map((e2) => e2 && typeof e2 === "object" ? Object.keys(e2) : null).flat(1).filter((f2, i2, a3) => !!f2 && f2 !== "sys" && a3.indexOf(f2) === i2).concat(["sys.created_at", "sys.updated_at"])
    });
    const refresh = _.debounce((values) => {
      var _a2, _b2;
      updateBufferWith(values, { spliceDiff: true, offload: (_a2 = parsedConfig.value.buffer) == null ? void 0 : _a2.offload, uniq: (_b2 = parsedConfig.value) == null ? void 0 : _b2.unique }).then(() => {
        pagination.set(pagination.current);
      });
    }, 50);
    watch(
      () => props.itemConfig,
      () => {
        parsedItemProps.value = defaultsDeep(props.itemConfig, config.DEFAULT_ITEM_PROPS);
      },
      { deep: true }
    );
    watch(() => props.query, (value) => {
      state.searchQueryString = value || "";
    });
    watch(() => state.searchQueryString, _.debounce(setFilter, 100));
    watch(() => state.searchQueryString, _.debounce(() => {
      if (entries.value.length <= 0)
        queryRemote().catch((e2) => console.error("searchQueryString: entries length watcher error", e2));
    }, 500));
    watch(() => props.sortBy, setSort);
    watch(() => props.modelValue, refresh, { deep: true });
    watch(() => windowWidth.value, () => {
      parsedItemProps.value.size = calcSizeBreakpoints(
        entryListContainer.value.clientWidth,
        parsedItemProps.value.breakPoints || {},
        Size[state.size]
      ) || config.DEFAULT_ITEM_SIZE;
    });
    function handleSelection({ target, selection }) {
      addToList(selection);
    }
    function get(entry, path = "", def = null) {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
      try {
        if (!entry) {
          throw Error$1("EntryList.get: invalid entry or path argument");
        }
        const e2 = !Array.isArray(entry) && typeof entry === "object" ? entry : entries;
        const pa = arguments.length <= 2 && (Array.isArray(entry) || typeof entry === "string") ? entry : path;
        const p = Array.isArray(pa) ? ((_a2 = parsedConfig.value.fields) == null ? void 0 : _a2.data) && !pa.includes((_b2 = parsedConfig.value.fields) == null ? void 0 : _b2.data) ? [(_c2 = parsedConfig.value.fields) == null ? void 0 : _c2.data].concat(pa) : pa : ((_d2 = parsedConfig.value.fields) == null ? void 0 : _d2.data) && !pa.includes(`.${(_e2 = parsedConfig.value.fields) == null ? void 0 : _e2.data}`) ? `${(_f2 = parsedConfig.value.fields) == null ? void 0 : _f2.data}.${pa}` : pa;
        return !p && e2 ? _.get(e2, ((_g2 = parsedConfig.value.fields) == null ? void 0 : _g2.data) || [], e2) : _.get(e2, p, def);
      } catch (e2) {
        return null;
      }
    }
    async function createItem(e2) {
      var _a2, _b2;
      try {
        if (!((_a2 = parsedConfig.value.actions) == null ? void 0 : _a2.edit)) {
          console.warn("EntryList: list is not editable", parsedConfig.value.actions);
          return Promise.resolve();
        }
        loading.value = true;
        if (!props.request) {
          console.warn("EntryList: list is editable, but does not provide a request prop");
          loading.value = false;
          return;
        }
        if (!props.model) {
          console.warn("EntryList: a model prop, with at least a field type for each field set, is required to create an entry");
          loading.value = false;
          return Promise.resolve();
        }
        if (!props.request.create && !props.request.post)
          console.warn('EntryList: could not create entry, The passed request handler object does not implement a "create" or "post" method');
        const data = Object.fromEntries(Object.keys(props.model).map((k2) => {
          if ((props.model || {})[k2].default === null) {
            return [k2, null];
          }
          return [k2, (props.model || {})[k2].default || getTypeDefault((props.model || {})[k2].type)];
        }));
        const create2 = props.request.create || props.request.post;
        let result;
        if (props.request.create) {
          result = await props.request.create(props.contentType, data);
        } else {
          result = await props.request.post(props.contentType, { endpoint: "create" }, data);
        }
        const { items } = result;
        addToList(items);
        emit("add", {
          items,
          contentType: props.contentType,
          callback: addToList,
          target: state.currentTarget,
          titleField: (_b2 = parsedConfig.value.fields) == null ? void 0 : _b2.title,
          groupBy: props.groupBy
        });
        loading.value = false;
        return Promise.resolve(items);
      } catch (e22) {
        loading.value = false;
        console.error("Entrylist.createItem", e22);
        return Promise.reject(Error$1("Error while creating entry"));
      }
    }
    function searchItems() {
      var _a2;
      if ((_a2 = parsedConfig.value.actions) == null ? void 0 : _a2.edit) {
        state.searching = !state.searching;
        emit("search", state.currentTarget);
      }
    }
    async function removeItem(item) {
      var _a2, _b2, _c2, _d2, _e2;
      if (!((_a2 = parsedConfig.value.actions) == null ? void 0 : _a2.edit) || !((_b2 = parsedConfig.value.actions) == null ? void 0 : _b2.remove)) {
        console.warn("[EntryList:removeItem] Not allowed, enable config.actions.remove");
        return false;
      }
      try {
        loading.value = true;
        if (((_c2 = parsedConfig.value.actions) == null ? void 0 : _c2.allow) && ((_d2 = parsedConfig.value.actions) == null ? void 0 : _d2.allow.delete)) {
          const del = props.request.remove || props.request.delete;
          await del(item.sys.id);
          loading.value = false;
        }
        if ((_e2 = parsedConfig.value.actions) == null ? void 0 : _e2.edit) {
          emit("remove", { target: props.modelValue, callback: removeFromList, items: [item] });
        }
        removeFromList(item);
        loading.value = false;
        return Promise.resolve(true);
      } catch (e2) {
        console.error("error while removing item", e2);
        loading.value = false;
        return Promise.reject(Error$1(e2));
      }
    }
    function makeActive(item, e2) {
      var _a2, _b2;
      if (e2)
        e2.stopPropagation();
      if (((_a2 = parsedConfig.value.actions) == null ? void 0 : _a2.toggle) && (state.active && state.active.entry && state.active && state.active.entry)) {
        if (!!((_b2 = item.sys) == null ? void 0 : _b2.id) && (state.active.entry.sys || {}).id === item.sys.id) {
          setActive(null);
          emit("deselect", item);
        }
      }
      setActive(item);
      emit("select", item);
    }
    function matchQueryToFields(input, model) {
      return Object.keys(model).map((key) => {
        if (!model[key].field)
          return null;
        switch (typeof model[key] === "string" ? model[key] : model[key].type) {
          case FormInputType.String:
            return model[key];
          case FormInputType.Number:
            return /^\d+$/.test(input) ? model[key] : null;
          case FormInputType.Array:
          case FormInputType.Select:
          case FormInputType.Tag:
            return model[key];
          case FormInputType.Object:
            return null;
          case FormInputType["Link-list"]:
          case FormInputType.Link:
            return isUUID(input) ? model[key] : null;
          case FormInputType.Boolean:
            return input && input.toLowerCase() === key.toLowerCase() ? model[key] : null;
          default:
            return null;
        }
      }).filter((f2) => f2 !== null && f2 !== void 0);
    }
    async function queryRemote() {
      var _a2;
      try {
        if (!((_a2 = parsedConfig.value.actions) == null ? void 0 : _a2.remote) || !state.searchQueryString || state.searchQueryString && state.searchQueryString.length <= 1)
          return Promise.resolve(true);
        if (!props.model) {
          console.warn("EntryList.queryRemote | A model prop is required, but none was defined");
          return Promise.reject(false);
        }
        const models = matchQueryToFields(state.searchQueryString, props.model);
        const query = models.map(({ field, type }) => ({ field, method: ["string", "link", "number", "boolean"].includes(type) ? "like" : type === "boolean" ? void 0 : "in", match: type === "boolean" ? (state.searchQueryString || "")[0] === "!" ? false : true : state.searchQueryString }));
        await load(query, { skip: 0, query: { any: true } });
        return Promise.resolve(true);
      } catch (e2) {
        console.error("Query remote error", e2);
        return Promise.reject(e2);
      }
    }
    async function load(query, config2) {
      try {
        if (!props.request)
          throw Error$1("A request handler is required, but none was defined.");
        if (props.request && (!props.request.load && !props.request.get))
          throw Error$1('A dedicated "load" or "get" method is required on the request handler for remote loading, but none was defined.');
        const loader = props.request.load || props.request.get;
        loading.value = true;
        const cf = config2 || { skip: entries.length };
        const q2 = query || [];
        const result = await loader(props.contentType, q2, cf);
        addToList(result.items);
        loading.value = false;
      } catch (e2) {
        loading.value = false;
        console.error("EntryList.load", e2);
      }
    }
    function isActiveItem(id) {
      const e2 = state.active && state.active.entry && typeof state.active.entry === "object" ? state.active.entry !== "" ? state.active.entry : null : null;
      return e2 && id && e2.sys && e2.sys.id === id;
    }
    function deactivateListItem(id) {
      setActive("");
    }
    function toggleFilterDropdown() {
      const dropdown = document.getElementById("dropdown--spin");
      dropdown == null ? void 0 : dropdown.children[1].classList.add("ozn-icon--spin-animation");
      setTimeout(function() {
        dropdown == null ? void 0 : dropdown.children[1].classList.remove("ozn-icon--spin-animation");
        state.filterDropdownActive = !state.filterDropdownActive;
      }, 299);
    }
    function hideFilterDropdown() {
      state.filterDropdownActive = false;
    }
    return {
      ...toRefs(state),
      isLoading: computed(() => props.loading || loading.value),
      windowWidth,
      entryListContainer,
      buffer,
      entries,
      pagination,
      entryCount: computed(() => entries.value.length),
      parsedConfig,
      parsedItemProps,
      get,
      load,
      queryRemote,
      setSort,
      removeItem,
      createItem,
      searchItems,
      makeActive,
      isActiveItem,
      deactivateListItem,
      toggleFilterDropdown,
      hideFilterDropdown,
      titleCase,
      Size,
      colArray,
      popupItem: null,
      DEFAULT_ITEM_SIZE: config.DEFAULT_ITEM_SIZE
    };
  },
  mounted() {
    this.popupItem = this.$el;
  }
});
const _withScopeId$1 = (n) => (pushScopeId("data-v-6b43f896"), n = n(), popScopeId(), n);
const _hoisted_1$3 = {
  key: 0,
  class: "ozn-entry-list__filter-container"
};
const _hoisted_2$1 = { class: "filters" };
const _hoisted_3$1 = { class: "ozn-search ozn-search--flat" };
const _hoisted_4$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("span", { class: "dropdown__label" }, "Filters", -1));
const _hoisted_5$1 = {
  key: 0,
  class: "dropdown"
};
const _hoisted_6$1 = {
  key: 1,
  class: "ozn-entry-list__label"
};
const _hoisted_7$1 = { class: "list-label" };
const _hoisted_8$1 = {
  key: 0,
  style: { "font-size": "70%", "font-weight": "400", "text-transform": "none" }
};
const _hoisted_9$1 = { class: "label" };
const _hoisted_10$1 = { class: "label" };
const _hoisted_11$1 = ["data-index", "onClick"];
const _hoisted_12$1 = { class: "ozn-entry-item__header--left" };
const _hoisted_13$1 = {
  key: 0,
  class: "ozn-entry-item__meta"
};
const _hoisted_14$1 = { class: "ozn-entry-item__title" };
const _hoisted_15 = { class: "entry-description description" };
const _hoisted_16 = {
  key: 3,
  class: "ozn-entry-list__placeholder"
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  const _component_EntrySearch = resolveComponent("EntrySearch");
  const _component_spinner = resolveComponent("spinner");
  const _component_IconSearch = resolveComponent("IconSearch");
  const _component_IconChevronDown = resolveComponent("IconChevronDown");
  const _component_IconChevronUp = resolveComponent("IconChevronUp");
  const _component_FormSelect = resolveComponent("FormSelect");
  const _component_OznButton = resolveComponent("OznButton");
  const _component_IconAdd = resolveComponent("IconAdd");
  const _component_ozn_pagination = resolveComponent("ozn-pagination");
  const _component_EntryItem = resolveComponent("EntryItem");
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", {
    key: _ctx.id,
    ref: "entryListContainer",
    class: normalizeClass(["ozn-entry-list", [
      `col-xs-${_ctx.colArray[0]}`,
      `col-sm-${_ctx.colArray[1]}`,
      `col-lg-${_ctx.colArray[2]}`
    ]])
  }, [
    createVNode(_component_EntrySearch, {
      "content-type": _ctx.contentType,
      request: _ctx.request,
      show: _ctx.searching,
      model: _ctx.model,
      config: { ..._ctx.parsedConfig, requests: { ..._ctx.parsedConfig.requests || {}, limit: _ctx.paginate } },
      size: "medium",
      payload: _ctx.store ? _ctx.store.values : void 0,
      onSelection: _ctx.currentTarget.callback,
      onClose: _cache[0] || (_cache[0] = ($event) => _ctx.searching = false)
    }, null, 8, ["content-type", "request", "show", "model", "config", "payload", "onSelection"]),
    ((_a = _ctx.parsedConfig.actions) == null ? void 0 : _a.search) && _ctx.filterConfig.show ? (openBlock(), createElementBlock("div", _hoisted_1$3, [
      createElementVNode("div", _hoisted_2$1, [
        createElementVNode("div", _hoisted_3$1, [
          createVNode(_component_spinner, {
            show: _ctx.isLoading,
            type: _ctx.loaderStyle,
            scale: 0.6
          }, null, 8, ["show", "type", "scale"]),
          withDirectives(createVNode(_component_IconSearch, {
            class: "ozn-icon ozn-icon--prepend",
            alt: "filter"
          }, null, 512), [
            [vShow, !_ctx.isLoading]
          ]),
          withDirectives(createElementVNode("input", {
            ref: "entryFilterInput",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.searchQueryString = $event),
            class: "ozn-search__input",
            placeholder: "Search properties..."
          }, null, 512), [
            [vModelText, _ctx.searchQueryString]
          ])
        ]),
        createElementVNode("div", {
          id: "dropdown--spin",
          class: "btn--dropdown",
          onClick: _cache[2] || (_cache[2] = (...args) => _ctx.toggleFilterDropdown && _ctx.toggleFilterDropdown(...args))
        }, [
          _hoisted_4$1,
          !_ctx.filterDropdownActive ? (openBlock(), createBlock(_component_IconChevronDown, {
            key: 0,
            class: "ozn-icon ozn-icon--prepend",
            alt: "expand"
          })) : (openBlock(), createBlock(_component_IconChevronUp, {
            key: 1,
            class: "ozn-icon ozn-icon--prepend",
            alt: "collapse"
          }))
        ])
      ]),
      _ctx.filterDropdownActive ? withDirectives((openBlock(), createElementBlock("div", _hoisted_5$1, [
        createVNode(_component_FormSelect, {
          modelValue: _ctx.sortByQuery,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.sortByQuery = $event),
          type: "select",
          label: "Sort by",
          class: "ozn-select",
          options: _ctx.fieldKeys,
          onSelect: _ctx.setSort
        }, null, 8, ["modelValue", "options", "onSelect"])
      ])), [
        [_directive_click_outside, _ctx.hideFilterDropdown]
      ]) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    _ctx.label ? (openBlock(), createElementBlock("h4", _hoisted_6$1, [
      createElementVNode("span", _hoisted_7$1, toDisplayString(_ctx.label), 1),
      ((_b = _ctx.parsedConfig.debug) == null ? void 0 : _b.verbose) ? (openBlock(), createElementBlock("span", _hoisted_8$1, "\xA0(" + toDisplayString(_ctx.contentType) + ")", 1)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["ozn-entry-list__actions ozn-entry-list__actions-header", `ozn-entry-list__actions--${_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE}`])
    }, [
      renderSlot(_ctx.$slots, "actions-header", {
        loading: _ctx.isLoading,
        loader: _ctx.loaderStyle,
        config: _ctx.parsedConfig,
        actions: {
          setSort: _ctx.setSort,
          removeItem: _ctx.removeItem,
          createItem: _ctx.createItem,
          searchItems: _ctx.searchItems,
          makeActive: _ctx.makeActive,
          pagination: _ctx.pagination
        }
      }, () => {
        var _a2, _b2, _c, _d;
        return [
          !_ctx.readonly && _ctx.contentType && ((_a2 = _ctx.parsedConfig.actions) == null ? void 0 : _a2.edit) && ((_b2 = _ctx.parsedConfig.actions) == null ? void 0 : _b2.add) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["entry-action", `entry-action--${_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE}`])
          }, [
            createVNode(_component_OznButton, {
              "full-width": "",
              class: "entry-action__btn",
              "loader-style": _ctx.loaderStyle,
              loading: _ctx.isLoading,
              onClick: _ctx.searchItems
            }, {
              default: withCtx(() => {
                var _a3;
                return [
                  withDirectives(createVNode(_component_IconSearch, {
                    class: "ozn-icon ozn-icon--prepend",
                    alt: "search existing"
                  }, null, 512), [
                    [vShow, !_ctx.isLoading]
                  ]),
                  createElementVNode("span", _hoisted_9$1, toDisplayString(_ctx.isLoading ? "..." : (_a3 = _ctx.parsedConfig.labels) == null ? void 0 : _a3.search) + " " + toDisplayString(_ctx.titleCase(_ctx.contentType.replace("_", " "))), 1)
                ];
              }),
              _: 1
            }, 8, ["loader-style", "loading", "onClick"])
          ], 2)) : createCommentVNode("", true),
          !_ctx.readonly && _ctx.contentType && ((_c = _ctx.parsedConfig.actions) == null ? void 0 : _c.edit) && ((_d = _ctx.parsedConfig.actions) == null ? void 0 : _d.create) ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["entry-action", `entry-action--${_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE}`])
          }, [
            createVNode(_component_OznButton, {
              "full-width": "",
              class: "entry-action__btn",
              "loader-style": _ctx.loaderStyle,
              loading: _ctx.isLoading,
              onClick: _ctx.createItem
            }, {
              default: withCtx(() => {
                var _a3;
                return [
                  withDirectives(createVNode(_component_IconAdd, {
                    class: "ozn-icon ozn-icon--prepend",
                    alt: "add"
                  }, null, 512), [
                    [vShow, !_ctx.isLoading]
                  ]),
                  createElementVNode("span", _hoisted_10$1, toDisplayString(_ctx.isLoading ? "..." : (_a3 = _ctx.parsedConfig.labels) == null ? void 0 : _a3.add) + " " + toDisplayString(_ctx.titleCase(_ctx.contentType.replace("_", " "))), 1)
                ];
              }),
              _: 1
            }, 8, ["loader-style", "loading", "onClick"])
          ], 2)) : createCommentVNode("", true)
        ];
      }, true)
    ], 2),
    renderSlot(_ctx.$slots, "pagination", {
      options: _ctx.pagination,
      loading: _ctx.isLoading
    }, () => [
      _ctx.pagination.count > 1 ? (openBlock(), createBlock(_component_ozn_pagination, {
        key: 0,
        modelValue: _ctx.pagination.current,
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event) => _ctx.pagination.current = $event),
          _cache[5] || (_cache[5] = (index2) => _ctx.pagination.set(index2))
        ],
        layout: _ctx.paginationLayout,
        count: _ctx.searchQueryString ? Math.ceil(_ctx.entries.length / _ctx.paginate) - 1 : _ctx.pagination.count - 1
      }, null, 8, ["modelValue", "layout", "count"])) : createCommentVNode("", true)
    ], true),
    !_ctx.groupBy && _ctx.pagination.count >= 0 ? (openBlock(), createElementBlock("ul", {
      key: 2,
      class: normalizeClass(["ozn-entry-list__list list-entries", `ozn-entry-list__list--${_ctx.Size[_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE]}`])
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.pagination.currentPage, (item, i2) => {
        return openBlock(), createElementBlock("li", {
          key: `list-item-${_ctx.get(item, "sys.id", item)}${i2}${_ctx.pagination.setAt}`,
          "data-index": i2,
          class: normalizeClass(["ozn-entry-list__list-item", `${_ctx.Size[_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE]} ${_ctx.isActiveItem(_ctx.get(item, "sys.id", item)) && "active"}`]),
          onClick: ($event) => _ctx.makeActive(item, $event)
        }, [
          renderSlot(_ctx.$slots, "list-item", {
            entry: item,
            index: i2,
            loading: _ctx.isLoading
          }, () => [
            (openBlock(), createBlock(_component_EntryItem, {
              key: `entry-item-${_ctx.get(item, "sys.id", item)}${i2}${_ctx.get(item, "sys.updated_at")}${i2}${_ctx.entryCount}`,
              index: i2,
              "content-type": _ctx.contentType,
              readonly: _ctx.readonly,
              active: _ctx.isActiveItem(_ctx.get(item, "sys.id", item)),
              entry: item,
              config: _ctx.parsedItemProps,
              size: _ctx.Size[_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE],
              highlight: _ctx.highlight.includes(_ctx.get(item, "sys.id", item)),
              request: _ctx.request,
              draggable: _ctx.parsedItemProps.draggable,
              onActivate: ($event) => _ctx.makeActive(item),
              onDeactivate: _ctx.deactivateListItem,
              onRemove: _ctx.removeItem
            }, {
              header: withCtx(({ entry, actions }) => [
                !_ctx.get(entry, "sys.loading") ? renderSlot(_ctx.$slots, "list-entry-item-header", {
                  key: 0,
                  entry,
                  actions
                }, () => {
                  var _a2, _b2, _c;
                  return [
                    createElementVNode("div", _hoisted_12$1, [
                      ((_a2 = _ctx.parsedConfig.debug) == null ? void 0 : _a2.sys) ? (openBlock(), createElementBlock("span", _hoisted_13$1, toDisplayString(entry.sys.id), 1)) : createCommentVNode("", true),
                      createElementVNode("h3", _hoisted_14$1, toDisplayString(((_b2 = _ctx.parsedConfig.fields) == null ? void 0 : _b2.title) ? _ctx.get(entry, (_c = _ctx.parsedConfig.fields) == null ? void 0 : _c.title) : actions.getTitle(entry)), 1)
                    ])
                  ];
                }, true) : createCommentVNode("", true)
              ]),
              content: withCtx(({ entry, activity, actions }) => [
                !_ctx.get(entry, "sys.loading") ? renderSlot(_ctx.$slots, "list-entry-item-content", {
                  key: 0,
                  entry,
                  actions,
                  activity
                }, void 0, true) : createCommentVNode("", true)
              ]),
              editor: withCtx(({ entry, activity, actions }) => [
                !_ctx.get(entry, "sys.loading") ? renderSlot(_ctx.$slots, "list-entry-item-editor", {
                  key: 0,
                  entry,
                  actions,
                  activity
                }, void 0, true) : createCommentVNode("", true)
              ]),
              "entry-overlay-header": withCtx(({ entry, activity, actions }) => [
                !_ctx.get(entry, "sys.loading") ? renderSlot(_ctx.$slots, "list-entry-item-overlay-header", {
                  key: 0,
                  entry,
                  actions,
                  activity
                }, void 0, true) : createCommentVNode("", true)
              ]),
              "entry-overlay-content": withCtx(({ entry, actions }) => [
                !_ctx.get(entry, "sys.loading") ? renderSlot(_ctx.$slots, "list-entry-item-overlay-content", {
                  key: 0,
                  entry,
                  actions
                }, () => [
                  createElementVNode("p", _hoisted_15, toDisplayString(actions.getDescription(entry)), 1),
                  createTextVNode("] ")
                ], true) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["index", "content-type", "readonly", "active", "entry", "config", "size", "highlight", "request", "draggable", "onActivate", "onDeactivate", "onRemove"]))
          ], true)
        ], 10, _hoisted_11$1);
      }), 128))
    ], 2)) : (openBlock(), createElementBlock("div", _hoisted_16, [
      createElementVNode("span", null, toDisplayString(_ctx.config.placeholder || `No entries for "${_ctx.contentType}" have been found.`), 1)
    ])),
    createElementVNode("div", {
      class: normalizeClass(["ozn-entry-list__actions ozn-entry-list__actions-footer", `ozn-entry-list__actions--${_ctx.parsedItemProps.size || _ctx.DEFAULT_ITEM_SIZE}`])
    }, [
      renderSlot(_ctx.$slots, "actions-footer", {
        loading: _ctx.isLoading,
        loader: _ctx.loaderStyle,
        config: _ctx.parsedConfig,
        actions: {
          setSort: _ctx.setSort,
          removeItem: _ctx.removeItem,
          createItem: _ctx.createItem,
          searchItems: _ctx.searchItems,
          makeActive: _ctx.makeActive,
          pagination: _ctx.pagination
        }
      }, () => {
        var _a2;
        return [
          ((_a2 = _ctx.parsedConfig.actions) == null ? void 0 : _a2.remote) ? withDirectives((openBlock(), createBlock(_component_OznButton, {
            key: 0,
            "loader-style": _ctx.loaderStyle,
            label: _ctx.entries.length > 0 ? "Load more" : "Load",
            "full-width": "",
            flat: "",
            onClick: _ctx.load
          }, null, 8, ["loader-style", "label", "onClick"])), [
            [vShow, _ctx.pagination.current === _ctx.pagination.count - 1]
          ]) : createCommentVNode("", true)
        ];
      }, true)
    ], 2)
  ], 2);
}
var EntryList = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$3], ["__scopeId", "data-v-6b43f896"]]);
EntryList.install = (Vue) => {
  Vue.component(EntryList.name, EntryList);
};
const { FormDateRangePicker, FormInput, FormSelect, FormUnknownField } = FormInputs;
const formComponents = {
  [FormInputTypeKeys.String]: FormInput,
  [FormInputTypeKeys.Number]: FormInput,
  [FormInputTypeKeys.Object]: FormUnknownField,
  [FormInputTypeKeys.Boolean]: FormSelect,
  [FormInputTypeKeys.Toggle]: FormSelect,
  [FormInputTypeKeys.Array]: FormSelect,
  [FormInputTypeKeys["Multi-select"]]: FormSelect,
  [FormInputTypeKeys.Select]: FormSelect,
  [FormInputTypeKeys.Tag]: FormSelect,
  [FormInputTypeKeys.Link]: EntryItem,
  [FormInputTypeKeys["Link-list"]]: EntryList,
  [FormInputTypeKeys.Placeholder]: FormUnknownField,
  [FormInputTypeKeys.Null]: FormUnknownField
};
const DEFAULT_EDITOR_LABELS = {
  save: "Save",
  delete: "Delete",
  saving: "Saving...",
  deleting: "Deleting..",
  loading: "Loading...",
  error: "Error",
  refresh: "Refresh"
};
const DEFAULT_CONFIG = {
  autosave: false,
  readonly: false,
  labels: DEFAULT_EDITOR_LABELS,
  header: {
    fixed: true,
    position: 0,
    offset: 0
  },
  debug: {
    sys: false,
    verbose: false
  }
};
var EntryEditor_vue_vue_type_style_index_0_scoped_true_lang = "";
function createDefaultRequestHandler() {
  return new RequestHandler({ service: void 0 });
}
const _sfc_main$3 = defineComponent({
  name: "EntryEditor",
  components: { EntrySearch, OznButton },
  props: {
    id: {
      type: String,
      default: Date.now().toString(32)
    },
    contentType: {
      type: String,
      default: null
    },
    entry: {
      type: Object,
      default: () => ({}),
      required: true
    },
    config: {
      type: Object,
      default: () => DEFAULT_CONFIG
    },
    shouldResolve: {
      type: Boolean,
      default: false
    },
    loaderStyle: {
      type: String,
      default: SpinnerType.Ozone
    },
    model: Object,
    request: {
      type: Object,
      default: createDefaultRequestHandler
    },
    columns: {
      type: [Array, Number],
      default: () => [8, 8, 8]
    }
  },
  emits: ["active", "save", "delete"],
  setup(props, { emit }) {
    const { colArray } = useColumns(props.columns);
    const state = reactive({
      updateQueue: ref({})
    });
    const entries = reactive({
      active: DEFAULT_ENTRY_STATE,
      refs: {}
    });
    const { active, refs } = toRefs(entries);
    const {
      resolve,
      save,
      remove,
      processing
    } = useEntryActions(props.request, active, emit);
    async function setActive(payload, prev) {
      var _a, _b;
      try {
        let entry = payload;
        if (props.shouldResolve) {
          if (!((_a = entry.sys) == null ? void 0 : _a.id))
            throw Error$1("EntryEditor.setActive: props.shouldResolve was set, but the passed entry prop did not have a sys.id to resolve it by");
          console.log("EntryEditor resolving entry...", entry.sys.id);
          const resolved = await props.request.get("id", [entry.sys.id]).then(({ items }) => items ? items[0] : void 0);
          entry = _.mergeWith(entry, resolved, (src, res) => {
            if (res && isUUID(src) && typeof res === "object")
              return res;
            else if (res && typeof src === "object" && typeof res === "object")
              return _.merge(src, res);
            return src;
          });
        }
        const model = assertModel(props.model, entry || props.entry);
        const e2 = { ...DEFAULT_ENTRY_STATE, entry: entry || props.entry, model };
        if (!validateEntry(e2.entry)) {
          throw Error$1("EntryEditor.setActive: Invalid entry");
        }
        e2.entry = applyModelDefaults(e2.entry, model);
        entries.active = e2;
        if (isEntry(e2.entry)) {
          entries.refs[e2.entry.sys.id] = e2;
        } else {
          entries.refs[e2.entry] = e2;
        }
        emit("active", e2);
      } catch (e2) {
        console.error(`setActive Error | payload<${typeof payload}> id ${(_b = payload == null ? void 0 : payload.sys) == null ? void 0 : _b.id}`, e2);
      }
    }
    watch(() => props.entry, setActive);
    onMounted(() => {
      if (!entries.active || entries.active && !isEntry(entries.active.entry))
        void setActive(props.entry);
    });
    const activeFieldModel = computed(() => {
      if (!entries.active || entries.active && !entries.active.model)
        return [{ field: "placeholder", type: "placeholder", required: false, validator: () => true }];
      return entries.active.model;
    });
    const searchState = reactive({
      contentType: null,
      active: false,
      limit: void 0,
      callback: (target, selection) => {
      }
    });
    const activity = reactive({
      entry: {
        label: "Save",
        validating: false,
        saving: false,
        confirmDelete: false,
        deleting: false,
        error: false
      }
    });
    return {
      editorConfig: _.defaultsDeep(props.config, DEFAULT_CONFIG),
      ...toRefs(state),
      activity,
      search: toRefs(searchState),
      processing,
      entries,
      activeFieldModel,
      formComponents,
      DEFAULT_VALIDATOR: () => true,
      DEFAULT_EDITOR_LABELS,
      actions: {
        save: async () => {
          var _a, _b, _c, _d;
          try {
            activity.entry.label = ((_b = (_a = props.config) == null ? void 0 : _a.labels) == null ? void 0 : _b.saving) || DEFAULT_EDITOR_LABELS.saving;
            activity.entry.saving = true;
            await save();
          } catch (e2) {
            activity.entry.error = e2;
            console.error("Error saving entry: ", e2);
          } finally {
            activity.entry.label = ((_d = (_c = props.config) == null ? void 0 : _c.labels) == null ? void 0 : _d.save) || DEFAULT_EDITOR_LABELS.save;
            activity.entry.saving = false;
          }
        },
        remove: async () => {
          var _a, _b, _c, _d;
          try {
            activity.entry.label = ((_b = (_a = props.config) == null ? void 0 : _a.labels) == null ? void 0 : _b.deleting) || DEFAULT_EDITOR_LABELS.deleting;
            activity.entry.deleting = true;
            await remove();
          } catch (e2) {
            activity.entry.error = e2;
            console.error("Error deleting entry: ", e2);
          } finally {
            activity.entry.label = ((_d = (_c = props.config) == null ? void 0 : _c.labels) == null ? void 0 : _d.save) || DEFAULT_EDITOR_LABELS.save;
            activity.entry.deleting = false;
          }
        },
        resolve,
        item: {
          replace: (field, type, value) => {
            searchState.contentType = type;
            searchState.active = true;
            searchState.limit = 1;
            searchState.callback = ({ target, selection: [selected] }) => {
              searchState.active = false;
              searchState.limit = void 0;
              entries.active.entry[field] = isEntry(selected) ? selected : selected;
            };
          }
        },
        list: {
          add: (field, selection) => {
          },
          remove: (field, item, index2) => {
            if (Array.isArray(entries.active.entry[field])) {
              const i2 = index2 !== void 0 ? index2 : entries.active.entry[field].findIndex((f2) => f2 === item);
              if (i2 > 0)
                entries.active.entry[field].splice(i2, 1);
            } else {
              entries.active.entry[field] = null;
            }
          },
          select: (field, selection) => {
          }
        }
      },
      error: Error$1(state),
      colArray,
      dateFormatter(dateString) {
        if (!dateString)
          return "unknown";
        const dt = new Date(dateString);
        return `${dt.getDay()}-${dt.getMonth()}-${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}`;
      }
    };
  }
});
const _withScopeId = (n) => (pushScopeId("data-v-5b7f47b6"), n = n(), popScopeId(), n);
const _hoisted_1$2 = ["id"];
const _hoisted_2 = { class: "actions-prepend" };
const _hoisted_3 = {
  key: 0,
  class: "ozn-entry-editor__modified-datetime"
};
const _hoisted_4 = { class: "actions-primary" };
const _hoisted_5 = { class: "action__delete--container" };
const _hoisted_6 = {
  key: 1,
  class: "action__delete--confirm"
};
const _hoisted_7 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", { class: "action__delete--confirm-message" }, [
  /* @__PURE__ */ createTextVNode("This action is "),
  /* @__PURE__ */ createElementVNode("u", null, "irreversible"),
  /* @__PURE__ */ createTextVNode(", are you sure?")
], -1));
const _hoisted_8 = { class: "actions-append" };
const _hoisted_9 = { class: "ozn-entry-editor__content" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = {
  key: 1,
  class: "ozn-entry-editor__input-component-slot--container"
};
const _hoisted_12 = { key: 2 };
const _hoisted_13 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "...", -1));
const _hoisted_14 = [
  _hoisted_13
];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c;
  const _component_EntrySearch = resolveComponent("EntrySearch");
  const _component_OznButton = resolveComponent("OznButton");
  return openBlock(), createElementBlock("div", {
    id: `editor-${_ctx.id}`,
    class: normalizeClass(["ozn-entry-editor", [
      `col-xs-${_ctx.colArray[0]}`,
      `col-sm-${_ctx.colArray[1]}`,
      `col-lg-${_ctx.colArray[2]}`
    ]])
  }, [
    createVNode(_component_EntrySearch, {
      "content-type": (_a = _ctx.search.contentType) == null ? void 0 : _a.value,
      request: _ctx.request,
      model: _ctx.model,
      show: _ctx.search.active.value,
      "select-limit": (_b = _ctx.search.limit) == null ? void 0 : _b.value,
      size: "medium",
      onSelection: (_c = _ctx.search.callback) == null ? void 0 : _c.value,
      onClose: _cache[0] || (_cache[0] = ($event) => _ctx.search.active.value = false)
    }, null, 8, ["content-type", "request", "model", "show", "select-limit", "onSelection"]),
    createElementVNode("div", {
      class: normalizeClass(["ozn-entry-editor__actions", _ctx.editorConfig.header.fixed ? "sticky top--flush" : ""])
    }, [
      createElementVNode("div", _hoisted_2, [
        renderSlot(_ctx.$slots, "header-prepend", {}, () => {
          var _a2, _b2, _c2, _d;
          return [
            _ctx.entries.active.entry && typeof _ctx.entries.active.entry === "object" ? (openBlock(), createElementBlock("span", _hoisted_3, "Last modified on " + toDisplayString(_ctx.dateFormatter((_a2 = _ctx.entries.active.entry.sys) == null ? void 0 : _a2.updated_at)) + " " + toDisplayString(((_b2 = _ctx.entries.active.entry.sys) == null ? void 0 : _b2.updated_by) && ((_c2 = _ctx.entries.active.entry.sys) == null ? void 0 : _c2.updated_by) !== "not_set" ? `by ${(_d = _ctx.entries.active.entry.sys) == null ? void 0 : _d.updated_by}` : ""), 1)) : createCommentVNode("", true)
          ];
        }, true)
      ]),
      createElementVNode("div", _hoisted_4, [
        renderSlot(_ctx.$slots, "header", {
          actions: _ctx.actions,
          activity: _ctx.activity,
          config: _ctx.config,
          loading: _ctx.processing,
          loaderStyle: _ctx.loaderStyle
        }, () => {
          var _a2, _b2, _c2, _d;
          return [
            createVNode(_component_OznButton, {
              label: _ctx.activity.entry.label,
              size: "medium",
              loading: _ctx.processing,
              "loader-style": _ctx.loaderStyle,
              onClick: _ctx.actions.save
            }, null, 8, ["label", "loading", "loader-style", "onClick"]),
            createElementVNode("div", _hoisted_5, [
              !_ctx.activity.entry.confirmDelete ? (openBlock(), createBlock(_component_OznButton, {
                key: 0,
                label: ((_b2 = (_a2 = _ctx.config) == null ? void 0 : _a2.labels) == null ? void 0 : _b2.delete) || _ctx.DEFAULT_EDITOR_LABELS.delete,
                class: "delete--btn ozn-btn--flat ozn-btn--danger",
                size: "medium",
                loading: _ctx.processing,
                "loader-style": _ctx.loaderStyle,
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.activity.entry.confirmDelete = true)
              }, null, 8, ["label", "loading", "loader-style"])) : (openBlock(), createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                createVNode(_component_OznButton, {
                  label: ((_d = (_c2 = _ctx.config) == null ? void 0 : _c2.labels) == null ? void 0 : _d.delete) || _ctx.DEFAULT_EDITOR_LABELS.delete,
                  class: "ozn-btn--flat ozn-btn--danger",
                  size: "medium",
                  loading: _ctx.processing,
                  "loader-style": _ctx.loaderStyle,
                  onClick: _ctx.actions.remove
                }, null, 8, ["label", "loading", "loader-style", "onClick"]),
                createVNode(_component_OznButton, {
                  label: "Cancel",
                  class: "ozn-btn--flat ozn-btn--info",
                  size: "medium",
                  loading: _ctx.processing,
                  "loader-style": _ctx.loaderStyle,
                  onClick: _cache[2] || (_cache[2] = ($event) => _ctx.activity.entry.confirmDelete = false)
                }, null, 8, ["loading", "loader-style"])
              ]))
            ])
          ];
        }, true)
      ]),
      createElementVNode("div", _hoisted_8, [
        renderSlot(_ctx.$slots, "header-append", {}, void 0, true)
      ])
    ], 2),
    createElementVNode("div", _hoisted_9, [
      renderSlot(_ctx.$slots, "default", {
        actions: _ctx.actions,
        active: _ctx.entries.active,
        entries: _ctx.entries
      }, () => [
        Object.keys(_ctx.entries.active.entry).length <= 0 ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString(typeof _ctx.entries.active.entry === "string" ? `Resolving ${_ctx.entries.active.entry}...` : "Nothing to edit..."), 1)) : _ctx.entries.active.model ? (openBlock(), createElementBlock("div", _hoisted_11, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(Object.keys(_ctx.entries.active.entry), (field, i2) => {
            return renderSlot(_ctx.$slots, `${field}`, {
              data: _ctx.entries.active.entry[field],
              model: _ctx.activeFieldModel[field],
              actions: _ctx.actions,
              active: _ctx.entries.active,
              entries: _ctx.entries,
              field
            }, () => [
              field !== "sys" && _ctx.activeFieldModel[field] ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.formComponents[(_ctx.activeFieldModel[field] || "placeholder").type]), {
                key: `input-${field}-${i2}-${typeof _ctx.entries.active.entry === "string" ? _ctx.entries.active.entry : _ctx.entries.active.entry.sys.id}_${_ctx.id}`,
                modelValue: _ctx.entries.active.entry[field],
                "onUpdate:modelValue": ($event) => _ctx.entries.active.entry[field] = $event,
                for: "editor",
                readonly: _ctx.activeFieldModel[field].readonly,
                "aria-readonly": _ctx.activeFieldModel[field].readonly,
                "loader-style": _ctx.loaderStyle,
                request: _ctx.request,
                entry: _ctx.entries.active.entry[field],
                debug: _ctx.config.debug.verbose,
                store: _ctx.activeFieldModel[field].options,
                type: _ctx.activeFieldModel[field].type,
                model: _ctx.activeFieldModel[field].model,
                taggable: _ctx.activeFieldModel[field].type === "tag",
                options: _ctx.activeFieldModel[field].options,
                label: _ctx.activeFieldModel[field].label,
                config: _ctx.activeFieldModel[field].config,
                "item-config": _ctx.activeFieldModel[field].config,
                "content-type": _ctx.activeFieldModel[field].contentType,
                "base-type": _ctx.activeFieldModel[field].type,
                validator: _ctx.activeFieldModel[field].validator || _ctx.DEFAULT_VALIDATOR,
                class: "ozn-entry-editor__field-input",
                onAdd: (e2) => _ctx.actions.list.add(field, e2),
                onRemove: (e2) => _ctx.actions.list.remove(field, e2),
                onSelect: _ctx.actions.list.select,
                onReplace: (t2, v) => _ctx.actions.item.replace(field, t2, v)
              }, null, 40, ["modelValue", "onUpdate:modelValue", "readonly", "aria-readonly", "loader-style", "request", "entry", "debug", "store", "type", "model", "taggable", "options", "label", "config", "item-config", "content-type", "base-type", "validator", "onAdd", "onRemove", "onSelect", "onReplace"])) : createCommentVNode("", true)
            ], true);
          }), 256))
        ])) : (openBlock(), createElementBlock("div", _hoisted_12, _hoisted_14))
      ], true)
    ])
  ], 10, _hoisted_1$2);
}
var EntryEditor = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$2], ["__scopeId", "data-v-5b7f47b6"]]);
EntryEditor.install = (Vue) => {
  Vue.component(EntryEditor.name, EntryEditor);
};
const _sfc_main$2 = defineComponent({
  name: "Label",
  props: {
    value: {
      type: String,
      default: "",
      required: true
    },
    height: {
      type: String,
      default: "20px"
    },
    width: {
      type: String,
      default: "70px"
    },
    fontSize: {
      type: String,
      default: "13px"
    },
    color: {
      type: String,
      default: "#7ea3ff"
    },
    backgroundColor: {
      type: String
    },
    borderColor: {
      type: String
    }
  }
});
const _hoisted_1$1 = { class: "ozn-label-container__label" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: "ozn-label",
    class: "ozn-label-container",
    style: normalizeStyle({
      width: _ctx.width,
      height: _ctx.height,
      "font-size": _ctx.fontSize,
      color: _ctx.color,
      "border-color": _ctx.borderColor ? _ctx.borderColor : _ctx.color,
      "background-color": _ctx.backgroundColor ? _ctx.backgroundColor : _ctx.color + "54"
    })
  }, [
    createElementVNode("span", _hoisted_1$1, toDisplayString(_ctx.value), 1)
  ], 4);
}
var Label = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$1]]);
Label.install = (Vue) => {
  Vue.component(Label.name, Label);
};
let lastTime = 0;
const prefixes = "webkit moz ms o".split(" ");
let requestAnimationFrame;
let cancelAnimationFrame;
const isServer = typeof window === "undefined";
if (isServer) {
  requestAnimationFrame = function() {
    return;
  };
  cancelAnimationFrame = function() {
    return;
  };
} else {
  requestAnimationFrame = window.requestAnimationFrame;
  cancelAnimationFrame = window.cancelAnimationFrame;
  let prefix;
  for (let i2 = 0; i2 < prefixes.length; i2++) {
    if (requestAnimationFrame && cancelAnimationFrame) {
      break;
    }
    prefix = prefixes[i2];
    requestAnimationFrame = requestAnimationFrame || window[prefix + "RequestAnimationFrame"];
    cancelAnimationFrame = cancelAnimationFrame || window[prefix + "CancelAnimationFrame"] || window[prefix + "CancelRequestAnimationFrame"];
  }
  if (!requestAnimationFrame || !cancelAnimationFrame) {
    requestAnimationFrame = function(callback) {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
    cancelAnimationFrame = function(id) {
      window.clearTimeout(id);
    };
  }
}
const _sfc_main$1 = defineComponent({
  name: "OznCountTo",
  props: {
    startVal: {
      type: Number,
      required: false,
      default: 0
    },
    endVal: {
      type: Number,
      required: false,
      default: 2017
    },
    duration: {
      type: Number,
      required: false,
      default: 3e3
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    decimals: {
      type: Number,
      required: false,
      default: 0,
      validator(value) {
        return value >= 0;
      }
    },
    decimal: {
      type: String,
      required: false,
      default: "."
    },
    separator: {
      type: String,
      required: false,
      default: ","
    },
    prefix: {
      type: String,
      required: false,
      default: ""
    },
    suffix: {
      type: String,
      required: false,
      default: ""
    },
    useEasing: {
      type: Boolean,
      required: false,
      default: true
    },
    easingFn: {
      type: Function,
      default(t2, b2, c2, d3) {
        return c2 * (-Math.pow(2, -10 * t2 / d3) + 1) * 1024 / 1023 + b2;
      }
    }
  },
  emits: ["callback", "mountedCallback"],
  setup(props, { emit }) {
    const countDown = computed(() => props.startVal > props.endVal);
    const displayValue = ref(formatNumber(props.startVal));
    const localStartVal = ref(props.startVal);
    const printVal = ref(null);
    const paused = ref(false);
    const localDuration = ref(props.duration);
    const startTime = ref(null);
    const localTimestamp = ref(null);
    const remaining = ref(null);
    const rAF = ref(null);
    watch(() => props.startVal, () => {
      if (props.autoplay)
        start();
    });
    watch(() => props.endVal, () => {
      if (props.autoplay)
        start();
    });
    onMounted(() => {
      if (props.autoplay)
        start();
      emit("mountedCallback");
    });
    onUnmounted(() => {
      cancelAnimationFrame(rAF.value);
    });
    function start() {
      localStartVal.value = props.startVal;
      startTime.value = null;
      localDuration.value = props.duration;
      paused.value = false;
      rAF.value = requestAnimationFrame(count);
    }
    function count(timestamp) {
      if (!startTime.value)
        startTime.value = timestamp;
      localTimestamp.value = timestamp;
      const progress = timestamp - startTime.value;
      remaining.value = localDuration.value - progress;
      if (props.useEasing) {
        if (countDown.value) {
          printVal.value = localStartVal.value - props.easingFn(progress, 0, localStartVal.value - props.endVal, localDuration.value);
        } else {
          printVal.value = props.easingFn(progress, localStartVal.value, props.endVal - localStartVal.value, localDuration.value);
        }
      } else {
        if (countDown.value) {
          printVal.value = localStartVal.value - (localStartVal.value - props.endVal) * (progress / localDuration.value);
        } else {
          printVal.value = localStartVal.value + (props.endVal - localStartVal.value) * (progress / localDuration.value);
        }
      }
      if (countDown.value) {
        printVal.value = printVal.value < props.endVal ? props.endVal : printVal.value;
      } else {
        printVal.value = printVal.value > props.endVal ? props.endVal : printVal.value;
      }
      displayValue.value = formatNumber(printVal.value);
      if (progress < localDuration.value) {
        rAF.value = requestAnimationFrame(count);
      } else {
        emit("callback");
      }
    }
    function isNumber2(val) {
      return !isNaN(parseFloat(val));
    }
    function formatNumber(num) {
      num = num.toFixed(props.decimals);
      num += "";
      const x2 = num.split(".");
      let x1 = x2[0];
      const x22 = x2.length > 1 ? props.decimal + x2[1] : "";
      const rgx = /(\d+)(\d{3})/;
      if (props.separator && !isNumber2(props.separator)) {
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + props.separator + "$2");
        }
      }
      return props.prefix + x1 + x22 + props.suffix;
    }
    return {
      displayValue
    };
  }
});
const _hoisted_1 = {
  id: "ozn-count-to",
  class: "ozn-count-to"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1, toDisplayString(_ctx.displayValue), 1);
}
var OznCountTo = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render]]);
OznCountTo.install = (Vue) => {
  Vue.component(OznCountTo.name, OznCountTo);
};
const _sfc_main = {
  name: "Row",
  componentName: "Row",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    gutter: Number,
    type: String,
    justify: {
      type: String,
      default: "start"
    },
    align: {
      type: String,
      default: "top"
    }
  },
  computed: {
    style() {
      const ret = {};
      if (this.gutter) {
        ret.marginLeft = `-${this.gutter / 2}px`;
        ret.marginRight = ret.marginLeft;
      }
      return ret;
    }
  },
  render(h3) {
    return h3(this.tag, {
      class: [
        "row",
        this.justify !== "start" ? `is-justify-${this.justify}` : "",
        this.align !== "top" ? `is-align-${this.align}` : "",
        { "row--flex": this.type === "flex" }
      ],
      style: this.style
    }, this.$slots.default);
  }
};
_sfc_main.install = (Vue) => {
  Vue.component(_sfc_main.name, _sfc_main);
};
const components = {
  OznButton,
  Avatar,
  Column: _sfc_main$k,
  EntryEditor,
  EntryItem,
  EntryList,
  EntrySearch,
  FormBase: _sfc_main$f,
  FormDateRangePicker: FormDateRangePicker$1,
  FormInput: FormInput$1,
  FormMultiSelect,
  FormSelect: FormSelect$1,
  FormSelectOption,
  FormUnknownField: FormUnknownField$1,
  Label,
  OznCountTo,
  OznPagination,
  Row: _sfc_main,
  Spinner
};
function install(Vue) {
  for (const component in components) {
    Vue.component(component, components[component]);
  }
}
var index = { install };
export { EntryStatus, RequestHandler, Shape, Size, index as default, generateUUID };
